webpackJsonp([32],{

/***/ 1010:
/***/ (function(module, exports) {

module.exports = "\n<my-app-sidenav [hidden]=\"!logedin\"></my-app-sidenav>\n\n<section [hidden]=\"!logedin\" id=\"page-container\" class=\"app-page-container\">\n  <my-app-header ></my-app-header>\n\n  <div class=\"app-content-wrapper\">\n    <div class=\"app-content\">\n      <div class=\"full-height\">\n        <router-outlet></router-outlet>\n      </div>\n    </div>\n\n    <my-app-footer></my-app-footer>\n  </div>\n</section>\n\n<!--<my-app-customizer></my-app-customizer>-->\n\n<my-app-search-overlay></my-app-search-overlay>\n"

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

module.exports = "<section [ngBusy]=\"{busy: busy, message: 'Loading...', backdrop: true, delay: 200, minDuration: 600}\">\n\n<div class=\"article-title-style\" >Pick Month to download the A3PL service transaction</div>\n<div md-dialog-content style=\"padding-bottom: 20px;\"  [ngBusy]=\"{busy: uploading, message: 'Uploading...', backdrop: true, delay: 200, minDuration: 600}\">\n  <div class=\"row\" style=\"margin: 5px; \">\n<div class=\"col-md-3\">\n\n    <mat-form-field class=\"full-width\">\n\n        <mat-select  placeholder=\"Select Year\" [(ngModel)]=\"selectedYear\">\n            <mat-option  *ngFor=\"let year of years\" (onSelectionChange)=\"getWorkOrderTemplatesOnSelectionChange(year)\" [value]=\"year\">\n                <span >{{year}}</span>\n            </mat-option>\n        </mat-select>\n    </mat-form-field>\n\n\n\n</div>\n      <div  class=\"col-md-3\">\n          <mat-form-field class=\"full-width\">\n\n              <mat-select  placeholder=\"Select Month\" [(ngModel)]=\"selectedMonth\">\n                  <mat-option  *ngFor=\"let month of months\" [value]=\"month\">\n                      <span >{{month.name}}</span>\n                  </mat-option>\n              </mat-select>\n          </mat-form-field>\n      </div>\n\n  </div>\n  <div class=\"row\">\n      <div class=\"col-md-4\" style=\"width: 18rem;\">\n      \n        </div>\n    <div class=\"col-md-4\">\n        <div class=\"card text-center\" style=\"width: 18rem;\">\n          <div class=\"card-body\">\n            <h5 class=\"card-title\">Transaction Logs</h5>\n            <p class=\"card-text\">Download CSV by clicking button Below</p>\n            <button mat-button color=\"primary\" (click)=\"downloadTemplate()\">Download</button>\n          </div>\n        </div>\n    </div>\n    <div class=\"col-md-4\" style=\"width: 18rem;\">\n    </div>\n  </div>\n</div>\n<div md-dialog-actions>\n    <div class=\"row\" style=\"margin-top: 10px\">\n    <!-- <div class=\"col-md-2\">\n    <button mat-button color=\"primary\" class=\"btn-w-md\">Need Help?</button>\n    </div> -->\n    <div class=\"col-md-6\" ></div>\n    <div class=\"col-md-6\">\n    <!-- <button mat-button (click)=\"dialogRef.close('Option 1')\">Cancel</button> -->\n    <button mat-raised-button (click)=\"close()\" style=\"float: right;\">Close</button>\n    </div>\n    </div>\n  </div> \n\n</section>\n"

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

module.exports = "<section  style=\"min-width: 700px\">\n    <div>\n\n       <div class=\"article-title-style\" style=\"color: #ef5350\">Failure!\n\n       </div>\n\n       <div>\n           <p style=\"font-size: larger\">{{message}}</p>\n       </div>\n\n   </div>\n    <div md-dialog-actions>\n        <div class=\"row\">\n\n            <div class=\"col-md-7\"></div>\n            <div class=\"col-md-5\">\n                <button mat-raised-button   class=\"btn-w-md\" (click)=\"close('cross')\">OK</button>\n                <button mat-raised-button class=\"btn-w-md\"  (click)=\"close('option-0')\"  style=\"background-color: #ff7519;color: white; float: right\" >Manage License</button>\n\n            </div>\n        </div>\n    </div>\n\n</section>\n"

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

module.exports = "<section [ngBusy]=\"{busy: busy, message: 'Loading...', backdrop: true, delay: 200, minDuration: 600}\">\n\n  <div class=\"row  max-height-500\" *ngIf=\"!customer.isCreateFlag\" style=\"min-width: 500px\">\n\n    <!--  <div class=\"col-md-4\">\n        <img style=\"width: 100%;\" src=\"{{getImageURL()}}\" >\n      </div> -->\n    <div class=\"col-md-12\" >\n      <table style=\"width:100%;\" class=\"mdl-data-table\">\n        <tbody *ngIf=\"!customer.isEditFlag\">\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Company Name</td>\n            <td>{{customer.customerName}}</td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Contact Person</td>\n            <td>{{customer.contactPerson}}</td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">SalesRep Code</td>\n            <td>{{customer.salePersonCode}}</td>\n          </tr>\n<!--          <tr>-->\n<!--            <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Tax Group</td>-->\n<!--            <td>{{customer.taxGroup}}</td>-->\n<!--          </tr>-->\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Payment term</td>\n            <td>{{customer.customerCompany}}</td>\n          </tr>\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Payment Currency*</td>\n            <td>{{customer.paymentCurrency}}</td>\n          </tr>\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Payment processing</td>\n            <td>{{customer.paymentProcessing}}</td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Discount Tag</td>\n            <td>{{customer.discountTag}}</td>\n          </tr>\n          <!-- <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Customer Status</td>\n            <td>{{customer.customerStatus}}</td>\n          </tr> -->\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Email</td>\n            <td>{{customer.email}}</td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Phone</td>\n            <td>{{customer.customerPhone}}</td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">ERP Customer ID</td>\n            <td>{{customer.erpCustomerId}}</td>\n          </tr>\n<!--          <tr>-->\n<!--            <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Group Code</td>-->\n<!--            <td>{{customer.groupCode}}</td>-->\n<!--          </tr>-->\n<!--          <tr>-->\n<!--            <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Shipping Cost</td>-->\n<!--            <td>{{customer.shippingCost}}</td>-->\n<!--          </tr>-->\n          <tr>\n              <td class=\"mdl-data-table__cell--non-numeric\" colspan=\"2\"><b>Shipping Services</b></td>\n          </tr>\n          <tr *ngFor=\"let ship of customer.shippingService\">\n              <td class=\"mdl-data-table__cell--non-numeric\">{{getNameFromId(ship.shippingServiceId)}}</td>\n              <td>{{ship.shippingServiceValue}}</td>\n          </tr>\n  \n          <tr *ngFor=\"let location of customer.Locations; let i = index\">\n            <td colspan=\"2\" style=\"padding-left: 20px\">\n              <div style=\" word-wrap: break-word; white-space: pre-line;    max-width: 500px; padding: 0 5px 0 5px\">\n                <b>Location {{i+1}} Location Type: {{location.locationType}}</b>\n                <div >\n                <span *ngIf=\"location.receiverName\">{{location.receiverName}},</span><span *ngIf=\"location.email\">{{location.email}},</span> <span *ngIf=\"location.phone\">{{location.phone}},</span><span *ngIf=\"location.fax\">{{location.fax}},</span> <span *ngIf=\"location.addressLine1 || location.addressLine2\">{{location.addressLine1}} {{location.addressLine2}},</span> {{location.city}},<span *ngIf=\"location.zipCode\">{{location.zipCode}},</span> {{location.state}} {{location.country}}\n                </div>\n\n              </div>\n            </td>\n          </tr>\n\n\n        </tbody>\n\n        <tbody *ngIf=\"customer.isEditFlag\">\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Company Name <span>*</span></td>\n            <!-- <td>{{customer.customerName}}</td> -->\n            <td>\n              <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input matInput  [(ngModel)]=\"customer.customerName\">\n              </mat-input-container>\n            </td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Contact Person <span>*</span></td>\n            <!-- <td>{{customer.customerName}}</td> -->\n            <td>\n              <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input matInput  [(ngModel)]=\"customer.contactPerson\">\n              </mat-input-container>\n            </td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">SalesRep Code </td>\n            <!-- <td>{{customer.salePersonCode}}</td> -->\n            <td>\n                <mat-select placeholder=\"select\" [(value)]=\"customer.salePersonCode\" name=\"action\">\n                    <mat-option [value]=\"\">None</mat-option>\n                    <mat-option *ngFor=\"let saleRepCode of saleRepCodes\" [value]=\"saleRepCode.id\">\n                      {{saleRepCode.code}} ( {{saleRepCode.firstName}} {{saleRepCode.lastName}} )\n                    </mat-option>\n                </mat-select>\n              <!-- <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input  matInput [(ngModel)]=\"customer.salePersonCode\">\n              </mat-input-container> -->\n              <!-- <mat-select placeholder=\"select\" [(ngModel)]=\"customer.salePersonCode\" name=\"action\">\n                  <mat-option *ngFor=\"let slrep of alesRep\" [value]=\"class.id\">\n                    {{class.name}}\n                  </mat-option>\n                </mat-select> -->\n            </td>\n          </tr>\n<!--          <tr>-->\n<!--            <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Tax Group </td>-->\n<!--            &lt;!&ndash; <td>$ {{customer.taxGroup}}</td> &ndash;&gt;-->\n<!--            <td>-->\n<!--              &lt;!&ndash; <mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n<!--                <input  matInput [(ngModel)]=\"customer.taxGroup\">-->\n<!--              </mat-input-container> &ndash;&gt;-->\n\n<!--              <mat-select placeholder=\"select\" [(value)]=\"customer.taxGroup\" name=\"action\">-->\n<!--                <mat-option [value]=\"\">None</mat-option>-->\n<!--                  <mat-option *ngFor=\"let tax of taxGroup\" [value]=\"tax.code\">-->\n<!--                    {{tax.code}} ({{tax.description}})-->\n<!--                  </mat-option>-->\n<!--              </mat-select>-->\n<!--            </td>-->\n<!--          </tr>-->\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Payment term </td>\n            <!-- <td>{{customer.customerCompany}}</td> -->\n            <td>\n              <!-- <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input  matInput [(ngModel)]=\"customer.customerCompany\">\n              </mat-input-container> -->\n\n              <mat-select placeholder=\"select\" [(value)]=\"customer.customerCompany\" name=\"action\">\n                <mat-option [value]=\"\">None</mat-option>\n                  <mat-option *ngFor=\"let term of termCode\" [value]=\"term.code\">\n                    {{term.code}} ({{term.description}})\n                  </mat-option>\n                </mat-select>\n\n            </td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Payment Currency* </td>\n            <td>\n\n\n              <mat-select placeholder=\"select\" [(value)]=\"customer.paymentCurrency\" name=\"action\">\n                <mat-option [value]=\"\">None</mat-option>\n                  <mat-option *ngFor=\"let currency of currencies\" [value]=\"currency.code\">\n                    {{currency.code}} ({{currency.description}})\n                  </mat-option>\n                </mat-select>\n\n            </td>\n          </tr>\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Payment processing</td>\n            <!-- <td>{{customer.customerCompany}}</td> -->\n            <td>\n              <!-- <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input  matInput [(ngModel)]=\"customer.customerCompany\">\n              </mat-input-container> -->\n              <mat-select placeholder=\"select\" [(value)]=\"customer.paymentProcessing\" name=\"action\">\n                <mat-option [value]=\"\">None</mat-option>\n                <mat-option *ngFor=\"let tax of paymentProcessingCode\" [value]=\"tax.code\">\n                  {{tax.description}}\n                </mat-option>\n              </mat-select>\n\n            </td>\n          </tr>\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Discount Tag</td>\n            <td>\n              <mat-select placeholder=\"select\" [(value)]=\"customer.discountTag\" name=\"action\">\n                <mat-option [value]=\"\">None</mat-option>\n                <mat-option *ngFor=\"let diacount of discountTagsList\" [value]=\"diacount.tag\">\n                  {{diacount.tag}}\n                </mat-option>\n              </mat-select>\n\n            </td>\n          </tr>\n\n\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Email *</td>\n            <!-- <td>{{customer.email}}</td> -->\n            <td>\n              <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input  matInput [(ngModel)]=\"customer.email\">\n              </mat-input-container>\n            </td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Phone <span>*</span></td>\n            <!-- <td>{{customer.customerPhone}}</td> -->\n            <!--<td>-->\n              <!--<mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n                <!--<input   matInput [(ngModel)]=\"countryCode\">-->\n              <!--</mat-input-container>-->\n            <!--</td>-->\n<!--            <td style =\"max-width:350px; padding:unset\">-->\n<!--              <table  style=\"all:unset\">-->\n<!--                <tr>-->\n<!--                  <td style=\"width: 35%; border-bottom: unset; border-top:unset\" >-->\n<!--                    <mat-input-container style=\"all: unset\" dividerColor=\"primary\">-->\n<!--                      <input [textMask]=\"{mask: countryCodeMask,guide:false}\"  matInput [(ngModel)]=\"customerCountryCode\" placeholder=\"Country Code\">-->\n<!--                    </mat-input-container>-->\n<!--                  </td>-->\n                  <td  >\n                    <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                      <input [textMask]=\"{mask: mask,guide:false}\" minlength={{maskLength}} matInput [(ngModel)]=\"customer.customerPhone\">\n                    </mat-input-container>\n                  </td>\n<!--                </tr>-->\n<!--              </table>-->\n\n\n              <!--<mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n                      <!--<input [textMask]=\"{mask: mask,guide:false}\"  matInput [(ngModel)]=\"customer.customerPhone\">-->\n                    <!--</mat-input-container>-->\n\n\n<!--            </td>-->\n          </tr>\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">ERP Customer ID <span></span></td>\n                  <td  >\n                    <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                      <input matInput [(ngModel)]=\"customer.erpCustomerId\">\n                    </mat-input-container>\n                  </td>\n          </tr>\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Calculate Tax On Primary Location <span></span></td>\n            <td>\n              <mat-checkbox [(ngModel)]=\"customer.taxOnPrimaryLocation\"></mat-checkbox>\n            </td>\n          </tr>\n<!--          <tr>-->\n<!--            <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Group Code </td>-->\n<!--            &lt;!&ndash; <td>{{customer.groupCode}}</td> &ndash;&gt;-->\n<!--            <td>-->\n<!--              &lt;!&ndash; <mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n<!--                <input matInput  [(ngModel)]=\"customer.groupCode\">-->\n<!--              </mat-input-container> &ndash;&gt;-->\n\n<!--              <mat-select placeholder=\"select\" [(value)]=\"customer.groupCode\" name=\"action\">-->\n<!--                <mat-option [value]=\"\">None</mat-option>-->\n<!--                  <mat-option *ngFor=\"let grp of customerGroup\" [value]=\"grp.code\">-->\n<!--                    {{grp.code}} ({{grp.description}})-->\n<!--                  </mat-option>-->\n<!--                </mat-select>-->\n<!--            </td>-->\n<!--          </tr>-->\n\n<!--          <tr>-->\n<!--            <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Shipping Cost</td>-->\n<!--            <td>-->\n<!--              <mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n<!--                <input type=\"number\"  matInput [(ngModel)]=\"customer.shippingCost\">-->\n<!--              </mat-input-container>-->\n<!--            </td>-->\n<!--          </tr>-->\n\n\n <!-- shipping service -->\n\n                  <!-- <tr  *ngIf=\"isShippingAdding\">\n                      <td>\n                         {{}}\n\n                      </td>\n                      <td>\n                        {{}}\n                      </td>\n        \n                    </tr> -->\n\n\n                    <tr  *ngFor=\"let shipAr of shippingArray\">\n                        <td *ngIf=\"shipAr.isShippingAdding\">\n                            <!-- [(ngModel)]=\"emails.authentication\"  [(ngModel)]=\"emails.emailUserName\"-->\n                            <mat-form-field>\n                                <mat-select placeholder=\"Select\" [(ngModel)]=\"shipAr.shippingServiceId\" name=\"actioin\">\n                                  <mat-option *ngFor=\"let ship of shippingService\" [value]=\"ship.id\">\n                                     {{ship.description}}\n                                  </mat-option>\n                                </mat-select>\n                              </mat-form-field>\n                        </td>\n                        <td *ngIf=\"shipAr.isShippingAdding\">\n                            <mat-input-container  dividerColor=\"primary\">\n                                <input  matInput placeholder=\"Shipping Service ID\" [(ngModel)]=\"shipAr.shippingServiceValue\">\n                              </mat-input-container>\n                              <button mat-icon-button  (click)=\"createShippingServiceArray(shipAr)\"><i class=\"fa fa-check\" aria-hidden=\"true\" ></i></button>\n                            <button mat-icon-button (click)=\"cancelShippingServiceArray(shipAr)\"><i class=\"fa fa-times\" aria-hidden=\"true\" ></i></button>\n                        </td>\n          \n                        <td *ngIf=\"!shipAr.isShippingAdding\"><span  *ngIf=\"!shipAr.isEditingSingleShippingService\">{{getNameFromId(shipAr.shippingServiceId)}}</span>\n                        <span  *ngIf=\"shipAr.isEditingSingleShippingService\">\n                            <mat-form-field>\n                                <mat-select placeholder=\"Select\" [(ngModel)]=\"shipAr.shippingServiceId\" name=\"actioin\">\n                                  <mat-option *ngFor=\"let ship of shippingService\" [(value)]=\"ship.id\">\n                                     {{ship.description}}\n                                  </mat-option>\n                                </mat-select>\n                              </mat-form-field>\n                          \n                        </span>\n                        </td>\n                        <td *ngIf=\"!shipAr.isShippingAdding\">\n                          <span *ngIf=\"!shipAr.isEditingSingleShippingService\">\n                          {{shipAr.shippingServiceValue}}\n                            <button mat-icon-button *ngIf=\"!shipAr.isEditingSingleShippingService\" (click)=\"removeshipingservice(shipAr)\"  style=\"float: right;\"><i class=\"fa fa-trash\" aria-hidden=\"true\" ></i></button>                          \n                            <button mat-icon-button *ngIf=\"!shipAr.isEditingSingleShippingService\" (click)=\"editingSingleShipping(shipAr)\"  style=\"float: right;\"><i class=\"fa fa-pencil\" aria-hidden=\"true\" ></i></button>                                                      \n                          </span>\n                          <span *ngIf=\"shipAr.isEditingSingleShippingService\">\n                              <mat-input-container  dividerColor=\"primary\">\n                                  <input  matInput placeholder=\"Shipping Service ID\" [(ngModel)]=\"shipAr.shippingServiceValue\">\n                                </mat-input-container>\n                                <button mat-icon-button *ngIf=\"shipAr.isEditingSingleShippingService\" (click)=\"editingSingleShippingService(shipAr)\"  style=\"float: right;\"><i class=\"fa fa-times\" aria-hidden=\"true\" ></i></button>\n                                <button mat-icon-button *ngIf=\"shipAr.isEditingSingleShippingService\" (click)=\"editingSingleShippingService(shipAr)\" style=\"float: right;\"><i class=\"fa fa-check\" aria-hidden=\"true\" ></i></button>                                \n                          </span>\n                        </td>\n          \n                      </tr>\n          \n                      <tr *ngIf=\"shippingService.length>0 && isEditingSingleShippingService\">\n                          <td class=\"mdl-data-table__cell--non-numeric\" colspan=\"2\">\n                            <button mat-raised-button class=\"color-success\" style=\" width: 100%;margin: 12px 0px;\" (click)=\"addObjectArr()\">\n                              <i class=\"material-icons\">add</i> Shipping Service</button></td>\n                        </tr>\n          \n                    <!-- END shipping service -->\n\n\n\n\n\n          <!-- <span colspan=\"2\" *ngFor=\"let location of customer.Locations\">\n            \n          </span> -->\n\n\n          <!--  <b>Phone:</b> <mat-input-container class=\"full-width\" dividerColor=\"primary\"><input matInput [(ngModel)]=\"location.phone\"> <b>Address:</b> <mat-input-container class=\"full-width\" dividerColor=\"primary\"><input matInput [(ngModel)]=\"location.addressLine1\"> <mat-input-container class=\"full-width\" dividerColor=\"primary\"><input matInput [(ngModel)]=\"location.addressLine2\">, <mat-input-container class=\"full-width\" dividerColor=\"primary\"><input matInput [(ngModel)]=\"location.city\">, <mat-input-container class=\"full-width\" dividerColor=\"primary\"><input matInput [(ngModel)]=\"location.state\"> <mat-input-container class=\"full-width\" dividerColor=\"primary\"><input matInput [(ngModel)]=\"location.country\">\n -->\n          <!-- <tr>\n            <td class=\"mdl-data-table__cellnon-numeric\">Next Available Date</td>\n            <td><mat-input-container class=\"full-width\" dividerColor=\"primary\"><input matInput [(ngModel)]=\"customer.nextAvailableDate\"></td>\n            <td>{{product.nextAvailableDate}}</td>\n          </tr> -->\n        </tbody>\n      </table>\n\n      <div *ngIf=\"customer.isEditFlag\">\n\n        <div *ngFor=\"let location of customer.Locations; let i = index\">\n          <table class=\"mdl-data-table\" style=\"margin-top: 10px; width: 100% \" *ngIf=\"!location.isEditFlag\">\n            <thead style=\"background: #ECECEC\">\n              <tr>\n                <th colspan=\"2\" class=\"numeric\">\n                  <b>Location {{i+1}} Type: {{location.locationType}}</b>\n                </th>\n                <th  class=\"numeric\">\n                  <b>Actions</b>\n                </th>\n                <th  class=\"numeric\">\n                  <b>Primary</b>\n                </th>\n              </tr>\n            </thead>\n            <tbody>\n\n              <tr *ngIf=\"!location.isEditFlag\">\n                <td colspan=\"2\" style=\"padding: 20px\">\n                  <div style=\" word-wrap: break-word; white-space: pre-line; max-width: 500px;padding: 0 5px 50px 5px;\">\n\n                    <span *ngIf=\"location.receiverName\">{{location.receiverName}},</span><span *ngIf=\"location.phone\"> {{location.phone}},</span> <span *ngIf=\"location.addressLine1 || location.addressLine2\">{{location.addressLine1}} {{location.addressLine2}},</span> {{location.city}},<span *ngIf=\"location.zipCode\">{{location.zipCode}},</span> {{location.state}}<span *ngIf=\"location.country\">,{{location.country}}</span>\n\n\n                  </div>\n\n                </td>\n                <td>\n                  <!--<button mat-button (click)=\"toggleEditAddress(location)\" [disabled]=\"!enableEditlocation\">-->\n                    <!--Mark Primary</button>-->\n                  <button mat-icon-button (click)=\"toggleEditAddress(location)\" [disabled]=\"!enableEditlocation\">\n                    <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> </button>\n                   <button mat-icon-button (click)=\"deleteThisLocation(location,i,false)\" [disabled]=\"!enableEditlocation\">\n                  <i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button>\n\n\n                </td>\n                <td>\n                  <mat-checkbox   [(ngModel)]=\"location.isShipToAddress\" (ngModelChange)=\"changePrimary(location,i)\"> </mat-checkbox>\n\n                </td>\n\n              </tr>\n\n\n            </tbody>\n          </table>\n\n\n\n\n\n\n\n          <table class=\"mdl-data-table \" style=\"margin-top: 10px; width:500px \" *ngIf=\"location.isEditFlag\">\n            <thead style=\"background: #ECECEC\">\n              <tr>\n                <th colspan=\"2\" class=\"numeric\">\n                  <b><span>Location {{i+1}}</span>\n                    <span style=\"float: right;\"><button *ngIf=\"customer.isEditFlag && location.isAddFlag\" mat-raised-button (click)=\"addLocationComplete(location)\" style=\"color: rgba(0,0,0,0.87);\">Add</button></span>\n                    <span style=\"float: right\"><button *ngIf=\"customer.isEditFlag &&  !location.isAddFlag\" mat-raised-button (click)=\"update(location)\" style=\"color: rgba(0,0,0,0.87);\">Update</button></span>\n                  </b>\n                </th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <td>Location Type <span>*</span></td>\n                <td>\n\n                  <mat-form-field>\n                    <mat-select placeholder=\"select\" [(ngModel)]=\"location.locationType\" name=\"lType\">\n                      <mat-option value=\"BILLTO\">\n                        BillTo\n                      </mat-option>\n                      <mat-option value=\"SHIPTO\">\n                        ShipTo\n                      </mat-option>\n                      <mat-option value=\"BILLTOSHIPTO\">\n                        BillToShipTo\n                      </mat-option>\n                    </mat-select>\n                  </mat-form-field>\n                </td>\n              </tr>\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                    Contact Person*\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input matInput  [(ngModel)]=\"location.receiverName\">\n                  </mat-input-container>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                    Receiver Phone*\n                </td>\n<!--                <td style =\"max-width:350px; padding:unset\">-->\n<!--                  <table  style=\"all:unset\">-->\n<!--                    <tr>-->\n<!--                      <td style=\"width: 35%; border-bottom: unset; border-top:unset\" >-->\n<!--                        <mat-input-container style=\"all: unset\" dividerColor=\"primary\">-->\n<!--                          <input [textMask]=\"{mask: countryCodeMask,guide:false}\"  matInput [(ngModel)]=\"receiverCountryCode\" placeholder=\"Country Code\">-->\n<!--                        </mat-input-container>-->\n<!--                      </td>-->\n                      <td >\n                        <mat-input-container  class=\"full-width\" dividerColor=\"primary\">\n                          <input [textMask]=\"{mask: mask,guide:false}\" minlength={{maskLength}} matInput [(ngModel)]=\"location.phone\">\n                        </mat-input-container>\n                      </td>\n<!--                    </tr>-->\n<!--                  </table>-->\n\n                        <!--<mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n                          <!--<input [textMask]=\"{mask: mask,guide:false}\"  matInput [(ngModel)]=\"location.phone\">-->\n                        <!--</mat-input-container>-->\n\n<!--                </td>-->\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">Receiver Email*</td>\n                <!-- <td>{{customer.email}}</td> -->\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input  matInput [(ngModel)]=\"location.email\">\n                  </mat-input-container>\n                </td>\n              </tr>\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Receiver Fax\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <textarea style=\"max-height: 100px;\" matInput [(ngModel)]=\"location.fax\" maxlength=\"50\" required></textarea>\n                  </mat-input-container>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Country <span>*</span>\n                </td>\n                <td>\n\n                  <mat-select placeholder=\"select\" [(value)]=\"location.country\" name=\"action\">\n                    <mat-option (onSelectionChange)=\"getProvinces(location,countory.abbrivation,$event)\" *ngFor=\"let countory of countories\" [value]=\"countory.abbrivation\">\n                      {{countory.description}}\n                    </mat-option>\n                  </mat-select>\n\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Address Line 1*\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <textarea style=\"max-height: 100px;\" matInput [(ngModel)]=\"location.addressLine1\" maxlength=\"50\" required></textarea>\n                  </mat-input-container>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Address Line 2\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <textarea style=\"max-height: 100px;\" matInput [(ngModel)]=\"location.addressLine2\" maxlength=\"50\"></textarea>\n                  </mat-input-container>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  City <span>*</span>\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input matInput  [(ngModel)]=\"location.city\">\n                  </mat-input-container>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  State/Province <span>*</span>\n                </td>\n                <td>\n<!--                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n<!--                    <input matInput  [(ngModel)]=\"location.state\">-->\n<!--                  </mat-input-container>-->\n                  <mat-select placeholder=\"select\" [(value)]=\"location.state\" name=\"action\">\n                    <mat-option *ngFor=\"let province of provinces\" [value]=\"province.code\">\n                      {{province.description}}\n                    </mat-option>\n                  </mat-select>\n                </td>\n              </tr>\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Zip/Postal Code <span>*</span>\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input matInput  [(ngModel)]=\"location.zipCode\">\n                  </mat-input-container>\n                </td>\n              </tr>\n\n\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">Shipping Cost</td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input type=\"number\"  matInput [(ngModel)]=\"location.shippingCost\">\n                  </mat-input-container>\n                </td>\n              </tr>\n\n              <tr>\n                <td *ngIf=\"!location.isAddFlag\">\n                  <button *ngIf=\"customer.isEditFlag\" mat-raised-button (click)=\"undoChanges(location)\">Cancel</button>\n                </td>\n                <td *ngIf=\"location.isAddFlag\">\n                  <button *ngIf=\"customer.isEditFlag\" mat-raised-button (click)=\"cancelAdd(location)\">Cancel</button>\n                </td>\n                <td *ngIf=\"!location.isAddFlag\">\n                  <button *ngIf=\"customer.isEditFlag\" mat-raised-button (click)=\"update(location)\">Update</button>\n                </td>\n                <td *ngIf=\"location.isAddFlag\">\n                  <button *ngIf=\"customer.isEditFlag\" mat-raised-button (click)=\"addLocationComplete(location)\">Add</button>\n                </td>\n              </tr>\n\n            </tbody>\n          </table>\n\n\n        </div>\n\n        <button style=\" width: 100%;margin: 12px 0px;\" mat-raised-button class=\"btn-w-md\" (click)=\"addLocation()\" [disabled]=\"!enableAddlocation\" >Add Location</button>\n\n\n\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row  max-height-500\" *ngIf=\"customer.isCreateFlag\" style=\"min-width: 500px;\">\n    <div class=\"col-md-12\">\n      <table style=\"width:100%;\" class=\"mdl-data-table\">\n\n        <tbody>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Company Name <span>*</span></td>\n            <!-- <td>{{customer.customerName}}</td> -->\n            <td>\n              <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input (blur)=\"checkCustomerWithSameNameAlreadyExist()\" matInput  [(ngModel)]=\"customer.customerName\" style=\"min-width:  316px;\">\n              </mat-input-container>\n            </td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Contact Person <span>*</span></td>\n            <!-- <td>{{customer.customerName}}</td> -->\n            <td>\n              <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input matInput  [(ngModel)]=\"customer.contactPerson\" style=\"min-width:  316px;\">\n              </mat-input-container>\n            </td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">SalesRep Code</td>\n            <!-- <td>{{customer.salePersonCode}}</td> -->\n            <td>\n                <mat-select placeholder=\"select\" [(value)]=\"customer.salePersonCode\" name=\"action\">\n                  <mat-option [value]=\"\">None</mat-option>\n                    <mat-option *ngFor=\"let saleRepCode of saleRepCodes\" [value]=\"saleRepCode.id\">\n                      {{saleRepCode.code}} ( {{saleRepCode.firstName}} {{saleRepCode.lastName}} )\n                    </mat-option>\n                </mat-select>\n              <!-- <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input  matInput [(ngModel)]=\"customer.salePersonCode\">\n              </mat-input-container> -->\n            </td>\n          </tr>\n<!--          <tr>-->\n<!--            <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Tax Group</td>-->\n<!--            &lt;!&ndash; <td>$ {{customer.taxGroup}}</td> &ndash;&gt;-->\n<!--            <td>-->\n<!--              &lt;!&ndash; <mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n<!--                <input  matInput [(ngModel)]=\"customer.taxGroup\">-->\n<!--              </mat-input-container> &ndash;&gt;-->\n<!--              <mat-select placeholder=\"select\" [(value)]=\"customer.taxGroup\" name=\"action\">-->\n<!--                <mat-option [value]=\"\">None</mat-option>-->\n<!--                  <mat-option *ngFor=\"let tax of taxGroup\" [value]=\"tax.code\">-->\n<!--                    {{tax.code}} ({{tax.description}})-->\n<!--                  </mat-option>-->\n<!--                </mat-select>-->\n<!--            </td>-->\n<!--          </tr>-->\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Payment term</td>\n            <!-- <td>{{customer.customerCompany}}</td> -->\n            <td>\n              <!-- <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input  matInput [(ngModel)]=\"customer.customerCompany\">\n              </mat-input-container> -->\n              <mat-select placeholder=\"select\" [(value)]=\"customer.customerCompany\" name=\"action\">\n                <mat-option [value]=\"\">None</mat-option>\n                  <mat-option *ngFor=\"let tax of termCode\" [value]=\"tax.code\">\n                    {{tax.code}} ({{tax.description}})\n                  </mat-option>\n              </mat-select>\n              \n            </td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Payment Currency*</td>\n            <td>\n              <mat-select placeholder=\"select\" [(value)]=\"customer.paymentCurrency\" name=\"action\">\n                <mat-option [value]=\"\">None</mat-option>\n                  <mat-option *ngFor=\"let currency of currencies\" [value]=\"currency.code\">\n                    {{currency.code}} ({{currency.description}})\n                  </mat-option>\n              </mat-select>\n\n            </td>\n          </tr>\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Payment processing</td>\n            <td>\n              <mat-select placeholder=\"select\" [(value)]=\"customer.paymentProcessing\" name=\"action\">\n                <mat-option [value]=\"\">None</mat-option>\n                <mat-option *ngFor=\"let tax of paymentProcessingCode\" [value]=\"tax.code\">\n                  <span *ngIf=\"getShowStatus(tax)\">{{tax.description}}</span>\n                </mat-option>\n              </mat-select>\n\n            </td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Discount Tag</td>\n            <td>\n              <mat-select placeholder=\"select\" [(value)]=\"customer.discountTag\" name=\"action\">\n                <mat-option [value]=\"\">None</mat-option>\n                <mat-option *ngFor=\"let discount of discountTagsList\" [value]=\"discount.tag\">\n                  <span>{{discount.tag}}</span>\n                </mat-option>\n              </mat-select>\n\n            </td>\n          </tr>\n\n          <!-- <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Customer Status</td>\n            \n            <td>\n              <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input  matInput [(ngModel)]=\"customer.customerStatus\">\n              </mat-input-container>\n            </td>\n          </tr> -->\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Email <span>*</span></td>\n            <!-- <td>{{customer.email}}</td> -->\n            <td>\n              <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                <input  matInput [(ngModel)]=\"customer.email\">\n              </mat-input-container>\n            </td>\n          </tr>\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Phone <span>*</span></td>\n            <!-- <td>{{customer.customerPhone}}</td> -->\n<!--            <td  style =\"max-width:350px; padding:unset\">-->\n<!--              <table  style=\"all:unset\">-->\n<!--                <tr>-->\n<!--                  <td style=\"width: 35%; border-bottom: unset; border-top:unset\" >-->\n<!--                    <mat-input-container style=\"all: unset\" dividerColor=\"primary\">-->\n<!--                      <input [textMask]=\"{mask: countryCodeMask,guide:false}\"  matInput [(ngModel)]=\"customerCountryCode\" placeholder=\"Country Code\">-->\n<!--                    </mat-input-container>-->\n<!--                  </td>-->\n                  <td>\n                    <mat-input-container  class=\"full-width\" dividerColor=\"primary\">\n                    <input [textMask]=\"{mask: mask,guide:false}\" minlength={{maskLength}}  matInput [(ngModel)]=\"customer.customerPhone\">\n<!--                    <input [textMask]=\"{mask: mask,guide:false}\"  matInput [(ngModel)]=\"customer.customerPhone\" placeholder=\"Number\">-->\n                    </mat-input-container>\n                  </td>\n<!--                </tr>-->\n<!--              </table>-->\n\n\n                    <!--<mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n                      <!--<input [textMask]=\"{mask: mask,guide:false}\"  matInput [(ngModel)]=\"customer.customerPhone\">-->\n                    <!--</mat-input-container>-->\n\n<!--            </td>-->\n          </tr>\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">ERP Customer ID <span></span></td>\n            <!-- <td>{{customer.customerPhone}}</td> -->\n            <!--            <td  style =\"max-width:350px; padding:unset\">-->\n            <!--              <table  style=\"all:unset\">-->\n            <!--                <tr>-->\n            <!--                  <td style=\"width: 35%; border-bottom: unset; border-top:unset\" >-->\n            <!--                    <mat-input-container style=\"all: unset\" dividerColor=\"primary\">-->\n            <!--                      <input [textMask]=\"{mask: countryCodeMask,guide:false}\"  matInput [(ngModel)]=\"customerCountryCode\" placeholder=\"Country Code\">-->\n            <!--                    </mat-input-container>-->\n            <!--                  </td>-->\n            <td>\n              <mat-input-container  class=\"full-width\" dividerColor=\"primary\">\n                <input  matInput [(ngModel)]=\"customer.erpCustomerId\">\n                <!--                    <input [textMask]=\"{mask: mask,guide:false}\"  matInput [(ngModel)]=\"customer.customerPhone\" placeholder=\"Number\">-->\n              </mat-input-container>\n            </td>\n            <!--                </tr>-->\n            <!--              </table>-->\n\n\n            <!--<mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n            <!--<input [textMask]=\"{mask: mask,guide:false}\"  matInput [(ngModel)]=\"customer.customerPhone\">-->\n            <!--</mat-input-container>-->\n\n            <!--            </td>-->\n          </tr>\n\n          <tr>\n            <td class=\"mdl-data-table__cell--non-numeric\">Calculate Tax On Primary Location <span></span></td>\n            <td  >\n              <mat-checkbox [(ngModel)]=\"customer.taxOnPrimaryLocation\"></mat-checkbox>\n            </td>\n          </tr>\n<!--          <tr>-->\n<!--            <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Group Code</td>-->\n<!--            &lt;!&ndash; <td>{{customer.groupCode}}</td> &ndash;&gt;-->\n<!--            <td>-->\n<!--              &lt;!&ndash; <mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n<!--                <input matInput  [(ngModel)]=\"customer.groupCode\">-->\n<!--              </mat-input-container> &ndash;&gt;-->\n\n<!--              -->\n<!--              <mat-select placeholder=\"select\" [(value)]=\"customer.groupCode\" name=\"action\">-->\n<!--                <mat-option [value]=\"\">None</mat-option>-->\n<!--                  <mat-option *ngFor=\"let grp of customerGroup\" [value]=\"grp.code\">-->\n<!--                    {{grp.code}} ({{grp.description}}) -->\n<!--                  </mat-option>-->\n<!--                </mat-select>-->\n<!--            </td>-->\n<!--          </tr>-->\n\n\n<!--          <tr>-->\n<!--            <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Shipping Cost</td>-->\n<!--            <td>-->\n<!--              <mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n<!--                <input type=\"number\"  matInput [(ngModel)]=\"customer.shippingCost\">-->\n<!--              </mat-input-container>-->\n<!--            </td>-->\n<!--          </tr>-->\n                  <!-- shipping service -->\n\n                  \n\n\n                  <tr  *ngFor=\"let shipAr of shippingArray\">\n                      <td *ngIf=\"shipAr.isShippingAdding\">\n                          <!-- [(ngModel)]=\"emails.authentication\"  [(ngModel)]=\"emails.emailUserName\"-->\n                          <mat-form-field>\n                              <mat-select placeholder=\"Select\" [(ngModel)]=\"shipAr.shippingServiceId\" name=\"actioin\">\n                                <mat-option *ngFor=\"let ship of shippingService\" [value]=\"ship.id\">\n                                   {{ship.description}}\n                                </mat-option>\n                              </mat-select>\n                            </mat-form-field>\n                      </td>\n                      <td *ngIf=\"shipAr.isShippingAdding\">\n                          <mat-input-container  dividerColor=\"primary\">\n                              <input  matInput placeholder=\"Shipping Service ID\" [(ngModel)]=\"shipAr.shippingServiceValue\">\n                            </mat-input-container>\n                            <button mat-icon-button  (click)=\"createShippingServiceArray(shipAr)\"><i class=\"fa fa-check\" aria-hidden=\"true\" ></i></button>\n                          <button mat-icon-button (click)=\"cancelShippingServiceArray(shipAr)\"><i class=\"fa fa-times\" aria-hidden=\"true\" ></i></button>\n                      </td>\n        \n                      <td *ngIf=\"!shipAr.isShippingAdding\"><span  *ngIf=\"!shipAr.isEditingSingleShippingService\">{{getNameFromId(shipAr.shippingServiceId)}}</span>\n                      <span  *ngIf=\"shipAr.isEditingSingleShippingService\">\n                          <mat-form-field>\n                              <mat-select placeholder=\"Select\" [(ngModel)]=\"shipAr.shippingServiceId\" name=\"actioin\">\n                                <mat-option *ngFor=\"let ship of shippingService\" [(value)]=\"ship.id\">\n                                   {{ship.description}}\n                                </mat-option>\n                              </mat-select>\n                            </mat-form-field>\n\n                      </span>\n                      </td>\n                      <td *ngIf=\"!shipAr.isShippingAdding\">\n                        <span *ngIf=\"!shipAr.isEditingSingleShippingService\">\n                        {{shipAr.shippingServiceValue}}\n                          <button mat-icon-button *ngIf=\"!shipAr.isEditingSingleShippingService\" (click)=\"removeshipingservice(shipAr)\"  style=\"float: right;\"><i class=\"fa fa-trash\" aria-hidden=\"true\" ></i></button>                          \n                          <button mat-icon-button *ngIf=\"!shipAr.isEditingSingleShippingService\" (click)=\"editingSingleShipping(shipAr)\"  style=\"float: right;\"><i class=\"fa fa-pencil\" aria-hidden=\"true\" ></i></button>                                                      \n                        </span>\n                        <span *ngIf=\"shipAr.isEditingSingleShippingService\">\n                            <mat-input-container  dividerColor=\"primary\">\n                                <input  matInput placeholder=\"Shipping Service ID\" [(ngModel)]=\"shipAr.shippingServiceValue\">\n                              </mat-input-container>\n                              <button mat-icon-button *ngIf=\"shipAr.isEditingSingleShippingService\" (click)=\"editingSingleShippingService(shipAr)\"  style=\"float: right;\"><i class=\"fa fa-times\" aria-hidden=\"true\" ></i></button>\n                              <button mat-icon-button *ngIf=\"shipAr.isEditingSingleShippingService\" (click)=\"editingSingleShippingService(shipAr)\" style=\"float: right;\"><i class=\"fa fa-check\" aria-hidden=\"true\" ></i></button>                                \n                        </span>\n                      </td>\n        \n                    </tr>\n        \n                    <tr *ngIf=\"shippingService.length>0 && isEditingSingleShippingService\">\n                        <td class=\"mdl-data-table__cell--non-numeric\" colspan=\"2\">\n                          <button mat-raised-button class=\"color-success\" style=\" width: 100%;margin: 12px 0px;\" (click)=\"addObjectArr()\">\n                            <i class=\"material-icons\">add</i> Shipping Service</button></td>\n                      </tr>\n        \n\n          <!-- END shipping service -->\n\n        </tbody>\n      </table>\n\n      <div *ngIf=\"customer.isCreateFlag\">\n\n        <div *ngFor=\"let location of customer.Locations; let i = index\">\n\n          <table class=\"mdl-data-table\" style=\"margin-top: 10px; width:100%;\" *ngIf=\"!location.isEditFlag\">\n            <thead style=\"background: #ECECEC\">\n              <tr>\n                <th colspan=\"2\" class=\"numeric\">\n                  <b>Location {{i+1}} Type: {{location.locationType}}</b>\n                </th>\n                <th class=\"numeric\">\n                    <b>Actions</b>\n                </th>\n                <th class=\"numeric\">\n                    <b>Primary</b>\n                </th>\n              </tr>\n            </thead>\n            <tbody>\n\n              <tr *ngIf=\"!location.isEditFlag\">\n                <td colspan=\"2\" style=\"padding: 20px\">\n                  <div style=\" word-wrap: break-word; white-space: pre-line; max-width: 500px;padding: 0 5px 0 5px\">\n                    <!--{{location.receiverName}}, {{location.phone}}, {{location.addressLine1}} {{location.addressLine2}}, {{location.city}}, {{location.state}},{{location.country}}-->\n                    <span *ngIf=\"location.receiverName\">{{location.receiverName}},</span><span *ngIf=\"location.phone\"> {{location.phone}},</span> <span *ngIf=\"location.addressLine1 || location.addressLine2\">{{location.addressLine1}} {{location.addressLine2}},</span> {{location.city}},<span *ngIf=\"location.zipCode\">{{location.zipCode}},</span> {{location.state}}<span *ngIf=\"location.country\">,{{location.country}}</span>\n                  </div>\n\n\n                </td>\n                <td>\n                  <button mat-icon-button (click)=\"toggleEditAddress(location)\" [disabled]=\"!enableEditlocation\">\n                    <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button>\n                  <button mat-icon-button (click)=\"deleteThisLocation(location,i,true)\" [disabled]=\"!enableEditlocation\">\n                  <i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button>\n\n                </td>\n                <td>\n                  <mat-checkbox   [(ngModel)]=\"location.isShipToAddress\"  (ngModelChange)=\"checkPrimary(location,i)\"></mat-checkbox>\n                </td>\n\n              </tr>\n\n\n            </tbody>\n          </table>\n\n\n\n\n\n\n\n          <table class=\"mdl-data-table\" style=\"margin-top: 10px; width:500px;\" *ngIf=\"location.isEditFlag\">\n            <thead style=\"background: #ECECEC\">\n              <tr>\n                <th colspan=\"2\" class=\"numeric\">\n                  <b><span>Location {{i+1}}</span><span style=\"float: right;\"><button mat-raised-button (click)=\"addLocationComplete(location,index)\"style=\"color: rgba(0,0,0,0.87);\">Add</button></span></b>\n                \n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <td>Location Type <span>*</span></td>\n                <td>\n\n                  <mat-form-field>\n                    <mat-select placeholder=\"select\" [(ngModel)]=\"location.locationType\" name=\"lType\" >\n                      <mat-option value=\"BILLTO\">\n                        BillTo\n                      </mat-option>\n                      <mat-option value=\"SHIPTO\">\n                        ShipTo\n                      </mat-option>\n                      <mat-option value=\"BILLTOSHIPTO\">\n                        BillToShipTo\n                      </mat-option>\n                    </mat-select>\n                  </mat-form-field>\n                </td>\n              </tr>\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                    Contact Person*\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input matInput  [(ngModel)]=\"location.receiverName\" required>\n                  </mat-input-container>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                    Receiver Phone\n                </td>\n<!--                  <td  style =\"max-width:350px; padding:unset\">-->\n<!--                    <table  style=\"all:unset\">-->\n<!--                      <tr>-->\n<!--                        <td style=\"width: 35%; border-bottom: unset; border-top:unset\" >-->\n<!--                          <mat-input-container style=\"all: unset\" dividerColor=\"primary\">-->\n<!--                            <input [textMask]=\"{mask: countryCodeMask,guide:false}\"  matInput [(ngModel)]=\"receiverCountryCode\" placeholder=\"Country Code\">-->\n<!--                          </mat-input-container>-->\n<!--                        </td>-->\n                        <td >\n                          <mat-input-container class=\"full-width\"  dividerColor=\"primary\">\n                            <input [textMask]=\"{mask: mask,guide:false}\" minlength={{maskLength}} matInput [(ngModel)]=\"location.phone\" >\n                          </mat-input-container>\n                        </td>\n<!--                      </tr>-->\n<!--                    </table>-->\n\n\n                    <!--<mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n                            <!--<input [textMask]=\"{mask: mask,guide:false}\"  matInput [(ngModel)]=\"location.phone\">-->\n                          <!--</mat-input-container>-->\n<!--                  </td>-->\n              </tr>\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">Receiver Email* </td>\n                <!-- <td>{{customer.email}}</td> -->\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input  matInput [(ngModel)]=\"location.email\">\n                  </mat-input-container>\n                </td>\n              </tr>\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Receiver Fax\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <textarea style=\"max-height: 100px;\" matInput [(ngModel)]=\"location.fax\" maxlength=\"50\" required></textarea>\n                  </mat-input-container>\n                </td>\n              </tr>\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Country <span>*</span>\n                </td>\n                <td>\n                  <!-- <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input matInput  [(ngModel)]=\"location.country\">\n                  </mat-input-container> -->\n\n                  <mat-select  placeholder=\"select\" [(value)]=\"location.country\" name=\"action\">\n                    <mat-option (onSelectionChange)=\"getProvinces(location, countory.abbrivation,$event)\" *ngFor=\"let countory of countories\" [value]=\"countory.abbrivation\">\n                      {{countory.description}}\n                    </mat-option>\n                  </mat-select>\n\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Address Line 1*\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <textarea style=\"max-height: 100px;\" matInput [(ngModel)]=\"location.addressLine1\" maxlength=\"50\" required></textarea>\n                  </mat-input-container>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Address Line 2\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <textarea style=\"max-height: 100px;\" matInput [(ngModel)]=\"location.addressLine2\" maxlength=\"50\" required></textarea>\n                  </mat-input-container>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  City <span>*</span>\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input matInput  [(ngModel)]=\"location.city\" required>\n                  </mat-input-container>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  State/Province <span>*</span>\n                </td>\n                <td>\n<!--                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">-->\n<!--                    <input matInput  [(ngModel)]=\"location.state\" required>-->\n<!--                  </mat-input-container>-->\n                  <mat-select placeholder=\"select\" [(value)]=\"location.state\" name=\"action\">\n                    <mat-option *ngFor=\"let province of provinces\" [value]=\"province.code\">\n                      {{province.description}}\n                    </mat-option>\n                  </mat-select>\n                </td>\n              </tr>\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">\n                  Zip/Postal Code <span>*</span>\n                </td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input matInput  [(ngModel)]=\"location.zipCode\" required>\n                  </mat-input-container>\n                </td>\n              </tr>\n\n\n\n\n              <tr>\n                <td class=\"mdl-data-table__cell--non-numeric\">Shipping Cost</td>\n                <td>\n                  <mat-input-container class=\"full-width\" dividerColor=\"primary\">\n                    <input type=\"number\"  matInput [(ngModel)]=\"location.shippingCost\">\n                  </mat-input-container>\n                </td>\n              </tr>\n\n              <tr>\n                <!-- <td *ngIf=\"!location.isAddFlag\">\n                     <button *ngIf=\"location.isEditFlag\" mat-raised-button  (click)=\"undoChanges(location)\">Cancel</button>\n                   </td>\n                   <td *ngIf=\"location.isAddFlag\">\n                     <button *ngIf=\"!location.isEditFlag\" mat-raised-button  (click)=\"cancelAdd(location)\">Cancel</button>\n                   </td> -->\n                <td *ngIf=\"location.isEditFlag && location.isAddFlag\">\n                  <button mat-raised-button (click)=\"cancelAdd(location)\">Cancel</button>\n                </td>\n                <td *ngIf=\"location.isEditFlag && !location.isAddFlag\">\n                  <button mat-raised-button (click)=\"undoChanges(location)\"> Cancel</button>\n                </td>\n                <td>\n                  <button mat-raised-button (click)=\"addLocationComplete(location)\">Add</button>\n                </td>\n              </tr>\n\n            </tbody>\n          </table>\n\n\n        </div>\n\n        <button style=\" width: 100%;margin: 12px 0px;\" mat-raised-button class=\"btn-w-md\" (click)=\"addLocation()\" [disabled]=\"!enableAddlocation\">Add Location</button>\n\n\n\n      </div>\n    </div>\n  </div>\n\n  <div md-dialog-actions *ngIf=\"!customer.isCreateFlag\">\n    <div class=\"row\" style=\"margin-top: 10px\">\n      <!-- <div class=\"col-md-2\">\n      <button mat-button color=\"primary\" class=\"btn-w-md\">Need Help?</button>\n      </div> -->\n      <div class=\"col-md-4\"></div>\n      <div class=\"col-md-8\">\n        <!-- <button mat-button (click)=\"dialogRef.close('Option 1')\">Cancel</button> -->\n        <button *ngIf=\"!customer.isEditFlag\" mat-raised-button (click)=\"close('Option 1')\">Ok</button>\n        <button *ngIf=\"customer.isEditFlag\" mat-raised-button (click)=\"close('cancel')\">Cancel</button>\n        <button *ngIf=\"customer.isEditFlag\" mat-raised-button (click)=\"close('update')\">Update</button>\n      </div>\n    </div>\n  </div>\n\n\n\n\n  <div md-dialog-actions *ngIf=\"customer.isCreateFlag\">\n    <div class=\"row\" style=\"margin-top: 10px\">\n\n      <div class=\"col-md-4\"></div>\n      <div class=\"col-md-8\">\n\n\n        <button mat-raised-button (click)=\"close('cancel')\">Cancel</button>\n        <button mat-raised-button (click)=\"close('create')\">Create</button>\n      </div>\n    </div>\n  </div>\n\n</section>\n"

/***/ }),

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EChartsDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_theme_macarons__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_theme_macarons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_theme_macarons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__ = __webpack_require__(112);





var EChartsDirective = /** @class */ (function () {
    function EChartsDirective(el, layoutService) {
        var _this = this;
        this.layoutService = layoutService;
        this.resizeChart = function (state) {
            // console.log('state: ' + state)
            setTimeout(function () {
                if (_this.myChart) {
                    //this.myChart.resize();
                    _this.myChart.dispose();
                    _this.myChart = null;
                    _this.myChart = __WEBPACK_IMPORTED_MODULE_2_echarts___default.a.init(_this.el.nativeElement, 'macarons');
                    if (!_this.EChartsOptions) {
                        return;
                    }
                    _this.myChart.setOption(_this.EChartsOptions);
                }
            }, 0);
        };
        this.el = el;
        this.subscription = layoutService.echartsState$.subscribe(function (state) {
            _this.resizeChart(state);
        });
    }
    EChartsDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.myChart = __WEBPACK_IMPORTED_MODULE_2_echarts___default.a.init(_this.el.nativeElement, 'macarons');
            if (!_this.EChartsOptions) {
                return;
            }
            _this.myChart.setOption(_this.EChartsOptions);
        }, 0);
    };
    EChartsDirective.prototype.ngOnDestroy = function () {
        if (this.myChart) {
            this.myChart.dispose();
            this.myChart = null; // https://bitbucket.org/iarouse/angular-material/commits/5eec2667b5496edfa1cc0896333b83e188a35676
        }
    };
    EChartsDirective.prototype.onResize = function () {
        this.resizeChart(true);
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Object)
    ], EChartsDirective.prototype, "EChartsOptions", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"])('window:resize'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", []),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:returntype", void 0)
    ], EChartsDirective.prototype, "onResize", null);
    EChartsDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myECharts]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__["a" /* LayoutService */]])
    ], EChartsDirective);
    return EChartsDirective;
}());



/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);



var LayoutService = /** @class */ (function () {
    function LayoutService() {
        this.preloaderStateSource = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.preloaderState$ = this.preloaderStateSource.asObservable();
        this.searchOverlaySource = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.searchOverlayState$ = this.searchOverlaySource.asObservable();
        this.echartsSource = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.echartsState$ = this.echartsSource.asObservable();
    }
    LayoutService.prototype.updatePreloaderState = function (state) {
        // console.log('preloader state: ' + state)
        this.preloaderStateSource.next(state);
    };
    LayoutService.prototype.updateSearchOverlayState = function (state) {
        // console.log('overlay state: ' + state)
        this.searchOverlaySource.next(state);
    };
    LayoutService.prototype.updateEChartsState = function (state) {
        // console.log('echarts state: ' + state)
        this.echartsSource.next(state);
    };
    LayoutService = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])()
    ], LayoutService);
    return LayoutService;
}());



/***/ }),

/***/ 1310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlimScrollDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll_jquery_slimscroll_min_js__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll_jquery_slimscroll_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll_jquery_slimscroll_min_js__);



var SlimScrollDirective = /** @class */ (function () {
    function SlimScrollDirective(el) {
        this.el = el;
    }
    SlimScrollDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        $el.slimScroll({
            height: this.scrollHeight || '100%'
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", String)
    ], SlimScrollDirective.prototype, "scrollHeight", void 0);
    SlimScrollDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[mySlimScroll]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], SlimScrollDirective);
    return SlimScrollDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileDropDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fileapi__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fileapi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fileapi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);



var FileDropDirective = /** @class */ (function () {
    function FileDropDirective(element) {
        this.fileOver = new __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"]();
        this.onFileDrop = new __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"]();
        this.element = element;
    }
    FileDropDirective.prototype.onDragOver = function (event) {
        var transfer = this.getDataTransfer(event);
        if (!this.haveFiles(transfer.types)) {
            return;
        }
        transfer.dropEffect = 'copy';
        this.preventAndStop(event);
        this.emitFileOver(true);
    };
    FileDropDirective.prototype.onDragLeave = function (event) {
        if (event.currentTarget === this.element[0]) {
            return;
        }
        this.preventAndStop(event);
        this.emitFileOver(false);
    };
    FileDropDirective.prototype.onDrop = function (event) {
        var transfer = this.getDataTransfer(event);
        if (!transfer) {
            return;
        }
        this.preventAndStop(event);
        this.emitFileOver(false);
        this.readFile(transfer.files[0]);
    };
    FileDropDirective.prototype.readFile = function (file) {
        var _this = this;
        var strategy = this.pickStrategy();
        if (!strategy) {
            this.emitFileDrop(file);
        }
        else {
            // XXX Waiting for angular/zone.js#358
            var method = "readAs" + strategy;
            __WEBPACK_IMPORTED_MODULE_1_fileapi__[method](file, function (event) {
                if (event.type === 'load') {
                    _this.emitFileDrop(event.result);
                }
                else if (event.type === 'error') {
                    throw new Error("Couldn't read file '" + file.name + "'");
                }
            });
        }
    };
    FileDropDirective.prototype.emitFileOver = function (isOver) {
        this.fileOver.emit(isOver);
    };
    FileDropDirective.prototype.emitFileDrop = function (file) {
        this.onFileDrop.emit(file);
    };
    FileDropDirective.prototype.pickStrategy = function () {
        if (!this.options) {
            return;
        }
        if (this.hasStrategy(this.options.readAs)) {
            return this.options.readAs;
        }
    };
    FileDropDirective.prototype.hasStrategy = function (type) {
        return [
            'DataURL',
            'BinaryString',
            'ArrayBuffer',
            'Text',
        ].indexOf(type) !== -1;
    };
    FileDropDirective.prototype.getDataTransfer = function (event) {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer;
    };
    FileDropDirective.prototype.preventAndStop = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    FileDropDirective.prototype.haveFiles = function (types) {
        if (!types) {
            return false;
        }
        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        }
        if (types.contains) {
            return types.contains('Files');
        }
        return false;
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Output"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"])
    ], FileDropDirective.prototype, "fileOver", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Output"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"])
    ], FileDropDirective.prototype, "onFileDrop", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Object)
    ], FileDropDirective.prototype, "options", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["HostListener"])('dragover', [
            '$event',
        ]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [Object]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:returntype", void 0)
    ], FileDropDirective.prototype, "onDragOver", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["HostListener"])('dragleave', [
            '$event',
        ]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [Object]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:returntype", void 0)
    ], FileDropDirective.prototype, "onDragLeave", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["HostListener"])('drop', [
            '$event',
        ]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [Object]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:returntype", void 0)
    ], FileDropDirective.prototype, "onDrop", null);
    FileDropDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"])({ selector: '[fileDrop]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"]])
    ], FileDropDirective);
    return FileDropDirective;
}());



/***/ }),

/***/ 1314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__providers_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular2_json2csv__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular2_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angular2_json2csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ngx_zendesk_webwidget__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_material2_theme_scss__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_material2_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_styles_material2_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_bootstrap_scss__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_bootstrap_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_styles_bootstrap_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_layout_scss__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_styles_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_theme_scss__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styles_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles_ui_scss__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles_ui_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_styles_ui_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styles_app_scss__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_styles_app_scss__);










// 3rd


// custom




var AppComponent = /** @class */ (function () {
    function AppComponent(router, toastr, vRef, _ngxZendeskWebwidgetService) {
        var _this = this;
        this.router = router;
        this.toastr = toastr;
        this.vRef = vRef;
        this._ngxZendeskWebwidgetService = _ngxZendeskWebwidgetService;
        if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') && localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') == 'true') {
            _ngxZendeskWebwidgetService.show();
            var user = JSON.parse(localStorage.getItem("currentUser"));
            _ngxZendeskWebwidgetService.identify({
                name: user.firstName + '-' + user.adpCustomerInfo.companyName,
                email: user.email,
                organization: user.adpCustomerInfo.companyName
            });
        }
        router.events.subscribe(function (event) {
            if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["e" /* NavigationStart */]) {
                // Show loading indicator
            }
            if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */]) {
                // Hide loading indicator
                _ngxZendeskWebwidgetService.setHelpCenterSuggestions({ url: true });
                console.log(_this.router.url);
            }
            if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["d" /* NavigationError */]) {
                // Hide loading indicator
                // Present error to user
                console.log(event.error);
            }
        });
        //
        // this.toastr.setRootViewContainerRef(vRef);
    }
    AppComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */];
        // Scroll to top on route change
        this.router.events.subscribe(function (evt) {
            if (!(evt instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */])) {
                return;
            }
            window.scrollTo(0, 0);
        });
    };
    AppComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'app-root',
            template: __webpack_require__(1321),
            providers: [__WEBPACK_IMPORTED_MODULE_4__layout_layout_service__["a" /* LayoutService */], __WEBPACK_IMPORTED_MODULE_5__providers_api__["a" /* Api */], __WEBPACK_IMPORTED_MODULE_7_angular2_json2csv__["CsvService"]],
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */],
            __WEBPACK_IMPORTED_MODULE_6_ng2_toastr__["ToastsManager"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"],
            __WEBPACK_IMPORTED_MODULE_8_ngx_zendesk_webwidget__["c" /* ngxZendeskWebwidgetService */]])
    ], AppComponent);
    return AppComponent;
}());



/***/ }),

/***/ 1315:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1316:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1321:
/***/ (function(module, exports) {

module.exports = "\n<div myPreloader class=\"preloaderbar hide\"><span class=\"bar\"></span></div>\n<div id=\"app-main\" class=\"app-main full-height\"\n   [ngClass]=\"{'fixed-header' : AppConfig.fixedHeader,\n               'nav-collapsed' : AppConfig.navCollapsed,\n               'nav-behind' : AppConfig.navBehind,\n               'layout-boxed' : AppConfig.layoutBoxed,\n               'theme-gray' : AppConfig.theme == 'gray',\n               'theme-dark' : AppConfig.theme == 'dark',\n               'sidebar-sm' : AppConfig.sidebarWidth == 'small',\n               'sidebar-lg' : AppConfig.sidebarWidth == 'large'}\">\n  <router-outlet></router-outlet>\n</div>"

/***/ }),

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreloaderDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_service__ = __webpack_require__(112);




var PreloaderDirective = /** @class */ (function () {
    function PreloaderDirective(el, router, layoutService) {
        var _this = this;
        this.el = el;
        this.router = router;
        this.layoutService = layoutService;
        router.events.subscribe(function (event) {
            _this.navigationInterceptor(event);
        });
        this.subscription = layoutService.preloaderState$.subscribe(function (state) {
            _this.updatePreloader(state);
        });
    }
    PreloaderDirective.prototype.ngAfterViewInit = function () {
        this.$el = $(this.el.nativeElement);
    };
    PreloaderDirective.prototype.active = function () {
        if (this.$el) {
            this.$el.removeClass('hide').addClass('active');
        }
    };
    PreloaderDirective.prototype.hide = function () {
        if (this.$el) {
            this.$el.addClass('hide').removeClass('active');
        }
    };
    // Shows and hides the loading spinner during RouterEvent changes
    PreloaderDirective.prototype.navigationInterceptor = function (event) {
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["e" /* NavigationStart */]) {
            this.active();
        }
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */]) {
            this.hide();
        }
        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* NavigationCancel */]) {
            this.hide();
        }
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["d" /* NavigationError */]) {
            this.hide();
        }
    };
    //
    PreloaderDirective.prototype.updatePreloader = function (state) {
        // console.log('change state')
        if (state === 'active') {
            this.active();
        }
        if (state === 'hide') {
            this.hide();
        }
    };
    PreloaderDirective.prototype.ngOnDestroy = function () {
        // prevent memory leak when component destroyed
        this.subscription.unsubscribe();
    };
    PreloaderDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({
            selector: '[myPreloader]',
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */], __WEBPACK_IMPORTED_MODULE_3__layout_service__["a" /* LayoutService */]])
    ], PreloaderDirective);
    return PreloaderDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppHeaderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(52);



var AppHeaderComponent = /** @class */ (function () {
    function AppHeaderComponent() {
    }
    AppHeaderComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    AppHeaderComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-header',
            styles: [],
            template: __webpack_require__(1324)
        })
    ], AppHeaderComponent);
    return AppHeaderComponent;
}());



/***/ }),

/***/ 1324:
/***/ (function(module, exports) {

module.exports = "<section class=\"app-header\">\n  <div class=\"app-header-inner\"\n     [ngClass]=\"{'bg-color-light': ['11','12','13','14','15','16','21'].indexOf(AppConfig.colorOption) >= 0,\n                 'bg-color-dark': AppConfig.colorOption === '31',\n                 'bg-color-primary': ['22','32'].indexOf(AppConfig.colorOption) >= 0,\n                 'bg-color-success': ['23','33'].indexOf(AppConfig.colorOption) >= 0,\n                 'bg-color-info': ['24','34'].indexOf(AppConfig.colorOption) >= 0,\n                 'bg-color-warning': ['25','35'].indexOf(AppConfig.colorOption) >= 0,\n                 'bg-color-danger': ['26','36'].indexOf(AppConfig.colorOption) >= 0}\">\n\n    <div class=\"d-lg-none d-xl-none float-left\">\n      <button mat-button myToggleOffcanvasNav class=\"md-button header-icon toggle-sidebar-btn\">\n        <i class=\"material-icons\">menu</i>\n      </button>\n    </div>\n\n\n    <div class=\"brand d-none d-lg-inline-block d-xl-inline-block\">\n      <h2><a [routerLink]=\"['/']\">{{AppConfig.brand}}</a></h2>\n    </div>\n\n    <div class=\"top-nav-left d-none d-lg-inline-block d-xl-inline-block\">\n      <ul class=\"list-unstyled list-inline\">\n        <li class=\"list-inline-item\"><button mat-button class=\"md-button header-btn\" myOpenSearchOverlay><i class=\"material-icons\">search</i></button></li>\n       <!--  <li class=\"list-inline-item\">\n          <button mat-button class=\"md-button header-btn\" [matMenuTriggerFor]=\"appNotification\">\n            <i class=\"material-icons\">notifications_none</i>\n            <span class=\"badge\">3</span>\n          </button>\n          <mat-menu #appNotification=\"matMenu\" x-position=\"after\" y-position=\"below\" overlapTrigger=\"false\">\n            <mat-list dense>\n              <mat-list-item>\n                <mat-icon mat-list-avatar>mail_outline</mat-icon>\n                <h4 mat-line>New mail from David</h4>\n                <p mat-line class=\"text-muted\">5 minutes ago</p>\n              </mat-list-item>\n              <mat-list-item>\n                <mat-icon mat-list-avatar>chat_bubble_outline</mat-icon>\n                <h4 mat-line>Message from Jane</h4>\n                <p mat-line class=\"text-muted\">15 minutes ago</p>\n              </mat-list-item>\n              <mat-list-item>\n                <mat-icon mat-list-avatar>person_outline</mat-icon>\n                <h4 mat-line>New member John joined</h4>\n                <p mat-line class=\"text-muted\">1 hour ago</p>\n              </mat-list-item>\n            </mat-list>\n          </mat-menu>\n        </li> -->\n      </ul>\n    </div>\n\n    <div class=\"top-nav-right\">\n      <ul class=\"list-unstyled float-right\">\n        <!-- <li>\n          <button mat-button class=\"md-button header-btn\" [routerLink]=\"['/app/page/about']\">\n            <img src=\"assets/images/g1.jpg\" alt=\"\" class=\"rounded img30_30\">\n          </button>\n        </li> -->\n        <li><button mat-button class=\"md-button header-btn d-lg-none d-xl-none\" myOpenSearchOverlay><i class=\"material-icons\">search</i></button></li>\n        <!-- <li><button mat-button class=\"md-button header-btn\"><i class=\"material-icons\">more_vert</i></button></li> -->\n      </ul>\n    </div>\n\n  </div>\n</section>\n"

/***/ }),

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSidenavComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__providers_api__ = __webpack_require__(83);





var AppSidenavComponent = /** @class */ (function () {
    function AppSidenavComponent(router, api) {
        this.router = router;
        this.api = api;
        this.userName = "Anonymous";
        this.logoImgUrl = "assets/images/placeholder.jpg";
        this.squareLogoImage = "";
        if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') && localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') == 'true') {
            this.userName = this.getUserName();
            this.logoImgUrl = this.getImageUrl();
        }
    }
    AppSidenavComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
        this.squareLogoImage = this.getSquareLogoImage();
        // this.squareLogoImage = "https://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
    };
    AppSidenavComponent.prototype.imageNotFoundServer = function (event) {
        // event.target.src = "https://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
    };
    AppSidenavComponent.prototype.toggleCollapsedNav = function () {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    };
    AppSidenavComponent.prototype.logout = function () {
        var _this = this;
        // this.api.activateLoader();
        this.api.get("user/logout").subscribe(function (res) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
            _this.router.navigate(['/extra/login']);
            // this.api.hideLoader();
        }, function (err) {
            console.log(err);
            //if (err.status == 401) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
            _this.router.navigate(['/extra/login']);
            // this.api.hideLoader();
            // }
        });
    };
    AppSidenavComponent.prototype.getUserName = function () {
        var fName = JSON.parse(localStorage.getItem('currentUser')).firstName;
        var lName = JSON.parse(localStorage.getItem('currentUser')).lastName;
        if (typeof fName === 'undefined') {
            fName = " ";
        }
        if (typeof lName === 'undefined') {
            lName = " ";
        }
        return fName + " " + lName;
    };
    AppSidenavComponent.prototype.getImageUrl = function () {
        return JSON.parse(localStorage.getItem('currentUser')).adpCustomerInfo.logoImgUrl || "assets/images/placeholder.jpg";
    };
    AppSidenavComponent.prototype.getSquareLogoImage = function () {
        return this.AppConfig.imagesBaseUrl + "/" + this.api.getADPCustomerUUID() + "/" + this.AppConfig.brandingFolder + "/logoSquare.png?v=" + Math.round((new Date()).getTime() / 1000);
    };
    AppSidenavComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-sidenav',
            styles: [],
            template: __webpack_require__(1326)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_router__["f" /* Router */], __WEBPACK_IMPORTED_MODULE_4__providers_api__["a" /* Api */]])
    ], AppSidenavComponent);
    return AppSidenavComponent;
}());



/***/ }),

/***/ 1326:
/***/ (function(module, exports) {

module.exports = "<nav class=\"app-sidebar\" myAutoCloseMobileNav\n     [ngClass]=\"{'bg-color-light': ['31','32','33','34','35','36'].indexOf(AppConfig.colorOption) >= 0,\n               'bg-color-dark': ['31','32','33','34','35','36'].indexOf(AppConfig.colorOption) < 0 }\">\n\n  <section class=\"sidebar-header\"\n           [ngClass]=\"{'bg-color-dark': ['11','31'].indexOf(AppConfig.colorOption) >= 0,\n                   'bg-color-light': AppConfig.colorOption === '21',\n                   'bg-color-primary': ['12','22','32'].indexOf(AppConfig.colorOption) >= 0,\n                   'bg-color-success': ['13','23','33'].indexOf(AppConfig.colorOption) >= 0,\n                   'bg-color-info': ['14','24','34'].indexOf(AppConfig.colorOption) >= 0,\n                   'bg-color-warning': ['15','25','35'].indexOf(AppConfig.colorOption) >= 0,\n                   'bg-color-danger': ['16','26','36'].indexOf(AppConfig.colorOption) >= 0}\">\n    <!-- <span class=\"logo-icon material-icons\">view_compact</span> -->\n    <!-- <svg class=\"logo-img\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 250 250\" style=\"enable-background:new 0 0 250 250;\" xml:space=\"preserve\">\n      <g>\n        <g>\n          <polygon class=\"st0\" points=\"125,153.4 100.3,153.4 88.6,182.6 88.6,182.6 66.9,182.6 66.8,182.6 125,52.1 125,52.2 125,52.2 \n            125,30 125,30 31.9,63.2 46.1,186.3 125,230 125,230 125,153.4    \"/>\n          <polygon class=\"st0\" points=\"108,135.4 125,135.4 125,135.4 125,94.5     \"/>\n        </g>\n        <g class=\"st1\">\n          <polygon class=\"st0\" points=\"125,153.4 149.7,153.4 161.4,182.6 161.4,182.6 183.1,182.6 183.2,182.6 125,52.1 125,52.2 125,52.2 \n            125,30 125,30 218.1,63.2 203.9,186.3 125,230 125,230 125,153.4    \"/>\n          <polygon class=\"st0\" points=\"142,135.4 125,135.4 125,135.4 125,94.5     \"/>\n        </g>\n      </g>\n    </svg> -->\n    <img style=\"width: 30px; margin: 0px 9px 0 0; margin-top: -5px;\" src=\"../../assets/images/JazzbaNewEmblemV2.png\">\n<!--    <a [routerLink]=\"['/app/dashboard']\" class=\"brand\">{{AppConfig.brand}}</a>-->\n    <a class=\"brand\">{{AppConfig.brand}}</a>\n    <a href=\"javascript:;\" class=\"collapsednav-toggler\" (click)=\"toggleCollapsedNav()\">\n      <i class=\"material-icons\" *ngIf=\"this.AppConfig.navCollapsed\">radio_button_unchecked</i>\n      <i class=\"material-icons\" *ngIf=\"!this.AppConfig.navCollapsed\">radio_button_checked</i>\n    </a>\n  </section>\n\n  <section class=\"sidebar-content\">\n    <my-app-sidenav-menu></my-app-sidenav-menu>\n  </section>\n\n  <section class=\"sidebar-footer gv-sidebar-footer\">\n    <ul class=\"nav\">\n<!--      <li  *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/branding/home']\"><i class=\"nav-icon material-icons\">grade</i><span class=\"nav-text\">Branding</span></a></li>-->\n      <li>\n        <a mat-button aria-label=\"menu\" target=\"_blank\" [matMenuTriggerFor]=\"appNotification\">\n          <div style=\"display: flex; justify-content: center;\">\n            <div class=\"nav-text\" style=\"margin-left: 0;\">{{userName}}</div>\n          </div>\n          <div style=\"margin-top: 5px; display: flex; justify-content: center; align-items: center; height: 100%;\">\n            <img mat-list-avatar src=\"{{squareLogoImage}}\" (error)=\"imageNotFoundServer($event)\" alt=\"\" class=\"rounded img30_30\">\n          </div>        </a>\n        <mat-menu #appNotification=\"matMenu\" x-position=\"after\" y-position=\"below\" overlapTrigger=\"false\">\n          <mat-list dense class=\"logout-popup\"  style=\"cursor: pointer;\">\n            <mat-list-item (click)=\"logout()\" style=\" margin-top: -6px; padding-top: 0;\">\n              <mat-icon mat-list-avatar>exit_to_app</mat-icon>\n              <h4 mat-line>Logout</h4>\n              <!-- <p mat-line class=\"text-muted\">5 minutes ago</p> -->\n            </mat-list-item>\n            <!-- <mat-list-item>\n              <mat-icon mat-list-avatar>chat_bubble_outline</mat-icon>\n              <h4 mat-line>Message from Jane</h4>\n              <p mat-line class=\"text-muted\">15 minutes ago</p>\n            </mat-list-item>\n            <mat-list-item>\n              <mat-icon mat-list-avatar>person_outline</mat-icon>\n              <h4 mat-line>New member John joined</h4>\n              <p mat-line class=\"text-muted\">1 hour ago</p>\n            </mat-list-item> -->\n          </mat-list>\n        </mat-menu>\n        <!-- <button mat-button class=\"md-button header-btn\" [routerLink]=\"['/app/page/about']\">\n          <img src=\"assets/images/g1.jpg\" alt=\"\" class=\"rounded img30_30\"> \n        </button>\n        <button mat-button class=\"md-button header-btn\" [matMenuTriggerFor]=\"appNotification\">\n            <i class=\"material-icons\">notifications_none</i>\n            <span class=\"badge\">3</span>\n          </button> -->\n      </li>\n      <!-- <li class=\"list-inline-item\">\n          <button mat-button class=\"md-button header-btn\" [matMenuTriggerFor]=\"appNotification\">\n            <img src=\"assets/images/g1.jpg\" alt=\"\" class=\"rounded img30_30\"> \n            <span class=\"badge\">3</span>\n          </button>\n          <div mat-button style=\"margin: 5px 10px;\" [matMenuTriggerFor]=\"appNotification\">User Name</div>\n          <mat-menu #appNotification=\"matMenu\" x-position=\"after\" y-position=\"below\" overlapTrigger=\"false\">\n            <mat-list dense>\n              <mat-list-item>\n                <mat-icon mat-list-avatar>mail_outline</mat-icon>\n                <h4 mat-line>New mail from David</h4>\n                <p mat-line class=\"text-muted\">5 minutes ago</p>\n              </mat-list-item>\n              <mat-list-item>\n                <mat-icon mat-list-avatar>chat_bubble_outline</mat-icon>\n                <h4 mat-line>Message from Jane</h4>\n                <p mat-line class=\"text-muted\">15 minutes ago</p>\n              </mat-list-item>\n              <mat-list-item>\n                <mat-icon mat-list-avatar>person_outline</mat-icon>\n                <h4 mat-line>New member John joined</h4>\n                <p mat-line class=\"text-muted\">1 hour ago</p>\n              </mat-list-item>\n            </mat-list>\n          </mat-menu>\n        </li> -->\n    </ul>\n  </section>\n</nav>\n"

/***/ }),

/***/ 1327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleOffcanvasNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


// off-canvas sidebar for mobile, and this is the trigger
var ToggleOffcanvasNavDirective = /** @class */ (function () {
    function ToggleOffcanvasNavDirective(el) {
        this.el = el;
    }
    ToggleOffcanvasNavDirective.prototype.ngAfterViewInit = function () {
        var $navToggler = $(this.el.nativeElement);
        var $body = $('#body');
        $navToggler.on('click', function (e) {
            // _sidebar.scss, _page-container.scss
            $body.toggleClass('sidebar-mobile-open');
            e.preventDefault();
        });
    };
    ToggleOffcanvasNavDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myToggleOffcanvasNav]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], ToggleOffcanvasNavDirective);
    return ToggleOffcanvasNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoCloseMobileNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(52);




// Mobile only: automatically close sidebar on route change.
var AutoCloseMobileNavDirective = /** @class */ (function () {
    function AutoCloseMobileNavDirective(el, router) {
        this.el = el;
        this.router = router;
    }
    AutoCloseMobileNavDirective.prototype.ngOnInit = function () {
        var $body = $('#body');
        if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].AutoCloseMobileNav) {
            this.router.events.subscribe(function (event) {
                if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */]) {
                    setTimeout(function () {
                        // console.log('NavigationEnd:', event);
                        $body.removeClass('sidebar-mobile-open');
                    }, 0);
                }
            });
        }
    };
    AutoCloseMobileNavDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myAutoCloseMobileNav]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */]])
    ], AutoCloseMobileNavDirective);
    return AutoCloseMobileNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSidenavMenuComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__providers_api__ = __webpack_require__(83);





var AppSidenavMenuComponent = /** @class */ (function () {
    function AppSidenavMenuComponent(router, api) {
        this.router = router;
        this.api = api;
        this.listGroups = [
            // {
            // 	name:"Tax Group",
            // 	alias:"taxGroup",
            // 	icon:"format_list_bulleted"
            // },
            {
                name: "Customer Group",
                alias: "customerGroup",
                icon: "format_list_bulleted"
            },
            {
                name: "Payment term",
                alias: "termsCode",
                icon: "format_list_bulleted"
            },
            {
                name: "Bad Product Conditions",
                alias: "badProductConditions",
                icon: "format_list_bulleted"
            },
            {
                name: "Shipping Services",
                alias: "shippingServices",
                icon: "format_list_bulleted"
            }
            // {
            // 	name:"Country",
            // 	alias:"country",
            // 	icon:"format_list_bulleted"
            // }
        ];
        localStorage.setItem("allowedTables", JSON.stringify(this.listGroups));
    }
    AppSidenavMenuComponent.prototype.logout = function () {
        localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
        this.router.navigate(['/extra/login']);
    };
    AppSidenavMenuComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-sidenav-menu',
            styles: [],
            template: __webpack_require__(1330)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */], __WEBPACK_IMPORTED_MODULE_4__providers_api__["a" /* Api */]])
    ], AppSidenavMenuComponent);
    return AppSidenavMenuComponent;
}());



/***/ }),

/***/ 1330:
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav\" myAccordionNav myAppendSubmenuIcon mySlimScroll myHighlightActiveItems>\n    <!-- <li class=\"nav-header\"><span>Navigation</span></li> -->\n    <!-- <li><a mat-button [routerLink]=\"['/app/login']\"><i class=\"nav-icon material-icons\">Login</i><span class=\"nav-text\">Login</span></a></li> -->\n    <!--<li class=\"nav-divider\"></li>-->\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/dashboard']\"><i class=\"nav-icon material-icons\">home</i><span class=\"nav-text\">Dashboard</span></a></li>\n    <li class=\"nav-divider\"></li>\n\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'warehouse'\">\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">insert_chart</i><span class=\"nav-text\">Reports</span></a>\n        <ul>\n\n            <li><a mat-button [routerLink]=\"['/app/reports/onsale']\" ><i class=\"nav-icon material-icons\">attach_money</i><span class=\"nav-text\">B2B Sales</span></a>\n                <!-- <ul>\n                    <li ><a mat-button [routerLink]=\"['/app/reports/onsale']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">By SalesRep</span></a></li> -->\n                <!-- <li ><a mat-button [routerLink]=\"['/app/reports/onhold']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">By SalesRep</span></a></li> -->\n                <!-- </ul> -->\n            </li>\n\n            <li><a mat-button [routerLink]=\"['/app/reports/saleChannelReport']\" ><i class=\"nav-icon material-icons\">attach_money</i><span class=\"nav-text\">B2C Sales</span></a>\n            </li>\n\n            <li><a mat-button  [routerLink]=\"['/app/reports/onhold']\"><i class=\"nav-icon material-icons\">trending_up</i><span class=\"nav-text\">Potential Sales</span></a>\n                <!-- <ul>\n                   <li ><a mat-button [routerLink]=\"['/app/reports/onsale']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">By Placed Orders</span></a></li> -->\n                <!-- <li ><a mat-button [routerLink]=\"['/app/reports/onhold']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">By SalesRep</span></a></li>\n            </ul> -->\n            </li>\n\n\n            <!-- bookmark_border -->\n            <li><a mat-button [routerLink]=\"['/app/reports/bookmarks']\"><i class=\"nav-icon material-icons\">trending_up</i><span class=\"nav-text\">Trending Products</span></a></li>\n            <!-- <li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">person</i><span class=\"nav-text\">IntelliRep Users</span></a></li> -->\n        </ul>\n    </li>\n\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\">\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">content_copy</i><span class=\"nav-text\">Products</span></a>\n        <ul>\n            <!--            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/customers/home']\"><i class=\"nav-icon material-icons\">supervisor_account</i><span class=\"nav-text\">Customers</span></a></li>-->\n            <li><a mat-button [routerLink]=\"['/app/products/home']\"><i class=\"nav-icon material-icons\">storage</i><span class=\"nav-text\">All Products</span></a></li>\n<!--            <li *ngIf=\"api.isloggedInUserAdmin()\"><a mat-button [routerLink]=\"['/app/inventory/home']\"><i class=\" nav-icon material-icons\">storage</i><span class=\"nav-text\">Products Inventory</span></a></li>-->\n            <!--            <li><a mat-button [routerLink]=\"['/app/product-discount/discounts-criteria']\"><i class=\"nav-icon material-icons\">storage</i><span class=\"nav-text\">Discounts</span></a></li>-->\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/categories/home']\"><i class=\"nav-icon material-icons\">view_week</i><span class=\"nav-text\">Categories</span></a></li>\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/attributes/home']\"><i class=\"nav-icon material-icons\">view_week</i><span class=\"nav-text\">Attributes</span></a></li>\n\n        </ul>\n    </li>\n\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/customers/home']\"><i class=\"nav-icon material-icons\">supervisor_account</i><span class=\"nav-text\">Customers</span></a></li>\n<!--    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'warehouse'\"><a mat-button [routerLink]=\"['/app/product-discount/discounts-criteria']\"><i class=\"nav-icon material-icons\">shop_outline</i><span class=\"nav-text\"> Discount</span></a></li>-->\n<!--    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'warehouse'\"><a mat-button [routerLink]=\"['/app/product-discount/discounts-criteria']\"><i class=\"nav-icon material-icons\">shop_outline</i><span class=\"nav-text\"> Discount</span></a></li>-->\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'warehouse'\"><a mat-button [routerLink]=\"['/app/discounts/home']\"><i class=\"nav-icon material-icons\">shop_outline</i><span class=\"nav-text\"> Discounts</span></a></li>\n\n\n    <li *ngIf=\"api.isloggedInUserAdmin() || api.isloggedInUserSaleRep()\">\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">receipt</i><span class=\"nav-text\">Transactions</span></a>\n        <ul>\n            <li *ngIf=\"(api.isloggedInUserAdmin() || api.isloggedInUserSaleRep()) && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/transactions/saleOrder']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span *ngIf=\"api.getADPCustomerType().toLowerCase() == 'warehouse'\" class=\"nav-text\">Inv. Transfer Orders</span><span *ngIf=\"api.getADPCustomerType().toLowerCase() != 'warehouse'\" class=\"nav-text\">Sales</span></a></li>\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'supplier' && api.getADPCustomerType().toLowerCase() != 'warehouse'\"><a mat-button [routerLink]=\"['/app/transactions/purchaseOrder']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">Purchases</span></a></li>\n\n        </ul>\n    </li>\n\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'warehouse'\">\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">content_copy</i><span class=\"nav-text\">Sales Channels</span></a>\n        <ul>\n            <!--            <li><a mat-button [routerLink]=\"['/app/dashboard']\"><i class=\"nav-icon material-icons\">storage</i><span class=\"nav-text\">B2B</span></a></li>-->\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/buy-supply/buyer']\"><i class=\"nav-icon material-icons\">supervisor_account</i><span class=\"nav-text\"> B2B</span></a></li>\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase().toLowerCase() != 'supplier'\"><a mat-button [routerLink]=\"['/app/buy-supply/supplier']\"><i class=\"nav-icon material-icons\">supervisor_account</i><span class=\"nav-text\">B2B</span></a></li>\n            <li><a mat-button [routerLink]=\"['/app/sale-channels/home']\"><i class=\"nav-icon material-icons\">storage</i><span class=\"nav-text\">B2C</span></a></li>\n        </ul>\n    </li>\n\n    <li *ngIf=\"api.isloggedInUserAdmin()\">\n        <a mat-button href=\"#/app/page\" ><i class=\"nav-icon material-icons\">people_outline</i><span class=\"nav-text\">Users Management</span></a>\n        <ul>\n            <li><a mat-button [routerLink]=\"['/app/users/admin']\"><i class=\"nav-icon material-icons\">store</i><span class=\"nav-text\">Admins</span></a></li>\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'warehouse'\"><a mat-button [routerLink]=\"['/app/users/intelliRep']\"><i class=\"nav-icon material-icons\">store</i><span class=\"nav-text\">Sales Reps</span></a></li>\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/users/intellistock']\"><i class=\"nav-icon material-icons\">store</i><span class=\"nav-text\">Warehouse Staff</span></a></li>\n\n            <!--<li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">supervisor_account</i><span class=\"nav-text\">System Users</span></a></li> -->\n            <!--<li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">person</i><span class=\"nav-text\">IntelliCom Users</span></a></li>-->\n        </ul>\n    </li>\n\n\n<!--        Inventory managment-->\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\">\n        <a mat-button href=\"#/app/page\"><i class=\" nav-icon material-icons\">domain</i><span class=\"nav-text\">Inventory Management</span></a>\n        <ul>\n            <li><a mat-button [routerLink]=\"['/app/inventory/reports']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Inventory Reports</span></a></li>\n            <li><a mat-button [routerLink]=\"['/app/inventory/home']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Products Inventory</span></a></li>\n            <li><a mat-button [routerLink]=\"['/app/inventory/locations']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Locations</span></a></li>\n\n            <!--<li><a mat-button [routerLink]=\"['/app/inventory/locations']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Inventory Locations</span></a></li>-->\n\n        </ul>\n    </li>\n\n    <!--Inventory Management Starts here-->\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\">\n        <a mat-button href=\"#/app/page\"><i class=\" nav-icon material-icons\">domain</i><span class=\"nav-text\">Warehouse Management</span></a>\n        <ul>\n<!--            <li><a mat-button [routerLink]=\"['/app/inventory/warehouses']\"><i class=\" nav-icon material-icons\">domain</i><span class=\"nav-text\">Warehouses</span></a></li>-->\n            <li><a mat-button [routerLink]=\"['/app/warehouses/home']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Warehouses</span></a></li>\n            <li><a mat-button [routerLink]=\"['/app/inventory/shipmentNotices']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Shipment Notices</span></a></li>\n\n            <!--<li><a mat-button [routerLink]=\"['/app/inventory/locations']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Inventory Locations</span></a></li>-->\n\n        </ul>\n    </li>\n\n\n<!--    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/buy-supply/buyer']\"><i class=\"nav-icon material-icons\">shop_outline</i><span class=\"nav-text\"> Online Buyers</span></a></li>-->\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/buy-supply/supplier']\"><i class=\"nav-icon material-icons\">contacts_outline</i><span class=\"nav-text\">Suppliers</span></a></li>\n\n\n\n\n\n\n<!--    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\">-->\n<!--        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">settings_input_composite</i><span class=\"nav-text\">Integrations</span></a>-->\n<!--        <ul>-->\n<!--            <li><a mat-button [routerLink]=\"['/app/integrations/erp']\"><i class=\"nav-icon material-icons\">receipt</i><span class=\"nav-text\">ERP</span></a></li>-->\n<!--            &lt;!&ndash; <li><a mat-button [routerLink]=\"['/app/products/home']\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">Products</span></a></li>-->\n<!--              <li><a mat-button [routerLink]=\"['/app/categories/home']\"><i class=\"nav-icon material-icons\">view_week</i><span class=\"nav-text\">Categories</span></a></li> &ndash;&gt;-->\n\n<!--        </ul>-->\n\n<!--    </li>-->\n\n\n    <li *ngIf=\"api.isloggedInUserAdmin()\">\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">settings</i><span class=\"nav-text\">Account Settings</span></a>\n        <ul>\n            <li><a mat-button [routerLink]=\"['/app/company/home']\"><i class=\"nav-icon material-icons\">business</i><span class=\"nav-text\">Personalize</span></a></li>\n            <li *ngIf=\"api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'supplier'\"><a mat-button [routerLink]=\"['/app/company/work-order-auto-sync']\"><i class=\"nav-icon material-icons\">business</i><span class=\"nav-text\">Work Orders Auto Sync</span></a></li>\n            <li><a mat-button [routerLink]=\"['/app/company/supplier-payment']\"><i class=\"nav-icon material-icons\">attach_money</i><span class=\"nav-text\">Payments</span></a></li>\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'warehouse'\"><a mat-button [routerLink]=\"['/app/tax/product-tax']\"><i class=\"nav-icon material-icons\">attach_money</i><span class=\"nav-text\">Tax</span></a></li>\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'warehouse'\"><a mat-button [routerLink]=\"['/app/currency/payment-currency']\"><i class=\"nav-icon material-icons\">attach_money</i><span class=\"nav-text\">Multi-Currency</span></a></li>\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'warehouse'\"><a mat-button [routerLink]=\"['/app/eif/eif-configurations']\"><i class=\"nav-icon material-icons\">domain</i><span class=\"nav-text\">ERP Integrations</span></a></li>\n            <!--    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer' && api.getADPCustomerType().toLowerCase() != 'warehouse'\"><a mat-button [routerLink]=\"['/app/product-discount/discounts-criteria']\"><i class=\"nav-icon material-icons\">shop_outline</i><span class=\"nav-text\"> Discount</span></a></li>-->\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button href=\"#/app/menu\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">Lookups</span></a>\n                <ul>\n                    <li *ngFor=\"let list of listGroups\"><a mat-button routerLink=\"/app/lookups/{{list.alias}}\"><i class=\"nav-icon material-icons\">{{list.icon}}</i><span class=\"nav-text\">{{list.name}}</span></a></li>\n                </ul>\n            </li>\n            <!-- <li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">person</i><span class=\"nav-text\">IntelliRep Users</span></a></li> -->\n        </ul>\n    </li>\n    <li  *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/branding/home']\"><i class=\"nav-icon material-icons\">grade</i><span class=\"nav-text\">Branding</span></a></li>\n    <li *ngIf=\"api.isloggedInUserAdmin()\">\n        <a mat-button  [routerLink]=\"['/app/billing/home']\"><i class=\"nav-icon material-icons\">attach_money</i><span class=\"nav-text\">Billing</span></a>\n        <!--<ul>-->\n        <!--<li><a mat-button [routerLink]=\"['/app/company/home']\"><i class=\"nav-icon material-icons\">business</i><span class=\"nav-text\">Company Profile</span></a></li>-->\n        <!--<li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">person</i><span class=\"nav-text\">IntelliRep Users</span></a></li>-->\n        <!--</ul>-->\n    </li>\n\n\n\n\n\n\n\n\n    <!-- <li><a mat-button (click)=\"logout()\"><i class=\"nav-icon material-icons\">exit_to_app</i><span class=\"nav-text\">Logout</span></a></li> -->\n    <!-- <li>\n      <a mat-button href=\"#/app/ui\"><i class=\"nav-icon material-icons\">bubble_chart</i><span class=\"nav-text\">UI Kit</span></a>\n      <ul>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/typography']\"><span>Typography</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/buttons']\"><span>Buttons</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/icons']\"><span>Icons</span><span class=\"badge badge-pill badge-info\">2</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/cards']\"><span>Cards</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/icon-boxes']\"><span>Icon Boxes</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/components']\"><span>Components</span><span class=\"badge badge-pill badge-danger\">12</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/hover']\"><span>Hover</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/feature-callouts']\"><span>Feature Callouts</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/lists']\"><span>Lists</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/sashes']\"><span>Sashes</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/testimonials']\"><span>Testimonials</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/pricing-tables']\"><span>Pricing Tables</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/call-to-actions']\"><span>Call to Actions</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/timeline']\"><span>Timeline</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/boxes']\"><span>Boxes</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/grids']\"><span>Grids</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/color']\"><span>Color</span></a></li>\n      </ul>\n    </li> -->\n\n    <!--\n      <li>\n        <a mat-button href=\"#/app/form\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">Products</span></a>\n        <ul>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/input']\"><span>Input</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/checkbox']\"><span>Checkbox</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/radio-button']\"><span>Radio Button</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/chips']\"><span>Chips</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/select']\"><span>Select</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/slide-toggle']\"><span>Slide Toggle</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/slider']\"><span>Slider</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/components']\"><span>Components</span><span class=\"badge badge-pill badge-info\">9</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/layouts']\"><span>Form Layouts</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/validation']\"><span>Form Validation</span></a></li>\n        </ul>\n      </li> -->\n\n\n\n\n\n\n\n\n\n    <!--   <li>\n        <a mat-button href=\"#/app/form\"><i class=\"nav-icon material-icons\">view_week</i><span class=\"nav-text\">Categories</span></a>\n        <ul>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/input']\"><span>Input</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/checkbox']\"><span>Checkbox</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/radio-button']\"><span>Radio Button</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/chips']\"><span>Chips</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/select']\"><span>Select</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/slide-toggle']\"><span>Slide Toggle</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/slider']\"><span>Slider</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/components']\"><span>Components</span><span class=\"badge badge-pill badge-info\">9</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/layouts']\"><span>Form Layouts</span></a></li>\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/validation']\"><span>Form Validation</span></a></li>\n        </ul>\n      </li>\n     -->\n\n\n\n\n\n    <!-- <li>\n      <a mat-button href=\"#/app/table\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">Products</span></a>\n      <ul>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/table/static']\"><span>Static Tables</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/table/responsive']\"><span>Responsive Tables</span></a></li>\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/table/data-table']\"><span>Data Tables</span></a></li>\n      </ul>\n    </li> -->\n    <!--<li>-->\n    <!--<a mat-button href=\"#/app/chart\"><i class=\"nav-icon material-icons\">equalizer</i><span class=\"nav-text\">Charts</span></a>-->\n    <!--<ul>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/line']\">Line &amp; Area</a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/bar']\">Bar</a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/pie']\">Pie</a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/scatter']\">Scatter</a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/radar']\">Radar</a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/funnel']\">Funnel</a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/more']\">More</a></li>-->\n    <!--</ul>-->\n    <!--</li>-->\n    <!--  <li class=\"nav-divider\"></li>\n     <li>\n       <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">content_copy</i><span class=\"nav-text\">Pages</span></a>\n       <ul>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/about']\">About</a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/services']\">Services</a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/contact']\">Contact</a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/careers']\">Careers</a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/blog']\">Blog</a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/faqs']\">FAQs</a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/terms']\">Terms of Service</a></li>\n       </ul>\n     </li>\n\n     <li>\n       <a mat-button href=\"#/extra\"><i class=\"nav-icon material-icons\">more_horiz</i><span class=\"nav-text\">Extra Pages</span></a>\n       <ul>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/login']\"><span>Login</span></a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/sign-up']\"><span>Sign Up</span></a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/forgot-password']\"><span>Forgot Password</span></a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/confirm-email']\"><span>Confirm Email</span></a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/lock-screen']\"><span>Lock Screen</span></a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/404']\"><span>404 Error</span></a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/500']\"><span>500 Error</span></a></li>\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/maintenance']\"><span>Maintenance</span></a></li>\n       </ul>\n     </li>\n\n\n\n     <li><a mat-button (click)=\"logout()\"><i class=\"nav-icon material-icons\">exit_to_app</i><span class=\"nav-text\">Logout</span></a></li> -->\n\n    <!--<li>-->\n    <!--<a mat-button href=\"#/app/pglayout\"><i class=\"nav-icon material-icons\">view_array</i><span class=\"nav-text\">Page Layouts</span></a>-->\n    <!--<ul>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/pglayout/full-width']\"><span>Full Width</span></a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/pglayout/centered']\"><span>Centered</span></a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/fullscreen']\"><span>Fullscreen</span></a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/pglayout/with-tabs']\"><span>With Tabs</span></a></li>-->\n    <!--</ul>-->\n    <!--</li>-->\n    <!--<li>-->\n    <!--<a mat-button href=\"#/app/ecommerce\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">eCommerce</span></a>-->\n    <!--<ul>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ecommerce/products']\"><span>Products</span></a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ecommerce/horizontal-products']\"><span>Products (Horizontal)</span></a></li>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ecommerce/invoice']\"><span>Invoice</span></a></li>-->\n    <!--</ul>-->\n    <!--</li>-->\n    <!--<li>-->\n    <!--<a mat-button href=\"#/app/menu\"><i class=\"nav-icon material-icons\">sort</i><span class=\"nav-text\">Menu Levels</span></a>-->\n    <!--<ul>-->\n    <!--<li><a mat-button class=\"md-button prepend-icon\" href=\"javascript:;\"><span>Level 1</span></a></li>-->\n    <!--<li>-->\n    <!--<a mat-button class=\"md-button prepend-icon\" href=\"javascript:;\"><span>Level 1</span></a>-->\n    <!--<ul>-->\n    <!--<li><a mat-button class=\"md-button\" href=\"javascript:;\"><span>Level 2</span></a></li>-->\n    <!--<li>-->\n    <!--<a mat-button class=\"md-button\" href=\"javascript:;\"><span>Level 2</span></a>-->\n    <!--<ul>-->\n    <!--<li><a mat-button class=\"md-button\" href=\"javascript:;\"><span>Level 3</span></a></li>-->\n    <!--<li><a mat-button class=\"md-button\" href=\"javascript:;\"><span>Level 3</span></a></li>-->\n    <!--</ul>-->\n    <!--</li>-->\n    <!--</ul>-->\n    <!--</li>-->\n    <!--</ul>-->\n    <!--</li>-->\n    <!--<li class=\"nav-divider\"></li>-->\n    <!--<li class=\"li-small\"><a mat-button [routerLink]=\"['/app/form/components']\"><i class=\"nav-icon nav-dot material-icons color-info\">fiber_manual_record</i><span class=\"nav-text\">Form Components</span></a></li>-->\n    <!--<li class=\"li-small\"><a mat-button [routerLink]=\"['/app/ui/components']\"><i class=\"nav-icon nav-dot material-icons color-success\">fiber_manual_record</i><span class=\"nav-text\">UI Components</span></a></li>-->\n    <!--<li class=\"li-small\"><a mat-button href=\"http://iarouse.com/dist-angular-material/landing/\" target=\"_blank\"><i class=\"nav-icon nav-dot material-icons color-danger\">fiber_manual_record</i><span class=\"nav-text\">Material Landing</span></a></li>-->\n</ul>\n"

/***/ }),

/***/ 1331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


var AccordionNavDirective = /** @class */ (function () {
    function AccordionNavDirective(el) {
        this.el = el;
    }
    AccordionNavDirective.prototype.ngAfterViewInit = function () {
        // on click, open it's own ul, close sibling li opened ul & sub ul
        // on click, close it's own ul & sub ul
        var $nav = $(this.el.nativeElement);
        var slideTime = 250;
        var $lists = $nav.find('ul').parent('li');
        $lists.append('<i class="material-icons icon-has-ul">arrow_drop_down</i>');
        var $As = $lists.children('a');
        // Disable a link that has ul
        $As.on('click', function (event) {
            event.preventDefault();
        });
        // Accordion nav
        $nav.on('click', function (e) {
            var target = e.target;
            var $parentLi = $(target).closest('li'); // closest, insead of parent, so it still works when click on i icons
            if (!$parentLi.length) {
                return;
            } // return if doesn't click on li
            var $subUl = $parentLi.children('ul');
            // let depth = $subUl.parents().length; // but some li has no sub ul, so...
            var depth = $parentLi.parents().length + 1;
            // filter out all elements (except target) at current depth or greater
            var allAtDepth = $nav.find('ul').filter(function () {
                if ($(this).parents().length >= depth && this !== $subUl.get(0)) {
                    return true;
                }
            });
            allAtDepth.slideUp(slideTime).closest('li').removeClass('open');
            // Toggle target
            if ($parentLi.has('ul').length) {
                $parentLi.toggleClass('open');
            }
            $subUl.stop().slideToggle(slideTime);
        });
    };
    AccordionNavDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myAccordionNav]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], AccordionNavDirective);
    return AccordionNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppendSubmenuIconDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


var AppendSubmenuIconDirective = /** @class */ (function () {
    function AppendSubmenuIconDirective(el) {
        this.el = el;
    }
    AppendSubmenuIconDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        $el.find('.prepend-icon').prepend('<i class="material-icons">keyboard_arrow_right</i>');
    };
    AppendSubmenuIconDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myAppendSubmenuIcon]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], AppendSubmenuIconDirective);
    return AppendSubmenuIconDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightActiveItemsDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(65);




var HighlightActiveItemsDirective = /** @class */ (function () {
    function HighlightActiveItemsDirective(el, location, router) {
        this.el = el;
        this.location = location;
        this.router = router;
    }
    HighlightActiveItemsDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        var $links = $el.find('a');
        function highlightActive(links) {
            var path = location.hash;
            // console.log(path);
            links.each(function (i, link) {
                var $link = $(link);
                var $li = $link.parent('li');
                var href = $link.attr('href');
                // console.log(href);
                if ($li.hasClass('active')) {
                    $li.removeClass('active');
                }
                if (path.indexOf(href) === 0) {
                    $li.addClass('active');
                }
            });
        }
        highlightActive($links);
        this.router.events.subscribe(function (evt) {
            if (!(evt instanceof __WEBPACK_IMPORTED_MODULE_3__angular_router__["c" /* NavigationEnd */])) {
                return;
            }
            highlightActive($links);
        });
    };
    HighlightActiveItemsDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myHighlightActiveItems]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_3__angular_router__["f" /* Router */]])
    ], HighlightActiveItemsDirective);
    return HighlightActiveItemsDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppCustomizerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_service__ = __webpack_require__(112);




var AppCustomizerComponent = /** @class */ (function () {
    function AppCustomizerComponent(layoutService) {
        var _this = this;
        this.layoutService = layoutService;
        this.onLayoutChange = function () {
            _this.layoutService.updateEChartsState(true);
        };
    }
    AppCustomizerComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    AppCustomizerComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-customizer',
            styles: [],
            template: __webpack_require__(1335),
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__layout_service__["a" /* LayoutService */]])
    ], AppCustomizerComponent);
    return AppCustomizerComponent;
}());



/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

module.exports = "<section class=\"quickview-wrapper customizer d-none d-lg-block d-xl-block\" id=\"quickview-customizer\">\n  <a class=\"customizer-close\" href=\"javascript:;\" myToggleQuickview=\"customizer\"><span class=\"material-icons\">close</span></a>\n  <a class=\"customizer-toggle\" href=\"javascript:;\" myToggleQuickview=\"customizer\"><span class=\"material-icons\">settings</span></a>\n\n  <div class=\"quickview-inner\" mySlimScroll>\n    <div>\n      <p class=\"customizer-header\">Customizer</p>\n      <p class=\"small no-margin\">Customize and preview in real time.</p>\n\n      <div class=\"divider divider-lg divider-solid\"></div>\n      <h4 class=\"section-header\">Layout Options</h4>\n      <div class=\"divider divider-sm\"></div>\n      <mat-list>\n        <mat-list-item>\n          <p>Fixed Header</p>\n          <mat-slide-toggle class=\"mat-secondary\" [(ngModel)]=\"AppConfig.fixedHeader\"></mat-slide-toggle>\n        </mat-list-item>\n        <mat-list-item>\n          <p>Collapsed Sidebar</p>\n          <mat-slide-toggle class=\"mat-secondary\" [(ngModel)]=\"AppConfig.navCollapsed\" (change)=\"onLayoutChange()\"></mat-slide-toggle>\n        </mat-list-item>\n        <mat-list-item>\n          <p>Full Width Header</p>\n          <mat-slide-toggle class=\"mat-secondary\" [(ngModel)]=\"AppConfig.navBehind\"></mat-slide-toggle>\n        </mat-list-item>\n        <mat-list-item>\n          <p>Boxed Layout</p>\n          <mat-slide-toggle class=\"mat-secondary\" [(ngModel)]=\"AppConfig.layoutBoxed\" (change)=\"onLayoutChange()\"></mat-slide-toggle>\n        </mat-list-item>\n        <mat-list-item>\n          <p>Sidebar Width</p>\n          <mat-select class=\"no-margin\" style=\"width: 80px;\" [(ngModel)]=\"AppConfig.sidebarWidth\" (change)=\"onLayoutChange()\">\n            <mat-option value=\"small\">small</mat-option>\n            <mat-option value=\"middle\" >middle</mat-option>\n            <mat-option value=\"large\" >large</mat-option>\n          </mat-select>\n        </mat-list-item>\n      </mat-list>\n\n\n      <div class=\"divider divider-lg divider-solid\"></div>\n      <h4 class=\"section-header\">Color Options</h4>\n      <p class=\"small no-margin\">Tip: Additionally, you can active \"Full Width Header\" above</p>\n      <div class=\"divider\"></div>\n      <div class=\"row\">\n        <div class=\"col-4\">\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"11\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-dark item-header\"></span>\n              <span class=\"bg-color-light item-header\"></span>\n              <span class=\"bg-color-dark\"></span>\n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"12\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-primary item-header\"></span>\n              <span class=\"bg-color-light item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"13\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-success item-header\"></span>\n              <span class=\"bg-color-light item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"14\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-info item-header\"></span>\n              <span class=\"bg-color-light item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"15\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-warning item-header\"></span>\n              <span class=\"bg-color-light item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"16\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-danger item-header\"></span>\n              <span class=\"bg-color-light item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n        </div>\n\n        <div class=\"col-4\">\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"21\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-light item-header\"></span>\n              <span class=\"bg-color-light item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"22\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-primary item-header\"></span>\n              <span class=\"bg-color-primary item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"23\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-success item-header\"></span>\n              <span class=\"bg-color-success item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"24\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-info item-header\"></span>\n              <span class=\"bg-color-info item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"25\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-warning item-header\"></span>\n              <span class=\"bg-color-warning item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"26\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-danger item-header\"></span>\n              <span class=\"bg-color-danger item-header\"></span>\n              <span class=\"bg-color-dark\"></span> \n            </span>\n          </label>                 \n        </div>\n        <div class=\"col-4\">\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"31\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-dark item-header\"></span>\n              <span class=\"bg-color-dark item-header\"></span>\n              <span class=\"bg-color-light\"></span> \n            </span>\n          </label> \n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"32\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-primary item-header\"></span>\n              <span class=\"bg-color-primary item-header\"></span>\n              <span class=\"bg-color-light\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"33\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-success item-header\"></span>\n              <span class=\"bg-color-success item-header\"></span>\n              <span class=\"bg-color-light\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"34\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-info item-header\"></span>\n              <span class=\"bg-color-info item-header\"></span>\n              <span class=\"bg-color-light\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"35\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-warning item-header\"></span>\n              <span class=\"bg-color-warning item-header\"></span>\n              <span class=\"bg-color-light\"></span> \n            </span>\n          </label>\n          <label class=\"color-option-check\">\n            <input type=\"radio\" name=\"color\" value=\"36\" [(ngModel)]=\"AppConfig.colorOption\">\n            <span class=\"color-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span class=\"bg-color-danger item-header\"></span>\n              <span class=\"bg-color-danger item-header\"></span>\n              <span class=\"bg-color-light\"></span> \n            </span>\n          </label>                 \n        </div>\n      </div>\n\n\n\n      <div class=\"divider divider-lg divider-solid\"></div>\n      <h4 class=\"section-header\">Theme Options</h4>\n      <div class=\"divider\"></div>\n\n      <div class=\"row no-margin theme-options clearfix\">\n        <div class=\"col-4\">\n          <label class=\"theme-option-check\">\n            <input type=\"radio\" name=\"theme\" value=\"dark\" [(ngModel)]=\"AppConfig.theme\">\n            <span class=\"theme-option-item bg-color-dark\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span>Dark</span>\n            </span>\n          </label>\n        </div>\n        <div class=\"col-4\">\n          <label class=\"theme-option-check\">\n            <input type=\"radio\" name=\"theme\" value=\"gray\" [(ngModel)]=\"AppConfig.theme\">\n            <span class=\"theme-option-item bg-color-gray\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span>Gray</span>\n            </span>\n          </label>\n        </div>\n        <div class=\"col-4\">\n          <label class=\"theme-option-check\">\n            <input type=\"radio\" name=\"theme\" value=\"light\" [(ngModel)]=\"AppConfig.theme\">\n            <span class=\"theme-option-item bg-color-page\">\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n              <span>Light</span>\n            </span>\n          </label>\n        </div>\n      </div>\n      <div class=\"divider divider-lg divider-solid\"></div>\n      <div class=\"text-right\">\n        <a target=\"_blank\" [href]=\"AppConfig.productLink\">Download it Now</a>\n      </div>\n\n    </div>\n  </div>\n</section>"

/***/ }),

/***/ 1336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleQuickviewDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


var ToggleQuickviewDirective = /** @class */ (function () {
    function ToggleQuickviewDirective(el) {
        this.el = el;
    }
    ToggleQuickviewDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        var $body = $('#body');
        var target = this.myToggleQuickview;
        var qvClass = 'quickview-open';
        if (target) {
            qvClass = qvClass + '-' + target;
        }
        $el.on('click', function (e) {
            $body.toggleClass(qvClass);
            e.preventDefault();
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", String)
    ], ToggleQuickviewDirective.prototype, "myToggleQuickview", void 0);
    ToggleQuickviewDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myToggleQuickview]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], ToggleQuickviewDirective);
    return ToggleQuickviewDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppFooterComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__version__ = __webpack_require__(537);




var AppFooterComponent = /** @class */ (function () {
    function AppFooterComponent() {
    }
    AppFooterComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
        this.version = __WEBPACK_IMPORTED_MODULE_3__version__["a" /* Version */];
    };
    AppFooterComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-footer',
            styles: [],
            template: __webpack_require__(1338)
        })
    ], AppFooterComponent);
    return AppFooterComponent;
}());



/***/ }),

/***/ 1338:
/***/ (function(module, exports) {

module.exports = "<section class=\"app-footer\">\n  <div class=\"container-fluid\">\n    <span class=\"float-left\">\n      <span>Copyright © {{AppConfig.brand}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Version {{version}}</span>\n    </span>\n    <!-- <span class=\"float-right\">\n      <span>Built with Love <i class=\"material-icons\">favorite_border</i></span>\n    </span> -->\n  </div>\n</section>\n"

/***/ }),

/***/ 1339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSearchOverlayComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


var AppSearchOverlayComponent = /** @class */ (function () {
    function AppSearchOverlayComponent() {
    }
    AppSearchOverlayComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-search-overlay',
            styles: [],
            template: __webpack_require__(1340)
        })
    ], AppSearchOverlayComponent);
    return AppSearchOverlayComponent;
}());



/***/ }),

/***/ 1340:
/***/ (function(module, exports) {

module.exports = "<section class=\"app-overlay\" mySearchOverlay>\n  <div class=\"app-overlay-inner\">\n    <div class=\"overlay-header\">\n      <a href=\"javascript:;\" id=\"overlay-close\" class=\"overlay-close\">\n        <i class=\"material-icons\">close</i>\n      </a>\n    </div>\n    <div class=\"overlay-content\">\n      <input id=\"overlay-search-input\"\n           class=\"overlay-search-input\" \n           placeholder=\"Search...\"\n           >\n\n      <div class=\"text-small text-muted\">\n        <span>Press <em>Esc</em> key to dismiss</span>\n      </div>\n    </div>\n  </div>\n</section>\n"

/***/ }),

/***/ 1341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchOverlayDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_service__ = __webpack_require__(112);



var SearchOverlayDirective = /** @class */ (function () {
    function SearchOverlayDirective(el, layoutService) {
        var _this = this;
        this.el = el;
        this.layoutService = layoutService;
        this.subscription = layoutService.searchOverlayState$.subscribe(function (state) {
            _this.updateSearchOverlay(state);
        });
    }
    SearchOverlayDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.$el = $(this.el.nativeElement);
        this.$body = $('#body');
        this.$searchInput = this.$el.find('#overlay-search-input');
        this.$closeOverlayBtn = this.$el.find('#overlay-close');
        this.$el.on('keyup', function (e) {
            if (e.keyCode === 27) { // when ESC is pressed
                _this.closeOverlay();
            }
        });
        this.$closeOverlayBtn.on('click', function (e) {
            _this.closeOverlay();
            e.preventDefault();
        });
    };
    SearchOverlayDirective.prototype.openOverlay = function () {
        var _this = this;
        this.$body.addClass('overlay-active');
        // [delay] should >= `visibility` transition duration in CSS, see _overlay.scss
        // otherwise auto-focus won't work since element is not there yet
        if (this.$searchInput) {
            setTimeout(function () {
                _this.$searchInput.focus();
            }, 301);
        }
    };
    SearchOverlayDirective.prototype.closeOverlay = function () {
        this.$body.removeClass('overlay-active');
        if (this.$searchInput) {
            this.$searchInput.val(function () {
                return this.defaultValue;
            });
        }
    };
    SearchOverlayDirective.prototype.updateSearchOverlay = function (state) {
        if (state === 'open') {
            this.openOverlay();
        }
    };
    SearchOverlayDirective.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    SearchOverlayDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[mySearchOverlay]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__layout_service__["a" /* LayoutService */]])
    ], SearchOverlayDirective);
    return SearchOverlayDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenSearchOverlaylDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_service__ = __webpack_require__(112);



var OpenSearchOverlaylDirective = /** @class */ (function () {
    function OpenSearchOverlaylDirective(el, layoutService) {
        this.el = el;
        this.layoutService = layoutService;
    }
    OpenSearchOverlaylDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        var $el = $(this.el.nativeElement);
        var $body = $('#body');
        $el.on('click', function (e) {
            _this.openOverlay();
        });
    };
    OpenSearchOverlaylDirective.prototype.openOverlay = function () {
        this.layoutService.updateSearchOverlayState('open');
    };
    OpenSearchOverlaylDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myOpenSearchOverlay]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__layout_service__["a" /* LayoutService */]])
    ], OpenSearchOverlaylDirective);
    return OpenSearchOverlaylDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiBilling; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);




var ApiBilling = /** @class */ (function () {
    function ApiBilling(http) {
        this.http = http;
        this.setURLS();
    }
    ApiBilling.prototype.get = function (endpoint, params, reqOpts) {
        if (!reqOpts) {
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]();
        }
        // {headers: new HttpHeaders({'Content-Type': 'application/json'})}
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (var k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }
        return this.http.get(this.url + '/' + endpoint, reqOpts);
        // return this.http.get('http://localhost:8088/api/v1' + '/' + endpoint, reqOpts);
    };
    ApiBilling.prototype.post = function (endpoint, body, reqOpts) {
        return this.http.post(this.url + '/' + endpoint, body, reqOpts);
    };
    ApiBilling.prototype.put = function (endpoint, body, reqOpts) {
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    };
    ApiBilling.prototype.delete = function (endpoint, reqOpts) {
        return this.http.delete(this.url + '/' + endpoint, reqOpts);
    };
    ApiBilling.prototype.patch = function (endpoint, body, reqOpts) {
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    };
    ApiBilling.prototype.setURLS = function () {
        this.url = localStorage.getItem("billingApiUrl");
        // this.url = APPCONFIG.ApiURL_billing;
    };
    ApiBilling.prototype.checkIsLicensedSubscribedAndLimit = function () {
    };
    ApiBilling = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */]])
    ], ApiBilling);
    return ApiBilling;
}());



/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SharedModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__echarts_directive__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slim_scroll_directive__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_file_drop__ = __webpack_require__(1312);





var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_2__echarts_directive__["a" /* EChartsDirective */],
                __WEBPACK_IMPORTED_MODULE_3__slim_scroll_directive__["a" /* SlimScrollDirective */],
                __WEBPACK_IMPORTED_MODULE_4__directives_file_drop__["a" /* FileDropDirective */]
            ],
            exports: [
                __WEBPACK_IMPORTED_MODULE_2__echarts_directive__["a" /* EChartsDirective */],
                __WEBPACK_IMPORTED_MODULE_3__slim_scroll_directive__["a" /* SlimScrollDirective */],
                __WEBPACK_IMPORTED_MODULE_4__directives_file_drop__["a" /* FileDropDirective */]
            ]
        })
    ], SharedModule);
    return SharedModule;
}());



/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthGuardService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_restrictedAccesss_component__ = __webpack_require__(446);







var AuthGuardService = /** @class */ (function () {
    function AuthGuardService(router, api, dialog) {
        this.router = router;
        this.api = api;
        this.dialog = dialog;
    }
    AuthGuardService.prototype.canLoad = function (route) {
        console.log("inside canLoad", route);
        if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') && localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') == 'true') {
            console.log("inside loading permission");
            return true;
        }
        console.log("user is not logged in for guard");
        return false;
    };
    AuthGuardService.prototype.canActivate = function (route, state) {
        // alert("activate route snap shot "  + ActivatedRouteSnapshot + " RouterStateSnapshot " + RouterStateSnapshot  ) ;
        var url = state.url;
        console.log('Url:' + url);
        if (this.api.isloggedInUserAdmin() || this.checkIsUrlIsSaleOrder(url)) {
            console.log("activated Route");
            return true;
        }
        console.log("Deactivated Route");
        this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__layout_restrictedAccesss_component__["a" /* RestrictedAccessComponent */]);
        return false;
    };
    AuthGuardService.prototype.checkIsUrlIsSaleOrder = function (url) {
        if (this.api.isloggedInUserSaleRep() && url === "/app/transactions/saleOrder") {
            return true;
        }
        else
            return false;
    };
    AuthGuardService = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */], __WEBPACK_IMPORTED_MODULE_4__api__["a" /* Api */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["i" /* MatDialog */]])
    ], AuthGuardService);
    return AuthGuardService;
}());



/***/ }),

/***/ 332:
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 332;

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutFullscreenComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


// Children of AppModule instead of AppMainModule
var PageLayoutFullscreenComponent = /** @class */ (function () {
    function PageLayoutFullscreenComponent() {
    }
    PageLayoutFullscreenComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-page-layout-fullscreen',
            styles: [],
            template: __webpack_require__(754)
        })
    ], PageLayoutFullscreenComponent);
    return PageLayoutFullscreenComponent;
}());



/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutModule", function() { return LayoutModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_routing_module__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_shared_module__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_restrictedAccesss_component__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(59);







var LayoutModule = /** @class */ (function () {
    function LayoutModule() {
    }
    LayoutModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MatButtonModule */],
                __WEBPACK_IMPORTED_MODULE_2__layout_routing_module__["a" /* LayoutRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_3__shared_shared_module__["a" /* SharedModule */],
                __WEBPACK_IMPORTED_MODULE_4_ng2_toastr__["ToastModule"].forRoot(),
            ],
            declarations: [__WEBPACK_IMPORTED_MODULE_5__layout_restrictedAccesss_component__["a" /* RestrictedAccessComponent */]],
            entryComponents: [__WEBPACK_IMPORTED_MODULE_5__layout_restrictedAccesss_component__["a" /* RestrictedAccessComponent */]]
        })
    ], LayoutModule);
    return LayoutModule;
}());



/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RestrictedAccessComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(59);



// openDialogWithAResult
var RestrictedAccessComponent = /** @class */ (function () {
    function RestrictedAccessComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    RestrictedAccessComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'restricted-access',
            template: "<h4 md-dialog-title style=\"align-items: center\">Restricted Access!</h4>\n    <div md-dialog-content style=\"padding-bottom: 20px;\">Only Admins are allowed to navigate into this section? </div>\n    <div md-dialog-actions>\n          <button mat-raised-button   (click)=\"dialogRef.close()\">OK</button>\n    </div>",
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["k" /* MatDialogRef */]])
    ], RestrictedAccessComponent);
    return RestrictedAccessComponent;
}());



/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular2_json2csv__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular2_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular2_json2csv__);






var LayoutComponent = /** @class */ (function () {
    function LayoutComponent(toastr, vcr) {
        this.toastr = toastr;
        this.logedin = false;
        this.toastr.setRootViewContainerRef(vcr);
        var lg = this.getIsLoggedIn();
        if (lg && lg == 'true') {
            this.logedin = true;
        }
        else {
            this.logedin = false;
        }
    }
    LayoutComponent.prototype.getIsLoggedIn = function () {
        return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].prefix + "isLoggedIn");
    };
    LayoutComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-layout',
            template: __webpack_require__(1010),
            providers: [__WEBPACK_IMPORTED_MODULE_4_angular2_json2csv__["CsvService"]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2_ng2_toastr__["ToastsManager"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"]])
    ], LayoutComponent);
    return LayoutComponent;
}());



/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmCreateCustomerWithExistingNameComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(59);



// openDialogWithAResult
var ConfirmCreateCustomerWithExistingNameComponent = /** @class */ (function () {
    function ConfirmCreateCustomerWithExistingNameComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    ConfirmCreateCustomerWithExistingNameComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'confirm-deleteLocation-dialog',
            template: "<h4 md-dialog-title>Warning!</h4>\n  <div md-dialog-content style=\"padding-bottom: 20px;\">Customer with same company name already exist. <br> Do you want to continue creating?</div>\n  <div md-dialog-actions>\n    <button mat-button (click)=\"dialogRef.close('cancel')\">No</button>\n    <button mat-button (click)=\"dialogRef.close('confirm')\">Yes</button>\n  </div>",
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["k" /* MatDialogRef */]])
    ], ConfirmCreateCustomerWithExistingNameComponent);
    return ConfirmCreateCustomerWithExistingNameComponent;
}());



/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = utcDateConverter;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPCONFIG; });
function makeAppConfig() {
    var date = new Date();
    var year = date.getFullYear();
    // var GA_MK_version = "1.1.8";
    var AppConfig = {
        companyName: "Jazzba Inc.",
        addressLine1: "2010 Winston Park Drive",
        addressLine2: "Suit 200",
        city: "Oakville",
        state: "Ontario",
        zip: "L6H 5R7",
        countryAbbr: "US",
        country: "Canada",
        tollFree: "+1-888-305-5552",
        webSite: "jazzba.io",
        businessTaxNumber: "BN#762538916",
        salesKey: "123",
        // TODO: local urls
        //imagesBaseUrl: "https://anydatapoint.net/",
        imagesBaseUrl: "https://anydatapoint.net/",
        brandingFolder: "branding",
        /* ****************************************************************************
         *                                                                            *
         *    Set Following Variable for the LOCAL, DEV and COMMERCIAL environment    *
         *                      0                                                      *
         * ****************************************************************************/
        ENVIRONMENT: "COMMERCIAL",
        /*URL Set For Local Environment*/
        LOCAL_RA_SERVICE: "https://raservice.jazzba.io/",
        LOCAL_CATALYST_SERVICE: "https://catalystservice.jazzba.io/api/v1/",
        LOCAL_CATALYST_APP: "https://catalyst.jazzba.io/",
        /*URL Set For DEV Environment*/
        // DEV CONFIGURATION
        DEV_RA_SERVICE: "https://raservice.jazzba.io/",
        DEV_CATALYST_SERVICE: "https://catalystservice.jazzba.io/api/v1/",
        DEV_CATALYST_APP: "https://catalyst.jazzba.io/",
        /*URL Set For COMMERCIAL Environment*/
        COMMERCIAL_RA_SERVICE: "https://raservice.jazzba.io/",
        COMMERCIAL_CATALYST_SERVICE: "https://catalystservice.jazzba.io/api/v1/",
        COMMERCIAL_CATALYST_APP: "https://catalyst.jazzba.io/",
        RA_SERVICE_API: "https://raservice.jazzba.io/",
        ApiURL_billing: "https://adppayus.jazzba.io/api/v1",
        WareHouseUrl: "https://istockus.jazzba.io",
        ApiURL_dt: "https://dtapius.jazzba.io/api/v1",
        java_image_uploader_url: "https://imageuploaderca.jazzba.io/api/v1",
        Monthly_License_alias: "ims",
        webStore_License_alias: "ws",
        WebStore_License_price: 500,
        InventoryManagement_License_price: 500,
        EDI_Integrations_License_price: 0.6,
        EDI_Integrations_License_alias: "fulfilment-topup",
        ASN_License_alias: "asn",
        License_defaultTrialSubscription_Planid: "growing-business-trial-cad",
        chargebeeSiteName: "jazzba",
        chargebeeSiteApiKKey: "**secret**",
        prefix: "local",
        //Todo we want api  route grouping based on module[e.g intellicommerce intellistock, intellicatalog]?, version?, region, application server URLs
        // jazzba global scripts ++zopim
        zopim_subdomain: 'whiztec.zendesk.com',
        storeURL: "https://istoreus.jazzba.io/?custId=",
        iRepURL: "https://irepus.jazzba.io",
        imageCutterSizes: "80x80,400x400",
        brand: 'JAZZ',
        version: "2.5.264",
        user: 'Lisa',
        year: year,
        layoutBoxed: false,
        navCollapsed: false,
        navBehind: false,
        fixedHeader: false,
        sidebarWidth: 'middle',
        theme: 'light',
        colorOption: '11',
        AutoCloseMobileNav: true,
        productLink: '#'
        // productLink: 'https://themeforest.net/item/material-design-angular-2-admin-web-app-with-bootstrap-4/19421267'
    };
    return AppConfig;
}
function utcDateConverter(date) {
    return new Date(date).toDateString() + ' 00:00:00 GMT 0';
}
var APPCONFIG = makeAppConfig();


/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseFailureDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__providers_api__ = __webpack_require__(83);




// openDialogWithAResult
var LicenseFailureDialogComponent = /** @class */ (function () {
    function LicenseFailureDialogComponent(dialogRef, api, data) {
        this.dialogRef = dialogRef;
        this.api = api;
        this.data = data;
        this.message = "";
        // this.dialogRef.disableClose = true;
        this.message = data.message;
    }
    LicenseFailureDialogComponent.prototype.close = function (option) {
        if (option == 'option-0') {
            var result = { message: "ReRoute to Manage License" };
            this.dialogRef.close(result);
        }
        else if ('cross') {
            this.dialogRef.close();
        }
    };
    LicenseFailureDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'license-failure-dialog',
            template: __webpack_require__(1017)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __param */](2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MAT_DIALOG_DATA */])),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["k" /* MatDialogRef */], __WEBPACK_IMPORTED_MODULE_3__providers_api__["a" /* Api */], Object])
    ], LicenseFailureDialogComponent);
    return LicenseFailureDialogComponent;
}());



/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransactionConsumedDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__providers_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular2_csv__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular2_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular2_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__providers_api_billing__ = __webpack_require__(280);





// import {dateConverter, utcDateConverter} from "../../config";


var TransactionConsumedDialogComponent = /** @class */ (function () {
    function TransactionConsumedDialogComponent(apiBilling, matDialog, dialogRef, api) {
        this.apiBilling = apiBilling;
        this.matDialog = matDialog;
        this.dialogRef = dialogRef;
        this.api = api;
        this.isSupplierTransaction = 0;
        this.selectedSupplierUuid = "";
        this.years = ["2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030"];
        this.months = [{ id: 0, name: "January" },
            { id: 1, name: "February" },
            { id: 2, name: "March" },
            { id: 3, name: "April" },
            { id: 4, name: "May" },
            { id: 5, name: "June" },
            { id: 6, name: "July" },
            { id: 7, name: "August" },
            { id: 8, name: "September" },
            { id: 9, name: "October" },
            { id: 10, name: "November" },
            { id: 11, name: "December" }];
        this.customerType = "";
        this.fileIsOver = false;
        this.options = {};
        this.dialogRef.disableClose = true;
        var year = new Date().getFullYear();
        this.startDate = new Date(year, 0, 1);
        this.endDate = new Date();
        this.isSupplierTransaction = __WEBPACK_IMPORTED_MODULE_3__providers_api__["b" /* ApplicationVariables */].supplierTransaction;
        this.selectedSupplierUuid = __WEBPACK_IMPORTED_MODULE_3__providers_api__["b" /* ApplicationVariables */].selectedSupplierUuid;
        this.customerType = localStorage.getItem("customerType");
    }
    TransactionConsumedDialogComponent.prototype.fileOver = function (fileIsOver) {
        this.fileIsOver = fileIsOver;
    };
    TransactionConsumedDialogComponent.prototype.downloadTemplate = function () {
        var _this = this;
        if (this.selectedYear === undefined || this.selectedYear === "") {
            this.api.toastMsg("Please select year first", "");
            return;
        }
        if (this.selectedMonth === undefined || this.selectedMonth === "") {
            this.api.toastMsg("Please select month first", "");
            return;
        }
        // alert("UD")
        // alert("start" + dateConverter(this.startDate))
        // alert("endDate" + dateConverter(this.endDate))
        // let from = dateConverter(this.startDate);
        // let to = dateConverter(this.endDate);
        var month = this.selectedMonth.id; // January
        var d = new Date(parseInt(this.selectedYear), month + 1, 0).getDate();
        // alert(d.toString());
        // 2022-8-28
        var from = this.selectedYear + "-" + (this.selectedMonth.id + 1) + "-1";
        var to = this.selectedYear + "-" + (this.selectedMonth.id + 1) + "-" + d.toString();
        if (this.isSupplierTransaction) {
            this.apiBilling.get("lms/getTransactionsByDate?customerUUID=" + this.selectedSupplierUuid +
                "&startDate=" + from.toString() + "&endDate=" + to.toString() + "&linkedSystemUuid=" + localStorage.getItem("uuid")).subscribe(function (res) {
                var result = res.json();
                _this.generateTransactionsLogsForSupplier(result.data);
            });
        }
        else {
            // alert("inside else " + this.customerType)
            this.apiBilling.get("lms/getTransactionsByDate?customerUUID=" + this.api.getADPCustomerUUID() +
                "&startDate=" + from.toString() + "&endDate=" + to.toString() + "&linkedSystemUuid=").subscribe(function (res) {
                var result = res.json();
                if (_this.customerType === "Warehouse")
                    _this.generateTransactionsLogs(result.data);
                else
                    _this.generateTransactionsLogsForSupplier(result.data);
            });
        }
        // this.busy = this.api.get('orders/quickbook?todate='+from.toString()+'&fromdate='+to.toString())
        // .map(res=>res.text())
        // .subscribe(res=>{
        //   console.log('orders data', res);
        //   // console.log(js2xmlparser.parse("OrdersList", data));
        //   this.download('orders.csv', res);
        // }, err=>{
        //   alert('there is error in integration'+ err);
        // })
    };
    TransactionConsumedDialogComponent.prototype.generateTransactionsLogs = function (data) {
        console.log('first entry', data[0], "length", data.length);
        var exportObject = [];
        var transactionType = "";
        for (var i = 0, len = data.length; i < len; i++) {
            if (data[i].quantityConsumed > 0) {
                transactionType = "Consumed";
            }
            else if (data[i].quantityConsumed == 0)
                transactionType = "Purchased";
            // if(data[i].transactionType.includes("monthly")){
            // 	data[i].transactionType = "Intellistock - Inventory Management (Monthly)";
            // } else if (data[i].transactionType.includes("yearly")){
            // 	data[i].transactionType = "Intellistock - Inventory Management (Yearly)";
            // }else if (data[i].transactionType.includes("topup")){
            // 	data[i].transactionType = "Integrations EDI TopUp";
            // }
            var workOrder = null;
            if (data[i].workOrderJson != null && data[i].workOrderJson !== undefined) {
                workOrder = JSON.parse(data[i].workOrderJson);
            }
            // let workOrderSkus = []
            // if(workOrder.skusJson !== undefined)
            //   workOrderSkus  = JSON.parse(workOrder.skusJson);
            var Header = ['Serial No.', 'Transaction Time', 'Supplier Name', 'Plan Name', 'Transaction Type',
                'Quantity', 'Transaction Consumed',
                'Cost', 'Transaction Per Resource', 'Invoice No', 'Order Id', 'User Name'];
            // let obj = {
            //   SerialNo:i+1,
            //   TransactionTime: data[i].transactionTime,
            //   PlanName: data[i].transactionType,
            //   TransactionType:transactionType,
            //   TransactionsAmount: data[i].amount,
            //   QuantityPurchased: data[i].quantityPurchased,
            //   QuantityConsumed: data[i].quantityConsumed,
            //   QuantityBalance: data[i].quantityBalance,
            //   InvoiceNo: data[i].invoiceIdFormula,
            //   OrderId: data[i].orderId,
            //   UserName: data[i].userName
            // };
            // console.log(row);
            var obj = {
                SerialNo: i + 1,
                TransactionTime: data[i].transactionTime,
                supplierName: workOrder !== null || undefined ? workOrder.supplierName : "",
                PlanName: data[i].transactionType,
                TransactionType: transactionType,
                resourceQuantity: workOrder !== null || undefined ? this.checkIfUndefined(workOrder.skusCount) : "",
                QuantityConsumed: data[i].quantityConsumed,
                cost: this.checkIfUndefined(data[i].cost),
                transactionPerResource: workOrder !== null || undefined ? this.checkIfUndefined(workOrder.consumeTransactionTier1) : "",
                // TransactionsAmount: data[i].amount,
                QuantityBalance: data[i].quantityBalance,
                // QuantityPurchased: data[i].quantityPurchased,
                InvoiceNo: data[i].invoiceIdFormula,
                OrderId: data[i].orderId,
                UserName: data[i].userName
            };
            transactionType = "";
            exportObject.push(obj);
        }
        var filename = "Transactions Logs";
        this.downloadTransactionsLogs(filename, exportObject);
    };
    TransactionConsumedDialogComponent.prototype.downloadTransactionsLogs = function (filename, text) {
        var options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: false,
            useBom: true
        };
        // let Header = ['Serial No.','Transaction Time','Plan Name', 'Transaction Type','Amount ($)','Quantity','Consumed','Available Balance','Invoice No','Order Id', 'User Name'];
        var Header = ['Serial No.', 'Transaction Time', 'Supplier Name', 'Plan Name', 'Transaction Type', 'Quantity', 'Transaction Consumed', 'Cost', 'Transaction Per Resource', 'Available Balance', 'Invoice No', 'Order Id', 'User Name'];
        new __WEBPACK_IMPORTED_MODULE_4_angular2_csv__["Angular2Csv"](text, filename.split(".")[0], { headers: (Header) });
    };
    TransactionConsumedDialogComponent.prototype.checkIfUndefined = function (string) {
        if (string == undefined || string == null) {
            return "";
        }
        else {
            return string;
        }
    };
    TransactionConsumedDialogComponent.prototype.generateTransactionsLogsForSupplier = function (data) {
        console.log('first entry', data[0], "length", data.length);
        var exportObject = [];
        var transactionType = "";
        for (var i = 0, len = data.length; i < len; i++) {
            if (data[i].quantityConsumed > 0 && data[i].workOrderJson !== null && data[i].workOrderJson !== undefined && data[i].workOrderJson !== "") {
                //   transactionType ="Consumed";
                // } else if(data[i].quantityConsumed == 0) transactionType ="Purchased";
                // if(data[i].transactionType.includes("monthly")){
                // 	data[i].transactionType = "Intellistock - Inventory Management (Monthly)";
                // } else if (data[i].transactionType.includes("yearly")){
                // 	data[i].transactionType = "Intellistock - Inventory Management (Yearly)";
                // }else if (data[i].transactionType.includes("topup")){
                // 	data[i].transactionType = "Integrations EDI TopUp";
                // }
                var workOrder = JSON.parse(data[i].workOrderJson);
                var workOrderSkus = [];
                if (workOrder.skusJson !== undefined)
                    workOrderSkus = JSON.parse(workOrder.skusJson);
                var obj = void 0;
                if (this.customerType === "Supplier") {
                    obj = {
                        name: this.checkIfUndefined(workOrder.name),
                        referenceNo: this.checkIfUndefined(workOrder.referenceNo),
                        finishedAt: this.checkIfUndefined(data[i].transactionTime),
                        transactionConsumed: this.checkIfUndefined(data[i].quantityConsumed),
                        resourceQuantity: this.checkIfUndefined(workOrder.skusCount),
                        cost: this.checkIfUndefined(data[i].cost),
                        resourceType: this.checkIfUndefined(workOrder.resourceType),
                        transactionPerResource: this.checkIfUndefined(workOrder.consumeTransactionTier1),
                        resourceCount: this.checkIfUndefined(workOrderSkus.length),
                        a3plName: this.checkIfUndefined(workOrder.warehouseName),
                        sops: this.checkIfUndefined(workOrder.sopLogJson),
                        type: this.checkIfUndefined(workOrder.type),
                        createdAt: this.checkIfUndefined(workOrder.createdAt),
                        startedAt: this.checkIfUndefined(workOrder.startedAt),
                    };
                }
                else {
                    obj = {
                        name: this.checkIfUndefined(workOrder.name),
                        referenceNo: this.checkIfUndefined(workOrder.referenceNo),
                        finishedAt: this.checkIfUndefined(data[i].transactionTime),
                        transactionConsumed: this.checkIfUndefined(data[i].quantityConsumed),
                        resourceQuantity: this.checkIfUndefined(workOrder.skusCount),
                        cost: this.checkIfUndefined(data[i].cost),
                        resourceType: this.checkIfUndefined(workOrder.resourceType),
                        transactionPerResource: this.checkIfUndefined(workOrder.consumeTransactionTier1),
                        resourceCount: this.checkIfUndefined(workOrderSkus.length),
                        supplier: this.checkIfUndefined(workOrder.supplierName),
                        sops: this.checkIfUndefined(workOrder.sopLogJson),
                        type: this.checkIfUndefined(workOrder.type),
                        createdAt: this.checkIfUndefined(workOrder.createdAt),
                        startedAt: this.checkIfUndefined(workOrder.startedAt),
                    };
                }
                transactionType = "";
                exportObject.push(obj);
            }
        }
        var filename = "Transactions Logs";
        this.downloadTransactionsLogsForSupplier(filename, exportObject);
    };
    TransactionConsumedDialogComponent.prototype.downloadTransactionsLogsForSupplier = function (filename, text) {
        var options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: false,
            useBom: true
        };
        // let Header = ['Work Order Name','Work Order Type','Created At', 'Started At','Finished At','SOP','Reference #','Transaction Consumed','A3Pl Name','Cost'];
        var Header = ['Work Order Name', 'Reference #', 'Finished At', 'Transaction Consumed', 'Resource Quantity', 'Cost', 'Resource Type', 'Transaction Per Resource', 'Resource Count', 'A3PL', 'SOP', 'Service', 'Created At', 'Started At'];
        if (this.customerType !== "Supplier") {
            Header = ['Work Order Name', 'Reference #', 'Finished At', 'Transaction Consumed', 'Resource Quantity', 'Cost', 'Resource Type', 'Transaction Per Resource', 'Resource Count', 'Supplier', 'SOP', 'Service', 'Created At', 'Started At'];
        }
        new __WEBPACK_IMPORTED_MODULE_4_angular2_csv__["Angular2Csv"](text, filename.split(".")[0], { headers: (Header) });
    };
    //   download(filename, text) {
    //     //this.api.downloadSaveFile(filename, text);
    //       var pom = document.createElement('a');
    //     pom.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(text));
    //     pom.setAttribute('download', filename);
    //     if (document.createEvent) {
    //         var event = document.createEvent('MouseEvents');
    //         event.initEvent('click', true, true);
    //         pom.dispatchEvent(event);
    //     }
    //     else {
    //         pom.click();
    //     }
    //     // document.removeChild(pom);
    // }
    TransactionConsumedDialogComponent.prototype.download = function (filename, text) {
        this.api.downloadSaveFile(filename, text);
    };
    TransactionConsumedDialogComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Object)
    ], TransactionConsumedDialogComponent.prototype, "options", void 0);
    TransactionConsumedDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'transaction-consumed-dialog',
            template: __webpack_require__(1015)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_5__providers_api_billing__["a" /* ApiBilling */], __WEBPACK_IMPORTED_MODULE_2__angular_material__["i" /* MatDialog */], __WEBPACK_IMPORTED_MODULE_2__angular_material__["k" /* MatDialogRef */], __WEBPACK_IMPORTED_MODULE_3__providers_api__["a" /* Api */]])
    ], TransactionConsumedDialogComponent);
    return TransactionConsumedDialogComponent;
}());



/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomersDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__providers_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__confirm_deleteLocation_dialog_component__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfirmCreateCustomerWithExistingNameComponent__ = __webpack_require__(452);







// openDialogWithAResult
var CustomersDialogComponent = /** @class */ (function () {
    function CustomersDialogComponent(dialogRef, api, matDialog) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.api = api;
        this.matDialog = matDialog;
        this.imageURL = "";
        this.imagesBaseUrl = "";
        this.customer = {};
        this.taxGroup = [];
        this.customerGroup = [];
        this.termCode = [];
        this.currencies = [];
        this.paymentProcessingCode = [];
        this.discountTagsList = [];
        this.saleRepCodes = [];
        this.countories = [];
        this.provinces = [];
        this.shippingService = [];
        this.isShippingAdding = false;
        this.shippingArray = [];
        this.customerCountryCode = "";
        this.enableEditlocation = true;
        this.enableAddlocation = true;
        this.enablePrimaryLocation = true;
        this.supplierPaymentStatus = false;
        this.isEditingSingleShippingService = true;
        this.customerBackUp = {};
        this.customerBackUpMaster = {};
        this.selectedLocation = {};
        this.checkboxPrimary = true;
        this.customerAlreadyExist = false;
        setTimeout(function () {
            _this.getTaxGroup();
        }, 5);
        setTimeout(function () {
            _this.getTermCode();
        }, 10);
        setTimeout(function () {
            _this.getPaymentProcessing();
        }, 20);
        setTimeout(function () {
            _this.getCountories();
        }, 60);
        setTimeout(function () {
            _this.getCustomerGroup();
        }, 20);
        setTimeout(function () {
            _this.getSaleRepCode();
        }, 35);
        setTimeout(function () {
            _this.getShippingServive();
        }, 30);
        setTimeout(function () {
            _this.getCurrenciesList();
        }, 30);
        setTimeout(function () {
            // console.log("beforxxxxxxxxxxxxxxxxxxxxxe condiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiition",this.customer.Locations[0].state);
            if (__WEBPACK_IMPORTED_MODULE_3__providers_api__["b" /* ApplicationVariables */].currentCustomer.Locations !== undefined && _this.customer.Locations.length > 0 && _this.customer.Locations[0].country !== undefined && _this.customer.Locations[0].country !== "") {
                _this.getProvincesWhileEditing(_this.customer.Locations[0].country);
            }
        }, 30);
        this.setMask();
        var paymentStatus = localStorage.getItem("supplierPayment");
        // alert("FFFFFFFFFF" + paymentStatus)
        if (paymentStatus !== null && paymentStatus == '1') {
            this.supplierPaymentStatus = true;
        }
        this.adpcustomersId = api.getUser().adpcustomersId;
        this.countryCodeMask = this.api.countryCodeMask;
        // this.mask = this.api.PHONE_MASK;
        //this.dialogRef.disableClose = true;
        this.imagesBaseUrl = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].imagesBaseUrl;
        this.customer = __WEBPACK_IMPORTED_MODULE_3__providers_api__["b" /* ApplicationVariables */].currentCustomer;
        this.customerBackUpMaster = JSON.parse(JSON.stringify(this.customer));
        this.imageURL = "";
        // if(!(this.customer.customerPhone==null || this.customer.customerPhone==undefined || !this.customer.isEditFlag)) {
        //   console.log("before split", this.customer.customerPhone)
        //   this.customer.customerPhone = this.splitPhoneNumber(this.customer.customerPhone, true);
        // }
        if (this.customer.isEditFlag) { //          this is for  disabling editing primiary location
            this.enablePrimaryLocation = false; // this will be set to true when already primary location is unmarked AS PRIMARY
        }
        console.log(this.customer);
        if (this.customer.shippingService !== undefined)
            setTimeout(function () {
                // this.customer.shippingService = [];
                console.log("this.customer.shippingService ---- ", _this.customer.shippingService);
                _this.shippingArray = _this.customer.shippingService;
                _this.customer.shippingServiceDTOs = _this.customer.shippingService;
                console.log("this.shippingArray", _this.shippingArray);
                if (_this.customer.shippingService.length > 0)
                    for (var _i = 0, _a = _this.shippingArray; _i < _a.length; _i++) {
                        var i = _a[_i];
                        i.isShippingAdding = false;
                        i.isEditingSingleShippingService = false;
                    }
                console.log("this.shippingArray constructor", _this.shippingArray);
            }, 500);
        this.getDiscounts();
    }
    CustomersDialogComponent.prototype.imageNotFound = function (e, item) {
        // this.imageURL = this.imagesBaseUrl+"products/400x400/nan-400x400.jpg"
    };
    CustomersDialogComponent.prototype.setMask = function () {
        if (localStorage.getItem('countryCode').length == 2) {
            this.mask = ['+', /\d/, ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
        else if (localStorage.getItem('countryCode').length == 3) {
            this.mask = ['+', /\d/, /\d/, ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
        else {
            this.mask = ['+', /\d/, ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
        this.maskLength = this.mask.length;
        console.log("mask.length", this.mask, this.maskLength);
    };
    CustomersDialogComponent.prototype.getShowStatus = function (tax) {
        if (tax.code === "pre-order" && this.supplierPaymentStatus === false) {
            return false;
        }
        else {
            return true;
        }
    };
    CustomersDialogComponent.prototype.getRandomId = function () {
        return -Math.floor(Math.random() * 1000) + 1;
    };
    CustomersDialogComponent.prototype.getImageURL = function () {
        return "";
        // return APPCONFIG.imagesBaseUrl +
        // "/" + this.api.getADPCustomerUUID() +
        // "/products/400x400/" + this.product.imageName + "-400x400."+
        // this.product.imageExtension;
    };
    // splitPhoneNumber(phoneNumber:String,phonebearer:boolean){
    //   if(phoneNumber[0]=="+") {
    //     let phoneCut = phoneNumber.split("(", 2)
    //     phoneNumber = "(" + phoneCut[1];
    //     if(phonebearer===true)
    //       this.customerCountryCode = phoneCut[0];
    //     else if(phonebearer===false)
    //             this.receiverCountryCode=phoneCut[0]
    //    }
    //   return phoneNumber;
    // }
    // splitPhone(phoneNumber:String,phonebearer:boolean){
    //   phoneNumber
    // }
    CustomersDialogComponent.prototype.toggleEditAddress = function (location) {
        this.enableAddlocation = false;
        this.enableEditlocation = false;
        // console.log("before,This location flags, E,A:",location.isEditFlag,location.isAddFlag);
        for (var _i = 0, _a = this.customer.Locations; _i < _a.length; _i++) {
            var loc = _a[_i];
            loc.isEditFlag = false;
        }
        // console.log("first,This location flags, E,A:",location.isEditFlag,location.isAddFlag);
        // console.log("edit location called");
        this.selectedLocation = JSON.parse(JSON.stringify(this.customer.Locations));
        console.log(this.selectedLocation);
        location.isEditFlag = !location.isEditFlag;
        console.log("phone before split in edit location", location.isEditFlag);
        // if(!(location.phone==null || location.phone==undefined || location.phone=="")) {
        //   console.log("inside split condition at edit button",location.phone)
        //   location.phone = this.splitPhoneNumber(location.phone, false)
        //   console.log("inside split condition after split",location.phone)
        //
        // }
        // console.log("second,This location flags, E,A:",location.isEditFlag,location.isAddFlag);
        this.getProvincesWhileEditing(location.country);
    };
    CustomersDialogComponent.prototype.deleteThisLocation = function (location, index, createFlag) {
        var _this = this;
        if (location.isShipToAddress == 1) {
            this.api.toastMsg("Primary Location cannot be Deleted", "");
        }
        else {
            console.log("Customer creation Flag", createFlag);
            var dialogRef = this.matDialog.open(__WEBPACK_IMPORTED_MODULE_5__confirm_deleteLocation_dialog_component__["a" /* ConfirmDeleteLocationDialogComponent */], { disableClose: true, });
            dialogRef.afterClosed().subscribe(function (result) {
                if (result === 'confirm') {
                    if (!createFlag) {
                        _this.api.delete("customer/deleteLocation/" + location.id).subscribe(function (response) {
                            console.log("response", response.json());
                            var res = response.json();
                            if (res.status == '200') {
                                _this.deleteLocation(location, index);
                                _this.api.toastMsg("Location deleted successfully", "");
                            }
                        }, function (error) {
                            _this.api.toastMsg("Something Went Wrong", "");
                        });
                    }
                    else if (createFlag)
                        _this.deleteLocation(location, index);
                }
                else if (result === 'cancel') {
                    console.log("cacnel delete location");
                }
            });
        }
    };
    CustomersDialogComponent.prototype.deleteLocation = function (location, index) {
        console.log("location to delete", "index", location, index);
        if (this.customer.Locations[index]["isShipToAddress"] == 1) {
            this.enablePrimaryLocation = true;
        }
        this.customer.Locations.splice(index, 1);
        console.log("all location", this.customer.Locations);
    };
    CustomersDialogComponent.prototype.checkPrimary = function (location, index) {
        var _this = this;
        console.log("check", this.customer.Locations[index]["isShipToAddress"]);
        if (location.locationType == "BILLTO") {
            setTimeout(function () {
                _this.customer.Locations[index]["isShipToAddress"] = 0;
            });
            this.api.toastMsg("“Bill To” location type cannot be selected as “Primary”", "");
        }
        else if (!this.customer.Locations[index]["isShipToAddress"]) {
            this.customer.Locations[index]["isShipToAddress"] = true;
        }
        else {
            for (var _i = 0, _a = this.customer.Locations; _i < _a.length; _i++) {
                var loc = _a[_i];
                loc.isShipToAddress = 0;
            }
            this.customer.Locations[index]["isShipToAddress"] = 1;
        }
        console.log("All locaitons in creating Customer", this.customer.Locations);
    };
    CustomersDialogComponent.prototype.changePrimary = function (location, index) {
        var _this = this;
        console.log("check", this.customer.Locations[index]["isShipToAddress"]);
        if (location.locationType == "BILLTO") {
            setTimeout(function () {
                _this.customer.Locations[index]["isShipToAddress"] = 0; //BILLTO location cannot be marked Primary
            });
            this.api.toastMsg("“Bill To” location type cannot be selected as “Primary”", "");
        }
        else if (!this.customer.Locations[index]["isShipToAddress"]) {
            this.customer.Locations[index]["isShipToAddress"] = true;
        }
        else {
            for (var _i = 0, _a = this.customer.Locations; _i < _a.length; _i++) {
                var loc = _a[_i];
                loc.isShipToAddress = 0;
            }
            this.customer.Locations[index]["isShipToAddress"] = 1;
        }
        console.log("All locaitons in editing Customer", this.customer.Locations);
    };
    CustomersDialogComponent.prototype.undoChanges = function (location) {
        console.log("Undo Changes");
        location.isEditFlag = false;
        this.customer.Locations = JSON.parse(JSON.stringify(this.selectedLocation));
        this.selectedLocation = {};
        console.log(location);
        // this.receiverCountryCode="";
        this.enableAddlocation = true;
        this.enableEditlocation = true;
    };
    CustomersDialogComponent.prototype.update = function (location) {
        console.log("llllllllllllllllllllllllll" + location.state);
        if (!location.locationType || location.locationType == "") {
            this.api.toastMsg("Location Type is required to add a location", "");
        }
        else if (location.receiverName == "" || location.receiverName == undefined) {
            this.api.toastMsg("Contact Person is required to add a location", "");
        }
        else if (location.addressLine1 == "" || location.addressLine1 == undefined) {
            this.api.toastMsg("Address Line 1 is required to add a location", "");
        }
        else if (location.city == "" || location.city == undefined) {
            this.api.toastMsg("City is required to add a location", "");
        }
        else if (location.state == "" || location.state == undefined) {
            this.api.toastMsg("State/Province is required to add a location", "");
        }
        else if (location.country == "" || location.country == undefined) {
            this.api.toastMsg("Country is required to add a location", ""); // made cumpolsary on June 19,2019 after NH approval
        }
        else if (location.zipCode == "" || location.zipCode == undefined) {
            this.api.toastMsg("Zip/Postal Code is required to add a location", ""); // made cumpolsary on June 19,2019 after NH approval
        }
        else if (location.email == "" || location.email == undefined) {
            this.api.toastMsg("Receiver Email is required to add a location", ""); // made cumpolsary on June 19,2019 after NH approval
        }
        else if (!this.validateEmail(location.email)) {
            this.api.toastMsg("Receiver Email is not valid", "");
            return false;
        }
        else {
            console.log("update called");
            this.selectedLocation = {};
            location.isEditFlag = false;
            if (location.locationType == "BILLTO" && location.isShipToAddress == 1)
                location.isShipToAddress = 0;
            // if(!(location.phone==undefined || location.phone.trim()=="" || location.phone==null))
            //   location.phone=this.receiverCountryCode+' '+ location.phone;
            // this.receiverCountryCode="";
            this.enableAddlocation = true;
            this.enableEditlocation = true;
        }
        // console.log("update called");
        // this.selectedLocation ={};
        // location.isEditFlag = false;
        // if(location.locationType=="BILLTO" && location.isShipToAddress==1)
        //       location.isShipToAddress=0;
        // // if(!(location.phone==undefined || location.phone.trim()=="" || location.phone==null))
        // //   location.phone=this.receiverCountryCode+' '+ location.phone;
        // // this.receiverCountryCode="";
        // this.enableAddlocation=true;
        // this.enableEditlocation=true;
    };
    CustomersDialogComponent.prototype.cancelNew = function (location) {
        console.log("cancel add new location  callled");
        location.isEditFlag = false;
        this.customer.Locations.splice(this.customer.Locations.indexOf(location), 1);
    };
    CustomersDialogComponent.prototype.addLocationComplete = function (location, index) {
        var _this = this;
        var billToLocationsCount = 0;
        if (location.locationType !== "" && location.locationType === "BILLTO") {
            for (var _i = 0, _a = this.customer.Locations; _i < _a.length; _i++) {
                var loc = _a[_i];
                if (loc.locationType === "BILLTO") {
                    billToLocationsCount++;
                }
            }
            if (billToLocationsCount > 1) {
                this.api.toastMsg("You can't add more than 1 billto location", "");
                return;
            }
        }
        console.log("llllllllllllllllllllllllll" + location.state);
        if (!location.locationType || location.locationType == "") {
            this.api.toastMsg("Location Type is required to add a location", "");
        }
        else if (location.receiverName == "" || location.receiverName == undefined) {
            this.api.toastMsg("Contact Person is required to add a location", "");
        }
        else if (location.addressLine1 == "" || location.addressLine1 == undefined) {
            this.api.toastMsg("Address Line 1 is required to add a location", "");
        }
        else if (location.city == "" || location.city == undefined) {
            this.api.toastMsg("City is required to add a location", "");
        }
        else if (location.state == "" || location.state == undefined) {
            this.api.toastMsg("State/Province is required to add a location", "");
        }
        else if (location.country == "" || location.country == undefined) {
            this.api.toastMsg("Country is required to add a location", ""); // made cumpolsary on June 19,2019 after NH approval
        }
        else if (location.zipCode == "" || location.zipCode == undefined) {
            this.api.toastMsg("Zip/Postal Code is required to add a location", ""); // made cumpolsary on June 19,2019 after NH approval
        }
        else if (location.email == "" || location.email == undefined) {
            this.api.toastMsg("Receiver Email is required to add a location", ""); // made cumpolsary on June 19,2019 after NH approval
        }
        else if (!this.validateEmail(location.email)) {
            this.api.toastMsg("Receiver Email is not valid", "");
            return false;
        }
        else {
            console.log("this.customer", this.customer);
            this.selectedLocation = {};
            location.isEditFlag = false;
            location.isAddFlag = false;
            this.enableAddlocation = true;
            this.enableEditlocation = true;
            if (location.locationType == "BILLTO" && location.isShipToAddress == 1)
                location.isShipToAddress = 0;
            // if(!(location.phone==undefined || location.phone.trim()=="" || location.phone==null || this.receiverCountryCode.trim()==""))
            //     location.phone=this.receiverCountryCode+' '+ location.phone;
            // this.receiverCountryCode="";
            location.customerId = this.customer.id;
            setTimeout(function () {
                _this.customerBackUpMaster = JSON.parse(JSON.stringify(_this.customer));
            }, 50);
        }
    };
    CustomersDialogComponent.prototype.addLocation = function () {
        this.customerBackUp = JSON.parse(JSON.stringify(this.customer));
        var alreadyOpendLocation = false;
        for (var _i = 0, _a = this.customer.Locations; _i < _a.length; _i++) {
            var loc = _a[_i];
            if (loc.isAddFlag && loc.isEditFlag) {
                this.api.showToastInfo("Click “Add” or “Update” to complete the Location section");
                this.api.toastMsg("Click “Add” or “Update” to complete the Location section", "");
                this.customer = JSON.parse(JSON.stringify(this.customerBackUp));
                alreadyOpendLocation = true;
            }
        }
        if (!alreadyOpendLocation) {
            // this.customer.Locations.push({id:0,isEditFlag:true,isAddFlag:true,isShipToAddress:0});
            this.customer.Locations.push({ id: 0, isEditFlag: true, isAddFlag: true, isShipToAddress: 0, email: this.customer.email });
            // this.receiverCountryCode="";
            this.enableEditlocation = false;
            this.enableAddlocation = false;
        }
    };
    CustomersDialogComponent.prototype.cancelAdd = function (location) {
        // this.customer = {};
        // setTimeout(()=>{
        //   this.customer = JSON.parse(JSON.stringify(this.customerBackUpMaster));
        // },50);
        this.checkEmptyLocation();
        // this.receiverCountryCode="";
        this.enableAddlocation = true;
        this.enableEditlocation = true;
    };
    CustomersDialogComponent.prototype.setPhoneNumber = function () {
        // if(this.customerCountryCode==undefined || this.customerCountryCode.trim()=="" || this.customerCountryCode.substr(1)==""||this.customerCountryCode==null ){
        //   this.api.toastMsg("Please provide country code for Customer","");
        //   return false;
        //
        // }else
        if (this.customer.customerPhone == undefined || this.customer.customerPhone == "" || this.customer.customerPhone == null) {
            this.api.toastMsg("Phone is required", "");
            return false;
        }
        else {
            // console.log("before merge:", this.customer.customerPhone);
            // if (this.customer.customerPhone[0] !== '+') {
            //   this.customer.customerPhone = this.customerCountryCode + ' ' + this.customer.customerPhone;
            // }
            return true;
        }
    };
    CustomersDialogComponent.prototype.close = function (typ) {
        var _this = this;
        console.log("TTTTT " + typ);
        if (typ == 'update') {
            if (this.validateCustomer()) {
                this.dialogRef.close(typ);
            }
            else {
            }
        }
        else if (typ == 'create') {
            // alert("fdff " + this.customerAlreadyExist)
            if (this.validateCustomer()) {
                if (this.customerAlreadyExist) {
                    var dialogRef = this.matDialog.open(__WEBPACK_IMPORTED_MODULE_6__ConfirmCreateCustomerWithExistingNameComponent__["a" /* ConfirmCreateCustomerWithExistingNameComponent */]);
                    dialogRef.afterClosed().subscribe(function (result) {
                        if (result == 'confirm') {
                            _this.dialogRef.close(typ);
                        }
                    });
                }
                else {
                    this.dialogRef.close(typ);
                }
            }
            else {
            }
        }
        else {
            console.log("No. of locations before:", this.customer.Locations.length);
            //this.customerBackUpMaster = JSON.parse(JSON.stringify(this.customer));
            this.checkEmptyLocation();
            console.log("No. of locations after:", this.customer.Locations.length);
            console.log("customer cancel on edit -- ", this.customer);
            console.log("customerBackUpMaster cancel on edit -- ", this.customerBackUpMaster);
            this.customer = this.customerBackUpMaster;
            this.dialogRef.close('cancel');
            this.customer.isCreateFlag = false;
            this.customer.isEditFlag = false;
        }
    };
    CustomersDialogComponent.prototype.checkEmptyLocation = function () {
        var primaryLoations = 0;
        for (var _i = 0, _a = this.customer.Locations; _i < _a.length; _i++) {
            var loc = _a[_i];
            if (loc.isAddFlag && loc.isEditFlag) {
                this.customer.Locations.splice(this.customer.Locations.indexOf(loc), 1);
            }
        }
    };
    CustomersDialogComponent.prototype.isNoPrimaryLocation = function () {
        var primaryLoations = 0;
        for (var _i = 0, _a = this.customer.Locations; _i < _a.length; _i++) {
            var loc = _a[_i];
            if (loc.isShipToAddress)
                loc.isShipToAddress = 1;
            if (!loc.isShipToAddress)
                loc.isShipToAddress = 0;
            if (loc.isShipToAddress == 1) {
                primaryLoations++;
            }
        }
        if (primaryLoations < 1) {
            this.api.toastMsg("Select one “Primary” shipping location", "");
            return false;
        }
        else
            return true;
    };
    CustomersDialogComponent.prototype.billToAddressCheck = function () {
        var bittoLocCount = 0;
        for (var _i = 0, _a = this.customer.Locations; _i < _a.length; _i++) {
            var loc = _a[_i];
            if (loc.locationType === "BILLTOSHIPTO" || loc.locationType === "BILLTO") {
                bittoLocCount++;
            }
        }
        if (bittoLocCount < 1) {
            this.api.toastMsg("Please add at least 1 Bill To location", "");
            return false;
        }
        else
            return true;
    };
    CustomersDialogComponent.prototype.validateCustomer = function () {
        console.log(this.customer);
        console.log("location array length", this.customer.Locations.length);
        if (this.customer.Locations.length === 0) {
            this.api.toastMsg("Add at least one location", "");
            this.enableAddlocation = true;
            return false;
        }
        for (var _i = 0, _a = this.customer.Locations; _i < _a.length; _i++) {
            var loc = _a[_i];
            console.log("location number", loc.isEditFlag);
            if (loc.isAddFlag || loc.isEditFlag) {
                this.api.showToastInfo("Click “Add” or “Update” to complete the Location section");
                this.api.toastMsg("Click “Add” or “Update” to complete the Location section", "");
                return false;
            }
        }
        if (this.customer.customerName == undefined || this.customer.customerName.trim() == "" || this.customer.customerName == null) {
            this.api.toastMsg("Company Name is required", "");
            return false;
        }
        else if (this.customer.contactPerson == undefined || this.customer.contactPerson.trim() == "" || this.customer.contactPerson == null) {
            this.api.toastMsg("Contact Person is required", "");
            return false;
        }
        else if (this.customer.email == undefined || this.customer.email.trim() == "" || this.customer.email == null) {
            this.api.toastMsg("Email is required", "");
            return false;
        }
        else if (!this.validateEmail(this.customer.email)) {
            this.api.toastMsg("Email is not valid", "");
            return false;
        }
        else if (!this.setPhoneNumber()) {
            //this.api.toastMsg("Customer Phone is not valid","");
            return false;
        }
        else if (!this.isNoPrimaryLocation()) {
            return false;
        }
        else if (!this.billToAddressCheck()) {
            return false;
        }
        else if (this.customer.paymentCurrency === undefined || this.customer.paymentCurrency === "") {
            this.api.toastMsg("Payment currency can't be empty", "");
            return false;
        }
        else {
            this.checkEmptyLocation();
            // if(
            //   this.customer.salePersonCode =="" ||
            //   this.customer.taxGroup == "" ||
            //   this.customer.customerCompany == "" ||
            //   this.customer.email == "" ||
            //   this.customer.groupCode ==""
            //    ){
            //    this.api.toastMsg("Some of the fields can't be empty","");
            //    return false;
            // }else{
            //   return true;
            // }
            return true;
        }
    };
    CustomersDialogComponent.prototype.validateEmail = function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    CustomersDialogComponent.prototype.getTaxGroup = function () {
        var _this = this;
        var query = " ";
        var offset = 0;
        var resultcount = 100;
        this.api.get("lookups/search/" + query + "/" + offset + "/" + resultcount + "/taxGroup")
            .subscribe(function (data) {
            if (data.status == 401) {
                _this.api.tokenExpiredLogout();
            }
            else {
                console.log(data.json().lookups);
                _this.taxGroup = data.json().lookups;
            }
        }, function (err) {
            console.log("Error", err);
        });
    };
    CustomersDialogComponent.prototype.getCustomerGroup = function () {
        var _this = this;
        var query = " ";
        var offset = 0;
        var resultcount = 100;
        this.api.get("lookups/search/" + query + "/" + offset + "/" + resultcount + "/customerGroup")
            .subscribe(function (data) {
            if (data.status == 401) {
                _this.api.tokenExpiredLogout();
            }
            else {
                _this.customerGroup = data.json().lookups;
            }
        }, function (err) {
            console.log("Error", err);
        });
    };
    CustomersDialogComponent.prototype.getTermCode = function () {
        var _this = this;
        var query = " ";
        var offset = 0;
        var resultcount = 100;
        this.api.get("lookups/search/" + query + "/" + offset + "/" + resultcount + "/termsCode")
            .subscribe(function (data) {
            if (data.status == 401) {
                _this.api.tokenExpiredLogout();
            }
            else {
                _this.termCode = data.json().lookups;
            }
        }, function (err) {
            console.log("Error", err);
        });
    };
    CustomersDialogComponent.prototype.getPaymentProcessing = function () {
        var _this = this;
        var query = " ";
        var offset = 0;
        var resultcount = 100;
        this.api.get("lookups/searchWithOutAdpCustomerId/" + query + "/" + offset + "/" + resultcount + "/payment-processing")
            .subscribe(function (data) {
            if (data.status == 401) {
                _this.api.tokenExpiredLogout();
            }
            else {
                for (var _i = 0, _a = data.json().lookups; _i < _a.length; _i++) {
                    var pay = _a[_i];
                    if (pay.code === "pre-order" && _this.supplierPaymentStatus === false) {
                        // return false;
                    }
                    else {
                        _this.paymentProcessingCode.push(pay);
                    }
                }
                // this.paymentProcessingCode = data.json().lookups;
            }
        }, function (err) {
            console.log("Error", err);
        });
    };
    // getCountories(){
    //   let query = " ";
    //   let offset = 0;
    //   let resultcount = 100
    //   this.api.get("lookups/search/"+query+"/"+offset+"/"+resultcount+"/country")
    // 	.subscribe(data => {
    // 			if(data.status == 401){
    //                   this.api.tokenExpiredLogout();
    //                 }else{
    // 			this.countories = data.json().lookups;
    // 		}
    // 		},err=>{
    // 			console.log("Error", err);
    // 		});
    // }
    CustomersDialogComponent.prototype.getCountories = function () {
        var _this = this;
        this.api.getCountryListRA("/api/v1/codes/all/0").subscribe(function (result) {
            _this.countories = result.json().data;
            console.log("CountryCodes from RA Service", _this.countories);
        }, function (err) {
            console.log("Error", err);
        });
    };
    CustomersDialogComponent.prototype.getSaleRepCode = function () {
        var _this = this;
        console.log("sale rep function called");
        this.api.get("jusers/saleRepCode")
            .subscribe(function (data) {
            if (data.status == 401) {
                _this.api.tokenExpiredLogout();
            }
            else {
                console.log("received sale rep codes:", data.json());
                _this.saleRepCodes = data.json().saleRepCodes;
                for (var _i = 0, _a = _this.saleRepCodes; _i < _a.length; _i++) {
                    var code = _a[_i];
                    code.id = JSON.stringify(code.id);
                }
                console.log(_this.saleRepCodes);
            }
        }, function (err) {
            console.log("Error", err);
        });
    };
    CustomersDialogComponent.prototype.getShippingServive = function () {
        var _this = this;
        var query = " ";
        var offset = 0;
        var resultcount = 100;
        this.api.get("lookups/search/" + query + "/" + offset + "/" + resultcount + "/shippingServices")
            .subscribe(function (data) {
            if (data.status == 401) {
                _this.api.tokenExpiredLogout();
            }
            else {
                _this.shippingService = data.json().lookups;
            }
        }, function (err) {
            console.log("Error", err);
        });
    };
    CustomersDialogComponent.prototype.createShippingServiceArray = function (shipAr) {
        if (shipAr.shippingServiceValue.trim() === "") {
            this.api.toastMsg("Please fill all fields", "");
        }
        else if (shipAr.shippingServiceId == 0) {
            this.api.toastMsg("Please fill all fields", "");
        }
        else {
            shipAr.isShippingAdding = false;
            this.customer.shippingServiceDTOs = this.shippingArray;
            console.log("this.shippingArray", this.customer);
            this.isShippingAdding = false;
            this.isEditingSingleShippingService = true;
        }
    };
    CustomersDialogComponent.prototype.cancelShippingServiceArray = function (shipAr) {
        shipAr.isShippingAdding = false;
        this.shippingArray.splice(-1, 1);
        this.isEditingSingleShippingService = true;
    };
    CustomersDialogComponent.prototype.addObjectArr = function () {
        this.shippingArray.push({
            id: this.getRandomId(),
            customerId: this.customer.id,
            shippingServiceId: 0,
            shippingServiceValue: "",
            adpCustomerId: this.adpcustomersId + "",
            isShippingAdding: true
        });
        this.isEditingSingleShippingService = false;
    };
    CustomersDialogComponent.prototype.getValueOfShippingService = function () {
    };
    CustomersDialogComponent.prototype.getNameFromId = function (id) {
        for (var _i = 0, _a = this.shippingService; _i < _a.length; _i++) {
            var i = _a[_i];
            if (id == i.id) {
                return i.description;
            }
        }
    };
    CustomersDialogComponent.prototype.editingSingleShippingService = function (ship) {
        ship.isEditingSingleShippingService = false;
        // this.isEditingSingleShippingService = true;
        this.customer.shippingServiceDTOs = this.shippingArray;
        console.log("this.customer.............", this.customer);
    };
    CustomersDialogComponent.prototype.editingSingleShipping = function (ship) {
        ship.isEditingSingleShippingService = true;
        // this.isEditingSingleShippingService = true;
    };
    CustomersDialogComponent.prototype.removeshipingservice = function (obj) {
        this.shippingArray = this.shippingArray.filter(function (o) { return o.id != obj.id; });
        this.customer.shippingServiceDTOs = this.shippingArray;
        console.log("this.customer.............", this.customer);
    };
    CustomersDialogComponent.prototype.getDiscounts = function () {
        var _this = this;
        this.api.getRt("/discount/findAllDiscountsByAdpCustomerId")
            // this.api.getCatalyst("store/getActiveAdpCustomerStoresList" )
            .subscribe(function (data) {
            if (data.status == 401) {
                _this.api.tokenExpiredLogout();
            }
            else {
                console.log("Data from rt : " + JSON.stringify(data));
                var data2 = data.json();
                // this.totalSearchCount = data2.searchCount;
                // this.totalPagesAvailable = Math.abs(this.totalSearchCount / resultcount);
                _this.discountTagsList = data2.data;
            }
        }, function (err) {
        });
    };
    CustomersDialogComponent.prototype.getProvinces = function (location, abbreviation, event) {
        var _this = this;
        if (event.isUserInput) {
            location.state = "";
            var query = " ";
            var offset = 0;
            var resultcount = 100;
            this.api.get("lookups/searchWithOutAdpCustomerId/" + query + "/" + offset + "/" + resultcount + "/Province-" + abbreviation)
                .subscribe(function (data) {
                if (data.status == 401) {
                    _this.api.tokenExpiredLogout();
                }
                else {
                    _this.provinces = data.json().lookups;
                    // this.paymentProcessingCode = data.json().lookups;
                }
            }, function (err) {
                console.log("Error", err);
            });
        }
    };
    CustomersDialogComponent.prototype.getProvincesWhileEditing = function (abbreviation) {
        var _this = this;
        var query = " ";
        var offset = 0;
        var resultcount = 100;
        this.api.get("lookups/searchWithOutAdpCustomerId/" + query + "/" + offset + "/" + resultcount + "/Province-" + abbreviation)
            .subscribe(function (data) {
            if (data.status == 401) {
                _this.api.tokenExpiredLogout();
            }
            else {
                _this.provinces = data.json().lookups;
            }
        }, function (err) {
            console.log("Error", err);
        });
    };
    CustomersDialogComponent.prototype.checkCustomerWithSameNameAlreadyExist = function () {
        var _this = this;
        this.api.getRt("/customers/getCustomerByCompany?company=" + this.customer.customerName)
            .subscribe(function (data) {
            var jsonObj = data.json();
            // alert("dddd " + JSON.stringify(jsonObj))
            if (jsonObj.status === "200") {
                _this.customerAlreadyExist = true;
            }
            else {
                _this.customerAlreadyExist = false;
            }
        }, function (err) {
        });
    };
    CustomersDialogComponent.prototype.getCurrenciesList = function () {
        var _this = this;
        var query = " ";
        var offset = 0;
        var resultcount = 100;
        this.api.get("lookups/search/" + query + "/" + offset + "/" + resultcount + "/currency")
            .subscribe(function (data) {
            if (data.status == 401) {
                _this.api.tokenExpiredLogout();
            }
            else {
                _this.currencies = data.json().lookups;
            }
        }, function (err) {
            console.log("Error", err);
        });
    };
    CustomersDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'customers-dialog',
            template: __webpack_require__(1018)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["k" /* MatDialogRef */], __WEBPACK_IMPORTED_MODULE_3__providers_api__["a" /* Api */], __WEBPACK_IMPORTED_MODULE_2__angular_material__["i" /* MatDialog */]])
    ], CustomersDialogComponent);
    return CustomersDialogComponent;
}());



/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Version; });
// App version
var Version = "2.5.732";


/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmDeleteLocationDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(59);



// openDialogWithAResult
var ConfirmDeleteLocationDialogComponent = /** @class */ (function () {
    function ConfirmDeleteLocationDialogComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    ConfirmDeleteLocationDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'confirm-deleteLocation-dialog',
            template: "<h4 md-dialog-title>Warning!</h4>\n  <div md-dialog-content style=\"padding-bottom: 20px;\">Deleting the location will permanently delete this location. <br> Do you want to continue?</div>\n  <div md-dialog-actions>\n    <button mat-button (click)=\"dialogRef.close('cancel')\">Cancel</button>\n    <button mat-button (click)=\"dialogRef.close('confirm')\">Delete</button>\n  </div>",
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["k" /* MatDialogRef */]])
    ], ConfirmDeleteLocationDialogComponent);
    return ConfirmDeleteLocationDialogComponent;
}());



/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["main"] = main;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_app_module__ = __webpack_require__(710);



// depending on the env mode, enable prod mode or add debugging modules
if (true) {
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["enableProdMode"])();
}
function main() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__["a" /* platformBrowserDynamic */])().bootstrapModule(__WEBPACK_IMPORTED_MODULE_2__app_app_module__["a" /* AppModule */]);
}
if (document.readyState === 'complete') {
    main();
}
else {
    document.addEventListener('DOMContentLoaded', main);
}


/***/ }),

/***/ 710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ZendeskConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__raven__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_http__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser_animations__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_material__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_routing_module__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_component__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layout_layout_component__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout_preloader_directive__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__layout_header_header_component__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layout_sidenav_sidenav_component__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__layout_sidenav_toggle_offcanvas_nav_directive__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__layout_sidenav_auto_close_mobile_nav_directive__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__layout_sidenav_sidenav_menu_sidenav_menu_component__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__layout_sidenav_sidenav_menu_accordion_nav_directive__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__layout_sidenav_sidenav_menu_append_submenu_icon_directive__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__layout_sidenav_sidenav_menu_highlight_active_items_directive__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__layout_customizer_customizer_component__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__layout_customizer_toggle_quickview_directive__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__layout_footer_footer_component__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__layout_search_overlay_search_overlay_component__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__layout_search_overlay_search_overlay_directive__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__layout_search_overlay_open_search_overlay_directive__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__page_layouts_fullscreen_fullscreen_component__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__layout_layout_module__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__shared_shared_module__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__angularclass_hmr__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__angularclass_hmr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__angularclass_hmr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__providers_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__providers_api_billing__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__providers_auth_guard_service__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_angular2_text_mask__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_angular2_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_angular2_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_angular2_json2csv__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_angular2_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_angular2_json2csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_angular2_busy__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_angular2_busy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_angular2_busy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__toverux_ngx_sweetalert2__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_ngx_zendesk_webwidget__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__inventory_shipmentNotices_license_failure_dialog_component__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__billing_home_transaction_consumed_dialog_component__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__customers_home_customers_dialog_component__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__customers_home_ConfirmCreateCustomerWithExistingNameComponent__ = __webpack_require__(452);






// import {NgxImageSwapModule} from 'ngx-image-swap';




// Layout


// Header

// Sidenav







// Customizer


// Footer

// Search Overaly



// Pages

// Sub modules


// hmr

// Providers




// import { FileDropModule } from 'ngx-file-drop/lib/ngx-drop';










var ZendeskConfig = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ZendeskConfig, _super);
    function ZendeskConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accountUrl = __WEBPACK_IMPORTED_MODULE_33__config__["a" /* APPCONFIG */].zopim_subdomain;
        return _this;
    }
    ZendeskConfig.prototype.beforePageLoad = function (zE) {
        zE.setLocale('en');
        zE.hide();
        zE.setHelpCenterSuggestions({ url: true });
    };
    return ZendeskConfig;
}(__WEBPACK_IMPORTED_MODULE_39_ngx_zendesk_webwidget__["a" /* ngxZendeskWebwidgetConfig */]));

var AppModule = /** @class */ (function () {
    function AppModule(appRef) {
        this.appRef = appRef;
    }
    AppModule.prototype.hmrOnInit = function (store) {
        console.log('HMR store', store);
    };
    AppModule.prototype.hmrOnDestroy = function (store) {
        var cmpLocation = this.appRef.components.map(function (cmp) { return cmp.location.nativeElement; });
        // recreate elements
        store.disposeOldHosts = Object(__WEBPACK_IMPORTED_MODULE_29__angularclass_hmr__["createNewHosts"])(cmpLocation);
        // remove styles
        Object(__WEBPACK_IMPORTED_MODULE_29__angularclass_hmr__["removeNgStyles"])();
    };
    AppModule.prototype.hmrAfterDestroy = function (store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    };
    AppModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_39_ngx_zendesk_webwidget__["b" /* ngxZendeskWebwidgetModule */].forRoot(ZendeskConfig),
                __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["BrowserModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_http__["c" /* HttpModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_forms__["FormsModule"],
                __WEBPACK_IMPORTED_MODULE_34_angular2_text_mask__["TextMaskModule"],
                __WEBPACK_IMPORTED_MODULE_5__angular_forms__["ReactiveFormsModule"],
                __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser_animations__["a" /* BrowserAnimationsModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["b" /* MatAutocompleteModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["c" /* MatButtonModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["d" /* MatButtonToggleModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["e" /* MatCardModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["f" /* MatCheckboxModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["g" /* MatChipsModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["G" /* MatStepperModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["h" /* MatDatepickerModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["j" /* MatDialogModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["l" /* MatExpansionModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["n" /* MatGridListModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["o" /* MatIconModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["p" /* MatInputModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["q" /* MatListModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["r" /* MatMenuModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["s" /* MatNativeDateModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["u" /* MatPaginatorModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["v" /* MatProgressBarModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["w" /* MatProgressSpinnerModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["x" /* MatRadioModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["y" /* MatRippleModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["z" /* MatSelectModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["A" /* MatSidenavModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["C" /* MatSliderModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["B" /* MatSlideToggleModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["E" /* MatSnackBarModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["F" /* MatSortModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["H" /* MatTableModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["I" /* MatTabsModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["J" /* MatToolbarModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["K" /* MatTooltipModule */],
                __WEBPACK_IMPORTED_MODULE_8__app_routing_module__["a" /* AppRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_35_ng2_toastr__["ToastModule"].forRoot(),
                // Sub modules
                __WEBPACK_IMPORTED_MODULE_27__layout_layout_module__["LayoutModule"],
                __WEBPACK_IMPORTED_MODULE_28__shared_shared_module__["a" /* SharedModule */],
                __WEBPACK_IMPORTED_MODULE_37_angular2_busy__["BusyModule"],
                __WEBPACK_IMPORTED_MODULE_38__toverux_ngx_sweetalert2__["a" /* SweetAlert2Module */].forRoot(),
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_9__app_component__["a" /* AppComponent */],
                // Layout
                __WEBPACK_IMPORTED_MODULE_10__layout_layout_component__["a" /* LayoutComponent */],
                __WEBPACK_IMPORTED_MODULE_11__layout_preloader_directive__["a" /* PreloaderDirective */],
                // Header
                __WEBPACK_IMPORTED_MODULE_12__layout_header_header_component__["a" /* AppHeaderComponent */],
                // Sidenav
                __WEBPACK_IMPORTED_MODULE_13__layout_sidenav_sidenav_component__["a" /* AppSidenavComponent */],
                __WEBPACK_IMPORTED_MODULE_14__layout_sidenav_toggle_offcanvas_nav_directive__["a" /* ToggleOffcanvasNavDirective */],
                __WEBPACK_IMPORTED_MODULE_15__layout_sidenav_auto_close_mobile_nav_directive__["a" /* AutoCloseMobileNavDirective */],
                __WEBPACK_IMPORTED_MODULE_16__layout_sidenav_sidenav_menu_sidenav_menu_component__["a" /* AppSidenavMenuComponent */],
                __WEBPACK_IMPORTED_MODULE_17__layout_sidenav_sidenav_menu_accordion_nav_directive__["a" /* AccordionNavDirective */],
                __WEBPACK_IMPORTED_MODULE_18__layout_sidenav_sidenav_menu_append_submenu_icon_directive__["a" /* AppendSubmenuIconDirective */],
                __WEBPACK_IMPORTED_MODULE_19__layout_sidenav_sidenav_menu_highlight_active_items_directive__["a" /* HighlightActiveItemsDirective */],
                // Customizer
                __WEBPACK_IMPORTED_MODULE_20__layout_customizer_customizer_component__["a" /* AppCustomizerComponent */],
                __WEBPACK_IMPORTED_MODULE_21__layout_customizer_toggle_quickview_directive__["a" /* ToggleQuickviewDirective */],
                // Footer
                __WEBPACK_IMPORTED_MODULE_22__layout_footer_footer_component__["a" /* AppFooterComponent */],
                __WEBPACK_IMPORTED_MODULE_40__inventory_shipmentNotices_license_failure_dialog_component__["a" /* LicenseFailureDialogComponent */],
                // Search overlay
                __WEBPACK_IMPORTED_MODULE_23__layout_search_overlay_search_overlay_component__["a" /* AppSearchOverlayComponent */],
                __WEBPACK_IMPORTED_MODULE_24__layout_search_overlay_search_overlay_directive__["a" /* SearchOverlayDirective */],
                __WEBPACK_IMPORTED_MODULE_25__layout_search_overlay_open_search_overlay_directive__["a" /* OpenSearchOverlaylDirective */],
                //
                // Pages
                __WEBPACK_IMPORTED_MODULE_26__page_layouts_fullscreen_fullscreen_component__["a" /* PageLayoutFullscreenComponent */],
                __WEBPACK_IMPORTED_MODULE_41__billing_home_transaction_consumed_dialog_component__["a" /* TransactionConsumedDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_42__customers_home_customers_dialog_component__["a" /* CustomersDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_43__customers_home_ConfirmCreateCustomerWithExistingNameComponent__["a" /* ConfirmCreateCustomerWithExistingNameComponent */]
            ],
            entryComponents: [
                __WEBPACK_IMPORTED_MODULE_40__inventory_shipmentNotices_license_failure_dialog_component__["a" /* LicenseFailureDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_41__billing_home_transaction_consumed_dialog_component__["a" /* TransactionConsumedDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_42__customers_home_customers_dialog_component__["a" /* CustomersDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_43__customers_home_ConfirmCreateCustomerWithExistingNameComponent__["a" /* ConfirmCreateCustomerWithExistingNameComponent */]
            ],
            bootstrap: [__WEBPACK_IMPORTED_MODULE_9__app_component__["a" /* AppComponent */]],
            providers: [{ provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ErrorHandler"], useClass: __WEBPACK_IMPORTED_MODULE_1__raven__["a" /* RavenErrorHandler */] }, __WEBPACK_IMPORTED_MODULE_36_angular2_json2csv__["CsvService"], __WEBPACK_IMPORTED_MODULE_31__providers_api_billing__["a" /* ApiBilling */], __WEBPACK_IMPORTED_MODULE_30__providers_api__["a" /* Api */], __WEBPACK_IMPORTED_MODULE_32__providers_auth_guard_service__["a" /* AuthGuardService */]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ApplicationRef"]])
    ], AppModule);
    return AppModule;
}());



/***/ }),

/***/ 711:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RavenErrorHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);

__WEBPACK_IMPORTED_MODULE_0_raven_js__["config"]('https://18926e522d6244e28cd2180a6e7d8965@sentry.io/253371')
    .install();
var RavenErrorHandler = /** @class */ (function () {
    function RavenErrorHandler() {
    }
    RavenErrorHandler.prototype.handleError = function (err) {
        console.error(err);
        __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureException"](err);
    };
    return RavenErrorHandler;
}());



/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page_layouts_fullscreen_fullscreen_component__ = __webpack_require__(365);

// Page Layouts

var AppRoutes = [
    { path: '', redirectTo: '/extra/login', pathMatch: 'full' },
    // { path: 'app', component: LayoutComponent },
    { path: 'app', loadChildren: function() { return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 366))  .then( function(module) { return module['LayoutModule']; } ); } },
    { path: 'extra', loadChildren: function() { return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1379))  .then( function(module) { return module['ExtraPagesModule']; } ); } },
    { path: 'fullscreen', component: __WEBPACK_IMPORTED_MODULE_1__page_layouts_fullscreen_fullscreen_component__["a" /* PageLayoutFullscreenComponent */] },
];
var AppRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forRoot(AppRoutes, { useHash: true });


/***/ }),

/***/ 754:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid\">\n\n  <div class=\"article-title\">Blank</div>\n\n</section>"

/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component__ = __webpack_require__(447);



var routes = [
    {
        path: 'app',
        component: __WEBPACK_IMPORTED_MODULE_2__layout_component__["a" /* LayoutComponent */],
        children: [
            { path: '', redirectTo: '/app/dashboard', pathMatch: 'full', canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'dashboard', loadChildren: function() { return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1349))  .then( function(module) { return module['DashboardModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'blank', loadChildren: function() { return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1350))  .then( function(module) { return module['BlankModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'billing', loadChildren: function() { return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1351))  .then( function(module) { return module['BillingModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'integrations', loadChildren: function() { return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1352))  .then( function(module) { return module['IntegrationsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'transactions', loadChildren: function() { return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1353))  .then( function(module) { return module['TransectionsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'lookups', loadChildren: function() { return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1354))  .then( function(module) { return module['LookupsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'company', loadChildren: function() { return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1355))  .then( function(module) { return module['TransectionsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'users', loadChildren: function() { return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1356))  .then( function(module) { return module['UsersModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'buy-supply', loadChildren: function() { return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1357))  .then( function(module) { return module['BuyerSupplierModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'reports', loadChildren: function() { return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1358))  .then( function(module) { return module['ReportsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'customers', loadChildren: function() { return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1359))  .then( function(module) { return module['CustomersModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'products', loadChildren: function() { return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1360))  .then( function(module) { return module['ProductsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'warehouses', loadChildren: function() { return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1361))  .then( function(module) { return module['warehouseMangementModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'discounts', loadChildren: function() { return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1362))  .then( function(module) { return module['discountsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'sale-channels', loadChildren: function() { return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1363))  .then( function(module) { return module['SaleChannelsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'product-discount', loadChildren: function() { return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1364))  .then( function(module) { return module['CurrencyModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'tax', loadChildren: function() { return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1365))  .then( function(module) { return module['TaxModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'currency', loadChildren: function() { return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1366))  .then( function(module) { return module['CurrencyModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'eif', loadChildren: function() { return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1367))  .then( function(module) { return module['EifModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'inventory', loadChildren: function() { return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1368))  .then( function(module) { return module['InventoryModule']; } ); }, canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'categories', loadChildren: function() { return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1369))  .then( function(module) { return module['CategoriesModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'attributes', loadChildren: function() { return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1370))  .then( function(module) { return module['AttributesModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'branding', loadChildren: function() { return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1371))  .then( function(module) { return module['BrandingModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'ecommerce', loadChildren: function() { return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1372))  .then( function(module) { return module['ECommerceModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'form', loadChildren: function() { return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1373))  .then( function(module) { return module['MyFormsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'page', loadChildren: function() { return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1374))  .then( function(module) { return module['PagesModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'pglayout', loadChildren: function() { return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1375))  .then( function(module) { return module['PageLayoutsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'chart', loadChildren: function() { return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1376))  .then( function(module) { return module['ChartsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'table', loadChildren: function() { return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1377))  .then( function(module) { return module['MyTablesModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'ui', loadChildren: function() { return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1378))  .then( function(module) { return module['UIModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
        ]
    }
];
var LayoutRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(routes);


/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Api; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ApplicationVariables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_map__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular2_csv__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular2_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angular2_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular2_json2csv__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular2_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angular2_json2csv__);











var Api = /** @class */ (function () {
    // todo Phone number length after mask is 14;
    function Api(http, snackBar, router, toastr, csvService
    //private vcr:ViewContainerRef
    // ,private layoutService:LayoutService
    ) {
        this.http = http;
        this.snackBar = snackBar;
        this.router = router;
        this.toastr = toastr;
        this.csvService = csvService;
        this.url = null;
        this.catalystUrl = null;
        this.rtUrl = null;
        this.eifUrl = null;
        // adpUrl:string = APPCONFIG.ADP_API_BASE_URL;
        this.currentURL = new __WEBPACK_IMPORTED_MODULE_8_rxjs__["BehaviorSubject"](null);
        // getCurentUrl = this.currentURL.asObservable();
        // starting badge functionality
        this.isFirstLogin = new __WEBPACK_IMPORTED_MODULE_8_rxjs__["BehaviorSubject"](null);
        this.getIfFirstLogin = this.isFirstLogin.asObservable();
        this.PHONE_MASKNA = ['+', /\d/, ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        this.PHONE_MASKPK = ['+', /\d/, /\d/, ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        this.PHONE_MASK = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        this.countryCodeMask = ['+', /\d/, /\d/, /\d/];
        this.shippingCostPriceMask = [/\d/, /\d/, /\d/];
        // this.toastr.setRootViewContainerRef(vcr);
    }
    Api.prototype.ngOnInit = function () {
        //this.getURL();
    };
    Api.prototype.isloggedInUserAdmin = function () {
        this.getADPCustomer();
        return this.getADPCustomer().roleId === 1;
    };
    Api.prototype.isloggedInUserSaleRep = function () {
        this.getADPCustomer();
        return this.getADPCustomer().roleId === 3;
    };
    // setURL(){
    //     // todo  May 28 2019  by NH AR and NR Once
    //     //  On login the response object will bring the end points [rtapi,dtapi,billingapi] that needs to set for url  of user
    //     // inside set url method rettrieve the end points and set in this.url
    //     console.log("setURL.countryCode 123 --- ", localStorage.getItem("countryCode"));
    //
    //     if(localStorage.getItem('countryCode') == undefined){
    //         console.log('countryCode is undefined', localStorage.getItem('countryCode'));
    //         this.url = APPCONFIG.LOCAL_DTAPI_PK;
    //         this.server_region = 'NA';
    //         this.PHONE_MASK1=this.PHONE_MASKNA;
    //     }
    //     else if(localStorage.getItem("countryCode") === "+92") {
    //         this.url = APPCONFIG [APPCONFIG.ENVIRONMENT + "_DTAPI_PK"];
    //             this.server_region = 'PK';
    //         this.PHONE_MASK1=this.PHONE_MASKPK;
    //
    //     }
    //     else if(localStorage.getItem("countryCode") === "+1") {
    //         this.url = APPCONFIG [APPCONFIG.ENVIRONMENT + "_DTAPI_NA"];
    //         this.server_region = 'NA';
    //         this.PHONE_MASK1=this.PHONE_MASKNA;
    //
    //     }
    //     else
    //     {
    //         this.url = APPCONFIG.LOCAL_DTAPI_PK;
    //         console.log("ELSE OPTION RUNNING---------------------->", this.url)
    //         this.server_region = 'NA';
    //         this.PHONE_MASK1=this.PHONE_MASKNA;
    //
    //
    //     }
    //
    //
    //     console.log("setURl.this.url ---- ", this.url, "----");
    // }
    Api.prototype.setUrls = function () {
        if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT == "COMMERCIAL" || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT == "DEV") {
            this.url = localStorage.getItem('dtApiURL') + "api/v1";
            console.log("IF OPTION RUNNING---------------------->", this.url);
        }
        else {
            this.url = "http://localhost:8089/api/v1";
            console.log("ELSE OPTION RUNNING---------------------->", this.url);
        }
    };
    Api.prototype.setUrlsRt = function () {
        if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT == "COMMERCIAL" || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT == "DEV") {
            this.rtUrl = localStorage.getItem('rtApiURL') + "api/v2";
            this.eifUrl = localStorage.getItem('eifServerUrl') + "api/v1";
            console.log("IF OPTION RUNNING---------------------->", this.url);
        }
        else {
            // this.rtUrl = "http://localhost:8085/api/v2"
            this.rtUrl = localStorage.getItem('rtApiURL') + "api/v2";
            console.log("ELSE OPTION RUNNING---------------------->", this.url);
        }
    };
    Api.prototype.setUrlsCatalyst = function () {
        if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT == "COMMERCIAL" || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT == "DEV") {
            // this.url = localStorage.getItem('rtApiURL') + "api/v2";
            this.catalystUrl = localStorage.getItem('catalystApiURL') + "api/v1/";
            console.log("IF OPTION RUNNING---------------------->", this.url);
        }
        else {
            // this.catalystUrl = "http://localhost:8085/api/v2"
            this.catalystUrl = localStorage.getItem('catalystApiURL') + "api/v1/";
            console.log("ELSE OPTION RUNNING---------------------->", this.url);
        }
        // return APPCONFIG[APPCONFIG.ENVIRONMENT+"_CATALYST_SERVICE"] + '/';
    };
    Api.prototype.setIfFirstLogin = function (firstLoginState) {
        this.isFirstLogin.next(firstLoginState);
    };
    // setCurrentURL(currentURL){
    // this.currentURL.next(currentURL)
    //     // console.log("curent urls", this.get)
    // }
    Api.prototype.get = function (endpoint, params, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        if (!reqOpts) {
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]();
        }
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (var k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }
        return this.http.get(this.url + '/' + endpoint, reqOpts);
        //
        // if(this.getCountryCode() === "+92")
        //   return this.http.get(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        // else
        //   return this.http.get(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);
    };
    Api.prototype.getCatalyst = function (endpoint, params, reqOpts) {
        this.setUrlsCatalyst(); /*SET URL According to the user Country */
        if (!reqOpts) {
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]();
        }
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", localStorage.getItem("buyerUuid"));
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (var k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }
        return this.http.get(this.catalystUrl + endpoint, reqOpts);
        //
        // if(this.getCountryCode() === "+92")
        //   return this.http.get(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        // else
        //   return this.http.get(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);
    };
    // POST
    Api.prototype.post = function (endpoint, body, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);
        return this.http.post(this.url + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.postCatalyst = function (endpoint, body, reqOpts) {
        this.setUrlsCatalyst(); /*SET URL According to the user Country */
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", localStorage.getItem("buyerUuid"));
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);
        return this.http.post(this.catalystUrl + endpoint, body, reqOpts);
    };
    Api.prototype.getRt = function (endpoint, params, reqOpts) {
        this.setUrlsRt(); /*SET URL According to the user Country */
        if (!reqOpts) {
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]();
        }
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (var k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }
        return this.http.get(this.rtUrl + '/' + endpoint, reqOpts);
        //
        // if(this.getCountryCode() === "+92")
        //   return this.http.get(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        // else
        //   return this.http.get(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);
    };
    Api.prototype.getEif = function (endpoint, params, reqOpts) {
        this.setUrlsRt(); /*SET URL According to the user Country */
        if (!reqOpts) {
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]();
        }
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (var k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }
        console.log("UD UD UD");
        //Move it in RA Service
        return this.http.get(this.eifUrl + '/' + endpoint, reqOpts);
        // return this.http.get(this.rtUrl + '/' +endpoint, reqOpts);
    };
    // POST
    Api.prototype.postRt = function (endpoint, body, reqOpts) {
        this.setUrlsRt(); /*SET URL According to the user Country */
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);
        return this.http.post(this.rtUrl + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.postImage = function (endpoint, body, reqOpts) {
        var url = localStorage.getItem('imageUploderURL');
        url = url.split('upload.php')[0];
        return this.http.post(url + endpoint + this.getTokenFromLocalStorage(), body, reqOpts);
    };
    Api.prototype.imageUploaderPost = function (endpoint, body, productId) {
        // let url =  APPCONFIG.java_image_uploader_url;
        var url = localStorage.getItem('imageUploderURL') + "/api/v1";
        console.log("Image uploadwr fuction called url : " + url + endpoint + body + productId);
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        headers.append("token", this.getTokenFromLocalStorage());
        headers.append("productCode", productId);
        headers.append("size", __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].imageCutterSizes);
        headers.append("countryAbbrivation", localStorage.getItem('countryAbbrivation'));
        var reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        return this.http.post(url + endpoint, body, reqOpts);
    };
    Api.prototype.brandImageUploaderPost = function (endpoint, body, brandImageName, size) {
        // let url =  APPCONFIG.java_image_uploader_url;
        var url = localStorage.getItem('imageUploderURL') + "/api/v1";
        console.log("Image uploadwr fuction called url : " + url + endpoint + body + brandImageName);
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        headers.append("token", this.getTokenFromLocalStorage());
        headers.append("brandImageName", brandImageName);
        headers.append("size", size);
        headers.append("countryAbbrivation", localStorage.getItem('countryAbbrivation'));
        var reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        return this.http.post(url + endpoint, body, reqOpts);
    };
    Api.prototype.tempImageUploaderPost = function (endpoint, body) {
        // let url =  APPCONFIG.java_image_uploader_url;
        var url = localStorage.getItem('imageUploderURL') + "/api/v1";
        console.log("Image uploadwr fuction called url : " + url + endpoint + body);
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        headers.append("token", this.getTokenFromLocalStorage());
        // headers.append("productCode",productId);
        // headers.append("size",APPCONFIG.imageCutterSizes);
        headers.append("countryAbbrivation", localStorage.getItem('countryAbbrivation'));
        var reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        return this.http.post(url + endpoint, body, reqOpts);
    };
    Api.prototype.postResetPassword = function (endpoint, body, reqOpts) {
        // this.setUrls() /*SET URL According to the user Country */
        var url = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ApiURL_dt;
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);
        return this.http.post(url + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.loginRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.getRa = function (endpoint, reqOpts) {
        return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, reqOpts);
    };
    Api.prototype.userAvailabilityRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, reqOpts, { params: body });
    };
    Api.prototype.getCountryCodeRA = function (endpoint, body, reqOpts) {
        return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, { params: body });
    };
    Api.prototype.getCountryListRA = function (endpoint, body, reqOpts) {
        return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint);
    };
    Api.prototype.registerUserRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.activateRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.postRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/api/v1/' + endpoint, body, reqOpts);
    };
    Api.prototype.postRAWithTokenAndUuid = function (endpoint, body) {
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        headers.append("token", this.getTokenFromLocalStorage());
        headers.append("uuid", localStorage.getItem("uuid"));
        var reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/api/v1/' + endpoint, body, reqOpts);
    };
    Api.prototype.getRA = function (endpoint, body, reqOpts) {
        return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/api/v1/' + endpoint);
    };
    Api.prototype.put = function (endpoint, body, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        headers.append("token", this.getTokenFromLocalStorage());
        reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        // if(this.getCountryCode() === "+92")
        //     return this.http.put(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.put(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.putWithGivenToken = function (endpoint, body, token, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        headers.append("token", token);
        reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        // if(this.getCountryCode() === "+92")
        //     return this.http.put(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.put(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.delete = function (endpoint, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        headers.append("token", this.getTokenFromLocalStorage());
        reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        /*if(this.getCountryCode() === "+92")
            return this.http.delete(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        else
            return this.http.delete(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);*/
        return this.http.delete(this.url + '/' + endpoint, reqOpts);
    };
    Api.prototype.patch = function (endpoint, body, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        /* if(this.getCountryCode() === "+92")
             return this.http.put(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
         else
             return this.http.put(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);*/
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.postADP = function (endpoint, body, reqOpts) {
        if (this.getCountryCode() === "+92")
            return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RTAPI_PK"] + '/' + endpoint, body, reqOpts);
        else
            return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RTAPI_NA"] + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.getADP = function (endpoint, params, reqOpts) {
        if (!reqOpts) {
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]();
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (var k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }
        if (this.getCountryCode() === "+92")
            return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RTAPI_PK"] + '/' + endpoint, reqOpts);
        else
            return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RTAPI_NA"] + '/' + endpoint, reqOpts);
        // return this.http.get(this.adpUrl + '/' + endpoint, reqOpts);
    };
    Api.prototype.getTokenFromLocalStorage = function () {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        //console.log("user",user.authToken);
        if (user) {
            return user.authToken;
        }
        else {
            return "";
        }
    };
    // tokenExpiredLogout(){
    //     this.snackBar.open("You Are Logged Out", "", {
    //         duration: 5000
    //     });
    //     this.router.navigate(['/extra/login']);
    // }
    Api.prototype.gotoLogOut = function () {
        var _this = this;
        // this.api.activateLoader();
        this.get("user/logout").subscribe(function (res) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('countryCode');
            localStorage.removeItem('billingCurrency');
            localStorage.removeItem('dtApiURL');
            localStorage.removeItem('billingApiUrl');
            localStorage.removeItem('imageUploderURL');
            localStorage.removeItem('imageStatsURL');
            localStorage.removeItem('countryAbbrivation');
            localStorage.removeItem("customerType");
            localStorage.removeItem("buyerUuid");
            localStorage.removeItem("supplierUuid");
            localStorage.removeItem("adpCustomer");
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
            _this.router.navigate(['/extra/login']);
            // this.api.hideLoader();
        }, function (err) {
            console.log(err);
            //if (err.status == 401) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('countryCode');
            localStorage.removeItem('billingCurrency');
            localStorage.removeItem('dtApiURL');
            localStorage.removeItem('billingApiUrl');
            localStorage.removeItem('imageUploderURL');
            localStorage.removeItem('imageStatsURL');
            localStorage.removeItem('countryAbbrivation');
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
            _this.router.navigate(['/extra/login']);
            // this.api.hideLoader();
            // }
        });
    };
    Api.prototype.tokenExpiredLogout = function () {
        this.snackBar.open("You Are Logged Out", "", {
            duration: 5000
        });
        this.gotoLogOut();
    };
    Api.prototype.toastMsg = function (msg, action) {
        // msg=msg.toLowerCase();
        // msg=msg.charAt(0).toUpperCase()+msg.slice(1);
        this.snackBar.open(msg, action, {
            duration: 3500
        });
    };
    Api.prototype.showToastSuccess = function (msg) {
        this.toastr.success(msg, 'Success!');
    };
    Api.prototype.showToastError = function (msg) {
        this.toastr.error(msg, 'Oops!');
    };
    Api.prototype.showToastWarning = function (msg) {
        this.toastr.warning(msg, 'Alert!');
    };
    Api.prototype.showToastInfo = function (msg) {
        this.toastr.info(msg);
    };
    Api.prototype.showCustom = function () {
        this.toastr.custom('<span style="color: red">Message in red.</span>', null, { enableHTML: true });
    };
    Api.prototype.getADPCustomerUUID = function () {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (user && user.adpCustomerInfo) {
            return user.adpCustomerInfo.uuid;
        }
        else {
            return "";
        }
    };
    Api.prototype.getADPCustomer = function () {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (user) {
            return user;
        }
        else {
            return "";
        }
    };
    Api.prototype.getADPCustomerBillingCurrency = function () {
        var billingCurrency = localStorage.getItem('billingCurrency');
        if (billingCurrency) {
            return billingCurrency;
        }
        else {
            return "";
        }
    };
    Api.prototype.getADPCustomerTrialDays = function () {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (user && user.adpCustomerInfo) {
            return user.adpCustomerInfo.trialDays;
        }
        else {
            return 0;
        }
    };
    Api.prototype.getADPCustomerType = function () {
        var customerType = localStorage.getItem("customerType");
        if (customerType) {
            return customerType;
        }
        else {
            return "";
        }
    };
    // activateLoader() {
    //   this.layoutService.updatePreloaderState('active');
    // }
    // hideLoader() {
    //   this.layoutService.updatePreloaderState('hide');
    // }
    Api.prototype.downloadSaveFile = function (filename, text) {
        var dat = JSON.parse(text);
        //  var pom = document.createElement('a');
        // pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        // pom.setAttribute('download', filename);
        // if (document.createEvent) {
        //     var event = document.createEvent('MouseEvents');
        //     event.initEvent('click', true, true);
        //     pom.dispatchEvent(event);
        // }
        // else {
        //     pom.click();
        // }
        var options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: false,
            useBom: true
        };
        // var finaldat = dat.data.unshift(dat.fields);
        // const data = ;
        // const headers = text.fields
        new __WEBPACK_IMPORTED_MODULE_9_angular2_csv__["Angular2Csv"](dat.data, filename.split(".")[0], { headers: (dat.fields) });
        // this.csvService.download(dat.data,'My Report');
        //downloadCsv(data, headers);
        //var blob = new Blob([text], {type: "text/csv;charset=utf-8"});
        // var blob = new Blob([text], {type: "text/plain"});
        // var href = window.URL.createObjectURL(blob);
        // var link = document.createElement("a");
        // link.setAttribute("href", href);
        // link.setAttribute("download", filename);
        // document.body.appendChild(link); // Required for FF
        // link.click(); // This will download the data file named "my_data.csv".
        // document.body.removeChild(link);
        // var textEncoder = new TextEncoder('windows-1252', {NONSTANDARD_allowLegacyEncoding: true});
        // //var BOM = "\uFEFF";
        // var csvData = text;
        // var csvDataEncoded = textEncoder.encode([csvData]);
        // var file = new Blob([csvDataEncoded],{type: "text/plain;charset=windows-1252;"});
        // saveAs(file, filename);
    };
    Api.prototype.getUser = function () {
        return JSON.parse(localStorage.getItem("currentUser"));
    };
    Api.prototype.getCountryCode = function () {
        console.log("     -------------------------     ", localStorage.getItem("countryCode"));
        return localStorage.getItem("countryCode");
    };
    Api.prototype.downloadSaveFileCSV = function (filename, text) {
        var pom = document.createElement('a');
        pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        pom.setAttribute('download', filename);
        if (document.createEvent) {
            var event = document.createEvent('MouseEvents');
            event.initEvent('click', true, true);
            pom.dispatchEvent(event);
        }
        else {
            pom.click();
        }
        document.body.removeChild(pom);
    };
    // Should add token for URL decision making
    Api.prototype.shouldToAddToken = function (endpoint) {
        var urlsNotToAddToken = [
            "recoverPassword"
        ];
        for (var _i = 0, urlsNotToAddToken_1 = urlsNotToAddToken; _i < urlsNotToAddToken_1.length; _i++) {
            var endP = urlsNotToAddToken_1[_i];
            // String.prototype.indexOf returns the position of the
            // string in the other string. If not found, it will return -1
            if (endpoint.indexOf("recoverPassword") !== -1) {
                return false;
            }
        }
        return true;
        // if(endpoint.indexOf("recoverPassword") !== -1){
        //   return false;
        // }else{
        //   return true;
        // }
    };
    Api = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_4__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["D" /* MatSnackBar */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */],
            __WEBPACK_IMPORTED_MODULE_6_ng2_toastr__["ToastsManager"],
            __WEBPACK_IMPORTED_MODULE_10_angular2_json2csv__["CsvService"]
            //private vcr:ViewContainerRef
            // ,private layoutService:LayoutService
        ])
    ], Api);
    return Api;
}());

var ApplicationVariables = { currentShipmentNoticePage: 0, currentShipmentNoticeSearchQuery: "", currentShipmentNoticeOffset: 0 };


/***/ })

},[706]);


// WEBPACK FOOTER //
// js/main.79f6aefcd7956ea68342.js